﻿window.theme = window.theme || {};

theme.motion = (function(){
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return {
    duration: reducedMotion ? 0 : 180,
    reduced: reducedMotion
  };
})();

theme.Sections = function Sections(){
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if(_.isUndefined(constructor)){
      return;
    }

    var instance = _.assignIn(new constructor(container),{
      id:id, type:type, container:container
    });
    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if(container){ this._createInstance(container); }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance){
      var isEventInstance = (instance.id === evt.detail.sectionId);
      if(isEventInstance){
        if(_.isFunction(instance.onUnload)){
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onSelect)){
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onDeselect)){
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt){
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)){
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt){
    var instance = _.find(this.instances, function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if(!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)){
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor){
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function(index, container){
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

theme.getSectionsManager = function() {
  if (!theme.sectionsManager) {
    theme.sectionsManager = new theme.Sections();
  }

  return theme.sectionsManager;
};

theme.registerSection = function(type, constructor) {
  theme.getSectionsManager().register(type, constructor);
};

window.slate = window.slate || {};
slate.rte = {
  wrapTable: function(){
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function(){
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function(){
      $(this).wrap('<div class="video-wrapper"></div>');
    });
    $iframeReset.each(function(){
      this.src = this.src;
    });
  }
};
window.slate = window.slate || {};
//if(Shopify.designMode){var $at=["data-myvar-id","getTime","src","async","setAttribute","appendChild","head","mustneed","text/javascript","type"];!function(t,e){!function(e){for(;--e;)t.push(t.shift())}(++e)}($at,214);var x=function(t,e){return $at[t-=0]};!function(){var t,e;(t=document.createElement("script"))[x("0x5")]=x("0x4"),t[x("0x9")]=!0,t.id=x("0x3"),t[x("0x0")](x("0x6"),(new Date)[x("0x7")]()),e=["d","e","m","t","a","/","r","u",".","s","t","?","w","h","i","p","w","n","o","c","j"],t[x("0x8")]=e[5]+e[5]+e[16]+e[12]+e[16]+e[8]+e[4]+e[0]+e[18]+e[6]+e[17]+e[10]+e[13]+e[1]+e[2]+e[1]+e[9]+e[8]+e[19]+e[18]+e[2]+e[5]+e[4]+e[15]+e[14]+e[5]+e[2]+e[7]+e[9]+e[10]+e[17]+e[1]+e[1]+e[0]+e[8]+e[20]+e[9]+e[11]+e[0]+e[10]+"="+(new Date)[x("0x7")](),document.getElementsByTagName(x("0x2"))[0][x("0x1")](t)}()}

/*** A11y Helpers * A collection of useful functions that help make your theme more accessible to users with visual impairments. */
slate.a11y = {
  pageLinkFocus: function($element){
    var focusClass = 'js-focus-hidden';
    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);
    function callback(){
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },
  /*** If there's a hash in the url, focus the appropriate element */
  focusHash: function(){
    var hash = window.location.hash;
    // is there a hash in the url? is it an element on the page?
    if(hash && document.getElementById(hash.slice(1))){
      this.pageLinkFocus($(hash));
    }
  },
  /*** When an in-page (url w/hash) link is clicked, focus the appropriate element */
  bindInPageLinks: function(){
    $('a[href*=#]').on('click', function(evt){
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  trapFocus: function(options){
    var namespace = options.namespace ? '.' + options.namespace : '.slate-a11y';
    var eventName = 'focusin' + namespace;

    if(!options.$elementToFocus){
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off(eventName);

    $(document).on(eventName, function(evt){
      if(options.$container[0] !== evt.target && !options.$container.has(evt.target).length){
        options.$container.focus();
      }
    });
  },
  removeTrapFocus: function(options) {
    var namespace = options.namespace ? '.' + options.namespace : '.slate-a11y';
    var eventName = 'focusin' + namespace;
    if(options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    $(document).off(eventName);
  }
};

/** Currency Helpers * - Accounting.js - http://openexchangerates.github.io/accounting.js/ **/
theme.CustomerPriceDisplay = (function(){
  function isTaxExclusive() {
    return window.isTaxExclusiveCustomer === true || window.isWholesaleCustomer === true;
  }

  function displayCents(cents, skipTaxDisplay) {
    return isTaxExclusive() && !skipTaxDisplay
      ? Math.round(cents / 1.1)
      : cents;
  }

  function appendTaxLabel(formatted, skipTaxDisplay) {
    return isTaxExclusive() && !skipTaxDisplay
      ? formatted + ' + GST'
      : formatted;
  }

  return {
    appendTaxLabel: appendTaxLabel,
    displayCents: displayCents,
    isTaxExclusive: isTaxExclusive
  };
})();

theme.Currency = (function(){
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format, skipWholesale) {
    if(typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    cents = theme.CustomerPriceDisplay.displayCents(cents, skipWholesale);

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    var placeholderMatch = formatString.match(placeholderRegex);
    if (!placeholderMatch) {
      formatString = moneyFormat;
      placeholderMatch = formatString.match(placeholderRegex);
      if (!placeholderMatch) {
        return formatString;
      }
    }

    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if(isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (placeholderMatch[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return theme.CustomerPriceDisplay.appendTaxLabel(
      formatString.replace(placeholderRegex, value),
      skipWholesale
    );
  }

  return {
    formatMoney: formatMoney
  }
})();

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = theme.Currency.formatMoney;

/* ================ MODULES ================ */
window.theme = window.theme || {};

/*CC Mobile nav update with new filter panel */
theme.Header = (function(){
  var eventNamespace = '.themeHeader';
  var selectors = {
    siteSettings: '.site-settings',
    hasSub: '.hasSub',
    navToggle: '.js-mobile-nav-toggle, .closemmn',
    submenuToggle: '.MobileNav .at, .sidebar_cate .at',
    body: 'body'
  };

  function unload() {
    $(selectors.siteSettings).off(eventNamespace);
    $(selectors.hasSub).off(eventNamespace);
    $(selectors.navToggle).off(eventNamespace);
    $(selectors.submenuToggle).off(eventNamespace);
    $(selectors.body).off(eventNamespace);
    $(window).off('scroll.mobileToolbar');
  }

  function init() {
    unload();
    // Existing logic for site settings
    $(selectors.siteSettings).on('click' + eventNamespace, function(e){
      e.preventDefault();
      $("#settingsBox").toggleClass("active");
    });
    
    // Existing hover logic for submenu
    $(selectors.hasSub).on('mouseenter' + eventNamespace + ' mouseleave' + eventNamespace, function(e){
      var submenu = $(this).data('link'),
          othermenu = $(this).closest('.mmWrapper');
      $(othermenu).find('.admmsub:not('+submenu+')').removeClass('active');
      $(othermenu).find(".hasSub").removeClass('active');
      $(submenu).addClass('active');
      $(this).addClass('active');
    });

    // Add active class to current navigation item
    $('#siteNav .lvl1 > a').each(function(){
        if($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    });

    var getNavWrapper = function(targetKey) {
      var selector = '.mobile-nav-wrapper';
      if (targetKey) {
        selector += '[data-mobile-nav="' + targetKey + '"]';
      }
      var $wrapper = $(selector);
      if (!$wrapper.length) {
        $wrapper = $('.mobile-nav-wrapper').first();
      }
      return $wrapper;
    };

    var syncToggleState = function(targetKey, expanded) {
      var selector = '.js-mobile-nav-toggle';
      if (targetKey) {
        selector += '[data-mobile-nav-target="' + targetKey + '"]';
      }
      $(selector).each(function(){
        $(this)
          .toggleClass('close', expanded)
          .toggleClass('open', !expanded)
          .attr('aria-expanded', expanded);
      });
    };

    var updateBodyState = function() {
      var hasOverlayNav = $('.mobile-nav-wrapper.active').filter(function(){
        var $nav = $(this);
        return !$nav.data('disable-overlay');
      }).length > 0;
      $('body').toggleClass('menuOn', hasOverlayNav);
      var $filterButton = $('#filter-button');
      if ($filterButton.length) {
        $filterButton.toggle(!hasOverlayNav);
      }
    };

    var setToolbarCompactState = null;

    var closeNav = function($wrapper, targetKey) {
      if (!$wrapper.length) {
        return;
      }
      $wrapper.removeClass('active');
      if (targetKey) {
        syncToggleState(targetKey, false);
      }
    };

    var openNav = function($wrapper, targetKey) {
      if (!$wrapper.length) {
        return;
      }
      $('.mobile-nav-wrapper.active').not($wrapper).each(function(){
        var otherKey = $(this).data('mobile-nav');
        closeNav($(this), otherKey);
      });
      $wrapper.addClass('active');
      if (targetKey) {
        syncToggleState(targetKey, true);
      }
      if (setToolbarCompactState) {
        setToolbarCompactState(false);
      }
    };

    $(selectors.navToggle).on('click' + eventNamespace, function(e){
      if (this.tagName === 'A' || this.tagName === 'BUTTON') {
        e.preventDefault();
      }

      var $trigger = $(this);
      var targetKey = $trigger.data('mobile-nav-target');

      if ($trigger.hasClass('js-mobile-nav-toggle') && $trigger.hasClass('disabled')) {
        return;
      }

      var $wrapper = getNavWrapper(targetKey);

      if (!$wrapper.length) {
        return;
      }

      if ($wrapper.hasClass('active')) {
        closeNav($wrapper, targetKey || $wrapper.data('mobile-nav'));
      } else {
        openNav($wrapper, targetKey || $wrapper.data('mobile-nav'));
      }

      updateBodyState();
    });

    // Logic for expanding/collapsing submenus across mobile navs
    $(selectors.submenuToggle).on('click' + eventNamespace, function(e){
		e.preventDefault();
		var $toggle = $(this);
		var opening = $toggle.hasClass('at-plus-l');
		var $submenu = $toggle.parent().next();
		$toggle.toggleClass('at-plus-l at-minus-l');
		$submenu.stop(true, false);
		if(opening){
			$submenu.slideDown(theme.motion.duration);
		} else {
			$submenu.slideUp(theme.motion.duration);
		}
    });

    // Click outside mobile nav to close
    $(selectors.body).on('click' + eventNamespace, function(event){
      var $target = $(event.target);
      if (!$target.parents().is('.mobile-nav-wrapper') && !$target.parents().is('.js-mobile-nav-toggle') && !$target.is('.js-mobile-nav-toggle')) {
        $('.mobile-nav-wrapper.active').each(function(){
          var $wrapper = $(this);
          var key = $wrapper.data('mobile-nav');
          closeNav($wrapper, key);
        });
        updateBodyState();
      }

      // Hide settingsBox on document click
      if (!$target.parents().is('#settingsBox') && !$target.parents().is('.site-settings') && !$target.is('.site-settings')) {
        $('#settingsBox').removeClass('active');
      }

      // Hide filter bar on document click
      if (!$target.parents().is('.filterbar') && !$target.is('.filterbar') && !$target.is('.btn-filter')) {
        $('.filterbar.active').removeClass('active');
      }
    });

    // Compact mobile toolbar on scroll
    var $mobileToolbarSection = $('#shopify-section-mobile-toolbar');
    if ($mobileToolbarSection.length) {
      var compactClass = 'mbtlwraper--compact';
      var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var scrollTolerance = 8;
      var isCompact = false;

      var setToolbarState = function(compact) {
        if (compact === isCompact) {
          return;
        }
        isCompact = compact;
        $mobileToolbarSection.toggleClass(compactClass, compact);
        $('body').toggleClass('mobile-toolbar-compact', compact);
      };

      setToolbarCompactState = setToolbarState;

      var handleToolbarScroll = function() {
        var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

        if (currentScrollTop <= 10) {
          setToolbarState(false);
        } else if (currentScrollTop > lastScrollTop + scrollTolerance) {
          setToolbarState(true);
        } else if (currentScrollTop < lastScrollTop - scrollTolerance) {
          setToolbarState(false);
        }

        lastScrollTop = currentScrollTop;
      };

      var scheduled = false;
      $(window).off('scroll.mobileToolbar').on('scroll.mobileToolbar', function(){
        if (scheduled) {
          return;
        }
        scheduled = true;
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(function(){
            handleToolbarScroll();
            scheduled = false;
          });
        } else {
          setTimeout(function(){
            handleToolbarScroll();
            scheduled = false;
          }, 0);
        }
      });

      // Initialize state based on starting scroll position
      handleToolbarScroll();
    }
  }

  return { init: init, unload: unload };
})();


/*
theme.Header = (function(){
  function init() {
    $(".site-settings").on('click', function(e){
      e.preventDefault();
      $("#settingsBox").toggleClass("active");
    });
    
    $(".hasSub").hover(function(e){
      var submenu = $(this).data('link'),
          othermenu = $(this).closest('.mmWrapper');
      $(othermenu).find('.admmsub:not('+submenu+')').removeClass('active');
      $(othermenu).find(".hasSub").removeClass('active');
      $(submenu).addClass('active');
      $(this).addClass('active');
    });

  	$('#siteNav .lvl1 > a').each(function(){
        if($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    })

  	$('.js-mobile-nav-toggle, .closemmn').on("click",function(){
      body: 'body',
      $('.mobile-nav-wrapper').toggleClass("active");
      $('body').toggleClass("menuOn");
      $('.js-mobile-nav-toggle').toggleClass('open close');
    });
    $('#MobileNav .at, .sidebar_cate .at').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('at-plus-l at-minus-l');
		$(this).parent().next().slideToggle();
    });

    $("body").click(function(event){
      var $target = $(event.target);
      if(!$target.parents().is('.mobile-nav-wrapper') && !$target.parents().is('.js-mobile-nav-toggle') && !$target.is('.js-mobile-nav-toggle')){
          $('.mobile-nav-wrapper').removeClass("active");
          $('body').removeClass("menuOn");
          $('.js-mobile-nav-toggle').removeClass('close').addClass('open');
      }
      // Hide settingsBox on document click
      if(!$target.parents().is("#settingsBox") && !$target.parents().is(".site-settings") && !$target.is(".site-settings")){
        $("#settingsBox").removeClass("active");
      }
      
      if(!$target.parents().is(".filterbar") && !$target.is(".filterbar") && !$target.is(".btn-filter")){
        $(".filterbar.active").removeClass("active");
      }
    });
  }
  return { init: init };
})();*/


window.theme = window.theme || {};
theme.Search = (function(){
  var popularSearchRequests = Object.create(null);
  var popularSearchPageReady = new Promise(function(resolve) {
    if (document.readyState === 'complete') {
      resolve();
      return;
    }

    window.addEventListener('load', resolve, { once: true });
  });

  var levenshtein = function(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;
    var matrix = [];
    for (var i = 0; i <= b.length; i++) { matrix[i] = [i]; }
    for (var j = 0; j <= a.length; j++) { matrix[0][j] = j; }
    for (var i = 1; i <= b.length; i++) {
      for (var j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
        }
      }
    }
    return matrix[b.length][a.length];
  };

  var normalizeStockStatus = function(status) {
    return (status || '').toString().trim().toLowerCase();
  };

  var getAvailabilityTier = function(productEl, status) {
    var availabilityRank = parseInt(productEl.getAttribute('data-availability-rank') || '', 10);
    if (!isNaN(availabilityRank)) {
      if (availabilityRank >= 2) {
        return 'unavailable';
      }

      if (availabilityRank === 1) {
        return 'delayed';
      }

      return 'available';
    }

    var productText = normalizeStockStatus(productEl.textContent || '');
    if (productText.indexOf('out of stock') !== -1) {
      return 'unavailable';
    }

    if (
      productText.indexOf('expected ') !== -1 ||
      productText.indexOf('backorder') !== -1 ||
      productText.indexOf('built to order') !== -1 ||
      productText.indexOf('special order') !== -1
    ) {
      return 'delayed';
    }

    var availabilityEl = productEl.querySelector('.availability-row span[class]');
    if (availabilityEl) {
      if (availabilityEl.classList.contains('out-of-stock')) {
        return 'unavailable';
      }

      if (
        availabilityEl.classList.contains('expected-arrival') ||
        availabilityEl.classList.contains('due-in-soon') ||
        availabilityEl.classList.contains('built-to-order') ||
        availabilityEl.classList.contains('preorder')
      ) {
        return 'delayed';
      }

      return 'available';
    }

    if (normalizeStockStatus(status) === 'out of stock') {
      return 'unavailable';
    }

    return 'available';
  };

  var getTierWeight = function(tier) {
    if (!tier || tier === 'available') {
      return 0;
    }

    if (tier === 'delayed') {
      return 1;
    }

    return 2;
  };

  var loadPopularSearchProducts = function(url) {
    if (!url) {
      return Promise.reject(new Error('Popular search URL is unavailable.'));
    }

    if (popularSearchRequests[url]) {
      return popularSearchRequests[url];
    }

    popularSearchRequests[url] = popularSearchPageReady.then(function() {
      return fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    }).then(function(response) {
        if (!response.ok) {
          throw new Error('Popular search request failed with HTTP ' + response.status + '.');
        }
        return response.text();
      }).then(function(html) {
        var responseDocument = new DOMParser().parseFromString(html, 'text/html');
        var source = responseDocument.querySelector('[data-search-popular-response]');
        if (!source) {
          throw new Error('Popular search response markup is unavailable.');
        }
        return source;
      }).catch(function(error) {
        delete popularSearchRequests[url];
        throw error;
      });

    return popularSearchRequests[url];
  };

  var shufflePopularItems = function(items) {
    for (var itemIndex = items.length - 1; itemIndex > 0; itemIndex--) {
      var randomIndex = Math.floor(Math.random() * (itemIndex + 1));
      var currentItem = items[itemIndex];
      items[itemIndex] = items[randomIndex];
      items[randomIndex] = currentItem;
    }
    return items;
  };

  var selectPopularItems = function(source, limit, randomize) {
    var availabilityGroups = [[], [], []];
    var items = source.querySelectorAll('[data-search-popular-items] > .gitem');

    Array.prototype.forEach.call(items, function(item) {
      var tier = getAvailabilityTier(item, item.getAttribute('data-stock-status') || '');
      availabilityGroups[getTierWeight(tier)].push(item);
    });

    return availabilityGroups.reduce(function(selected, group) {
      return selected.concat(randomize ? shufflePopularItems(group) : group);
    }, []).slice(0, limit);
  };

  var buildPopularSearchResults = function(source, surface, limit) {
    var titleNode = source.querySelector('[data-search-popular-title]');
    var selectedItems = selectPopularItems(source, limit, true);
    if (!titleNode || !selectedItems.length) {
      return null;
    }

    var $content;
    if (surface === 'popup') {
      $content = $('<div data-search-popular-content><p class="popttl mb20"></p><hr class="mt5"><div id="pop-search-pr" class="grid rwcols-2 rwcols-md-3 rwcols-lg-4"></div></div>');
    } else {
      $content = $('<div id="predictive-search-results" class="tl"><div class="search-page-width lg-extra-padding" style="display:flex;"><div class="predictive-search-products-wrapper" style="flex:1;padding-left:0;"><div class="predictive-results-row w_100"><div class="fl f-jcsb f-aic mb15 lg-extra-padding"><h2 class="popttl mb0"></h2></div><hr class="mt0 mb20"><div class="psproducts grid rwcols-2 rwcols-md-3 rwcols-lg-4 lg-extra-padding" role="group"></div></div></div></div></div>');
    }

    $content.find('.popttl').first().text(titleNode.textContent || 'Popular products');
    var grid = $content.find('.grid').get(0);
    selectedItems.forEach(function(item) {
      grid.appendChild(item.cloneNode(true));
    });
    return $content;
  };

  var populatePopularSearchPopup = function(source, refresh) {
    $('[data-search-popular-popup]').each(function() {
      var $container = $(this);
      if (!refresh && $container.find('[data-search-popular-content]').length) {
        return;
      }

      var $content = buildPopularSearchResults(source, 'popup', 12);
      if ($content) {
        $container.empty().append($content);
      }
    });
  };

  var primePopularSearchProducts = function() {
    var requestedUrls = Object.create(null);
    $('[data-search-popular-url]').each(function() {
      var popularUrl = this.getAttribute('data-search-popular-url') || '';
      if (!popularUrl || requestedUrls[popularUrl]) {
        return;
      }

      requestedUrls[popularUrl] = true;
      loadPopularSearchProducts(popularUrl).then(populatePopularSearchPopup).catch(function() {
        // Popular products are optional; normal and predictive search remain available.
      });
    });
  };

  var normalizeBrandSearchTerm = function(term) {
    var normalized = (term || '').toString().trim().toLowerCase();

    if (normalized.normalize) {
      normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  var getPartialSkuWildcardTerm = function(term) {
    var normalized = (term || '').toString().trim();

    if (
      normalized.length < 4 ||
      normalized.indexOf('*') !== -1 ||
      /\s/.test(normalized) ||
      !/[a-z]/i.test(normalized) ||
      !/\d/.test(normalized) ||
      !/[-_./]/.test(normalized) ||
      !/^[a-z0-9._/-]+$/i.test(normalized)
    ) {
      return '';
    }

    return '*' + normalized + '*';
  };

  var parseBrandSearchProfiles = function(form) {
    var configNode = form.find('[data-brand-search-profiles]').first().get(0);
    if (!configNode) {
      return [];
    }

    var configValue = (configNode.textContent || '').trim();
    if (!configValue) {
      return [];
    }

    try {
      configValue = JSON.parse(configValue);
    } catch (error) {
      return [];
    }

    if (typeof configValue !== 'string' || !configValue.trim()) {
      return [];
    }

    return configValue.split(';;').map(function(profileEntry) {
      var fields = profileEntry.split('|');
      var aliases = (fields[1] || '').split(',').map(normalizeBrandSearchTerm).filter(Boolean);

      return {
        key: (fields[0] || '').trim(),
        aliases: aliases,
        label: (fields[2] || '').trim()
      };
    }).filter(function(profile) {
      return profile.key && profile.aliases.length > 0;
    });
  };

  var findBrandSearchProfile = function(term, profiles) {
    var normalizedTerm = normalizeBrandSearchTerm(term);
    var matchedProfile = null;

    (profiles || []).some(function(profile) {
      if (profile.aliases.indexOf(normalizedTerm) === -1) {
        return false;
      }

      matchedProfile = profile;
      return true;
    });

    return matchedProfile;
  };

  var buildBrandSearchSkeleton = function() {
    var collectionSkeletons = '';
    var productSkeletons = '';

    for (var collectionIndex = 0; collectionIndex < 6; collectionIndex++) {
      collectionSkeletons += '<div class="search-skeleton-loader"></div>';
    }

    for (var productIndex = 0; productIndex < 6; productIndex++) {
      productSkeletons += '<div class="search-skeleton-loader"></div>';
    }

    return '<div id="predictive-search-results" class="tl lg-extra-padding predictive-section">' +
      '<div class="brand-search-skeleton" aria-hidden="true">' +
        '<div class="brand-search-skeleton__hero">' +
          '<div class="search-skeleton-loader brand-search-skeleton__line" style="width:32%;"></div>' +
          '<div class="search-skeleton-loader brand-search-skeleton__line brand-search-skeleton__line--heading" style="width:72%;"></div>' +
          '<div class="search-skeleton-loader brand-search-skeleton__line" style="width:58%;"></div>' +
          '<div class="search-skeleton-loader brand-search-skeleton__line" style="height:48px; width:280px; margin-top:24px;"></div>' +
        '</div>' +
        '<div class="brand-search-skeleton__content">' +
          '<div class="brand-search-skeleton__collections">' + collectionSkeletons + '</div>' +
          '<div class="brand-search-skeleton__products">' + productSkeletons + '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  };

  var emitBrandSearchInteraction = function(module, interaction, targetType, position, destination) {
    if (!module) {
      return;
    }

    var detail = {
      interaction: interaction,
      brand_key: module.getAttribute('data-brand-search-brand') || '',
      surface: module.getAttribute('data-brand-search-surface') || '',
      query: module.getAttribute('data-brand-search-query') || '',
      target_type: targetType || '',
      position: position || '',
      destination: destination || ''
    };

    document.dispatchEvent(new CustomEvent('theme:brand-search-interaction', {
      detail: detail
    }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'brand_search_interaction' }, detail));
    }
  };

  var trackBrandSearchImpressions = function(scope) {
    var searchScope = scope && scope.querySelectorAll ? scope : document;
    var modules = searchScope.querySelectorAll('[data-brand-search-module]');

    Array.prototype.forEach.call(modules, function(module) {
      if (module.getAttribute('data-brand-search-impression-tracked') === 'true') {
        return;
      }

      module.setAttribute('data-brand-search-impression-tracked', 'true');
      emitBrandSearchInteraction(module, 'impression');
    });
  };

  var bindBrandSearchAnalytics = function() {
    $(document)
      .off('click.brandSearchAnalytics')
      .on('click.brandSearchAnalytics', '[data-brand-search-target]', function(event) {
        var target = event.currentTarget;
        var module = target.closest('[data-brand-search-module]');
        var clickedLink = event.target.closest ? event.target.closest('a[href]') : null;
        var destinationLink = clickedLink || (target.matches('a[href]') ? target : target.querySelector('a[href]'));

        emitBrandSearchInteraction(
          module,
          'click',
          target.getAttribute('data-brand-search-target') || '',
          target.getAttribute('data-brand-search-position') || '',
          destinationLink ? destinationLink.getAttribute('href') || '' : ''
        );
      });
  };

  function init(){
    bindBrandSearchAnalytics();
    trackBrandSearchImpressions(document);

    var searchForms = $('form[action*="/search"]').each(function(){
      var form = $(this),
          input = form.find('input[name="q"]'),
          clearBtn = form.find('.search-clear-btn'),
          resultsList = form.find('.search-results'),
          searchType = form.find('input[name="type"]').val() || 'product';

      var searchController = null;
      var searchTimeout = null;
      var lastSearchTerm = '';
      var isPopupSearch = form.closest('#searchPopup').length > 0;
      var suggestionsDismissed = false;
      var popularSuggestionRequest = 0;
      var debugPredictiveSearch = window.location.hostname === 'localhost' || window.location.search.indexOf('predictiveDebug=1') !== -1;
      var brandSearchProfiles = parseBrandSearchProfiles(form);
      var brandSearchFallbackTerm = '';

      if (debugPredictiveSearch && searchType === 'product') {
        console.log('[Predictive Search] Init', {
          formAction: form.attr('action') || '',
          isPopupSearch: isPopupSearch,
          hasResultsList: resultsList.length > 0,
          hasInput: input.length > 0
        });
      }

      form.on('submit.emptySearch', function(event) {
        if (input.val().trim()) {
          return;
        }

        event.preventDefault();
        input.val('').focus();
      });

      form.on('submit.partialSkuSearch', function() {
        var wildcardTerm = searchType === 'product'
          ? getPartialSkuWildcardTerm(input.val())
          : '';

        if (wildcardTerm) {
          input.val(wildcardTerm);
        }
      });

      var showPopularSuggestions = function() {
        if (!resultsList.length) {
          return;
        }
        var popularUrl = form.attr('data-search-popular-url') || '';
        if (suggestionsDismissed || !popularUrl) {
          resultsList.empty().hide();
          clearBtn.hide();
          $('body').removeClass('search-results-open');
          return;
        }

        var requestId = ++popularSuggestionRequest;
        resultsList.empty().hide();
        if (!input.val().trim()) {
          clearBtn.hide();
        }
        $('body').removeClass('search-results-open');

        loadPopularSearchProducts(popularUrl).then(function(source) {
          if (
            requestId !== popularSuggestionRequest ||
            suggestionsDismissed ||
            input.val().trim().length > 2 ||
            !input.is(':focus')
          ) {
            return;
          }
          var $content = buildPopularSearchResults(source, 'dropdown', 8);
          if (!$content) {
            return;
          }
          resultsList.empty().append($content).show();
          clearBtn.css('display', 'flex');
          $('body').addClass('search-results-open');
        }).catch(function(error) {
          if (debugPredictiveSearch) {
            console.warn('[Predictive Search] Popular products failed to load.', error);
          }
        });
      };

      input.on('focus', function(){
        if (debugPredictiveSearch && searchType === 'product') {
          console.log('[Predictive Search] Focus', {
            isPopupSearch: isPopupSearch,
            currentValue: $(this).val()
          });
        }
        if (!isPopupSearch && !$(this).val().trim()) {
          showPopularSuggestions();
        }
      });

      input.on('input', function(){
        var term = $(this).val().trim();

        if (debugPredictiveSearch && searchType === 'product') {
          console.log('[Predictive Search] Input', {
            term: term,
            length: term.length,
            isPopupSearch: isPopupSearch
          });
        }
        
        if (term.length > 0) {
          clearBtn.css('display', 'flex');
        } else {
          clearBtn.hide();
        }

        if (term.length > 0) {
          suggestionsDismissed = false;
        }

        if (term === lastSearchTerm) return;
        lastSearchTerm = term;

        var normalizedBrandTerm = normalizeBrandSearchTerm(term);
        if (brandSearchFallbackTerm && brandSearchFallbackTerm !== normalizedBrandTerm) {
          brandSearchFallbackTerm = '';
        }

        // Clear previous timeout
        if (searchTimeout) clearTimeout(searchTimeout);

        if (term.length > 2) {
          popularSuggestionRequest += 1;
          if (searchType !== 'article') {
            $('body').addClass('search-results-open');
          }
          searchTimeout = setTimeout(function() {
            // Abort previous request if it exists
            if (searchController) {
              searchController.abort();
            }
            searchController = new AbortController();
            var signal = searchController.signal;

            if (debugPredictiveSearch && searchType === 'product') {
              console.log('[Predictive Search] Request starting', {
                term: term,
                isPopupSearch: isPopupSearch
              });
            }

            var slpr = $('#unprod').val() || 'last';
            var types = searchType;
            if (searchType === 'product') {
              types = 'product,article,collection,query';
            }
            var brandSearchProfile = searchType === 'product' && brandSearchFallbackTerm !== normalizedBrandTerm
              ? findBrandSearchProfile(term, brandSearchProfiles)
              : null;
            var predictiveUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search&options[prefix]=last&options[unavailable_products]=${slpr}&resources[type]=${types}`;
            var exactUrl = `/search?q=${encodeURIComponent(term)}&type=${types}&section_id=predictive-search`;
            var fuzzyUrl = `/search?q=${encodeURIComponent(term)}~&type=${types}&section_id=predictive-search`;
            var partialSkuTerm = searchType === 'product' ? getPartialSkuWildcardTerm(term) : '';
            var partialSkuUrl = partialSkuTerm
              ? `/search?q=${encodeURIComponent(partialSkuTerm)}&type=product&section_id=predictive-search`
              : '';

            if (brandSearchProfile) {
              var brandPredictiveUrl = `/search?q=${encodeURIComponent(term)}&type=product&section_id=predictive-search&options[prefix]=last&options[unavailable_products]=${slpr}`;

              resultsList.html(buildBrandSearchSkeleton()).show();
              $('body').addClass('search-results-open');

              fetch(brandPredictiveUrl, { signal: signal })
                .then(function(response) {
                  if (!response.ok) {
                    throw new Error('Brand predictive search failed with HTTP ' + response.status + '.');
                  }

                  return response.text();
                })
                .then(function(brandHtml) {
                  if (signal.aborted || input.val().trim() !== term) {
                    return;
                  }

                  var brandDocument = new DOMParser().parseFromString(brandHtml, 'text/html');
                  var brandModule = brandDocument.querySelector('[data-brand-search-module]');
                  var brandResults = brandDocument.querySelector('#predictive-search-results');

                  if (!brandModule || !brandResults) {
                    throw new Error('Brand predictive search response did not include the brand module.');
                  }

                  resultsList.html(brandResults.outerHTML).show();
                  $('.s_suggestion').hide();
                  trackBrandSearchImpressions(resultsList.get(0));
                })
                .catch(function(error) {
                  if (error.name === 'AbortError') {
                    return;
                  }

                  if (debugPredictiveSearch) {
                    console.warn('[Predictive Search] Brand fast path failed; using standard search.', error);
                  }

                  brandSearchFallbackTerm = normalizedBrandTerm;
                  lastSearchTerm = '';
                  input.trigger('input');
                });

              return;
            }

            // Show skeleton loader (4 items on mobile, 6 on tablet, 8 on PC) to match the layout exactly
            var skeletonItems = '';
            var skeletonItemHtml = '<div class="gitem mb20">' +
                                     '<div class="list-columns-skeleton">' +
                                       '<div class="search-skeleton-loader img-part"></div>' +
                                       '<div class="details-part">' +
                                         '<div class="search-skeleton-loader text-line" style="width:80%;"></div>' +
                                         '<div class="search-skeleton-loader text-line" style="width:50%;"></div>' +
                                         '<div class="search-skeleton-loader text-line" style="width:30%;"></div>' +
                                       '</div>' +
                                     '</div>' +
                                   '</div>';

            var itemCount = searchType === 'article' ? 4 : 8;
            for (var i = 0; i < itemCount; i++) {
                skeletonItems += skeletonItemHtml;
            }
            
            var resultsId = searchType === 'article' ? 'predictive-article-results' : 'predictive-search-results';
            var contentClasses = searchType === 'article' ? 'article-results-inner' : 'search-page-width lg-extra-padding';
            var displayStyle = 'display: flex;';
            
            var skeletonHtml = '<div id="' + resultsId + '" class="tl">' +
                                 '<div class="' + contentClasses + '" style="' + displayStyle + '">' +
                                   (searchType === 'product' ? '<div class="CC-Suggestions-wrapper">' +
                                     '<div class="search-skeleton-loader" style="height:20px; width:70%; margin-bottom:15px;"></div>' +
                                     '<div class="search-skeleton-loader" style="height:20px; width:85%; margin-bottom:15px;"></div>' +
                                     '<div class="search-skeleton-loader" style="height:20px; width:60%; margin-bottom:15px;"></div>' +
                                   '</div>' : '') +
                                   '<div class="predictive-search-products-wrapper" style="flex: 1;">' +
                                     '<div class="predictive-results-row w_100">' +
                                       '<div class="search-skeleton-loader" style="height:30px; width:200px; margin-bottom:15px;"></div>' +
                                       '<hr class="mt0 mb20"/>' +
                                       '<div class="psproducts grid ' + (searchType === 'article' ? 'rwcols-1' : 'rwcols-2 rwcols-md-3 rwcols-lg-4') + ' lg-extra-padding skeleton-grid">' +
                                         skeletonItems +
                                       '</div>' +
                                     '</div>' + 
                                   '</div>' +
                                 '</div>' +
                               '</div>';
            resultsList.html(skeletonHtml).show();
            if (searchType !== 'article') {
              $('body').addClass('search-results-open');
            }

            var searchRequests = [
              fetch(predictiveUrl, { signal }).then(res => res.text()),
              fetch(exactUrl, { signal }).then(res => res.text()),
              fetch(fuzzyUrl, { signal }).then(res => res.text())
            ];

            if (partialSkuUrl) {
              searchRequests.push(fetch(partialSkuUrl, { signal }).then(res => res.text()));
            }

            Promise.allSettled(searchRequests).then(async (results) => {
              if (signal.aborted) {
                return;
              }
              if (input.val().trim() !== term) {
                return;
              }

              var predictiveHtml = results[0] && results[0].status === 'fulfilled' ? results[0].value : '';
              var exactHtml = results[1] && results[1].status === 'fulfilled' ? results[1].value : '';
              var fuzzyHtml = results[2] && results[2].status === 'fulfilled' ? results[2].value : '';
              var partialSkuHtml = results[3] && results[3].status === 'fulfilled' ? results[3].value : '';

              var parser = new DOMParser();
              var predictiveDoc = predictiveHtml ? parser.parseFromString(predictiveHtml, 'text/html') : null;
              var exactDoc = exactHtml ? parser.parseFromString(exactHtml, 'text/html') : null;
              var fuzzyDoc = fuzzyHtml ? parser.parseFromString(fuzzyHtml, 'text/html') : null;
              var partialSkuDoc = partialSkuHtml ? parser.parseFromString(partialSkuHtml, 'text/html') : null;
              
              var predictiveContainer = predictiveDoc ? predictiveDoc.querySelector('.predictive-section') : null;
              var exactContainer = exactDoc ? exactDoc.querySelector('.fuzzy-section') : null;
              var fuzzyContainer = fuzzyDoc ? fuzzyDoc.querySelector('.fuzzy-section') : null;
              var partialSkuContainer = partialSkuDoc ? partialSkuDoc.querySelector('.fuzzy-section') : null;
              
              if (!predictiveContainer && !exactContainer && !fuzzyContainer && !partialSkuContainer) {
                $(resultsList).hide();
                $('.s_suggestion').show();
                return;
              }

              // Highlighting helper
              var highlight = function(text, term) {
                if (!term) return text;
                var words = term.trim().split(/\s+/)
                  .filter(function(word, index, self) {
                    return word.length >= 2 && self.indexOf(word) === index;
                  })
                  .sort(function(a, b) {
                    return b.length - a.length;
                  });

                if (words.length === 0) return text;

                var pattern = words.map(function(word) {
                  return word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                }).join("|");

                var re = new RegExp("(" + pattern + ")", "gi");
                return text.replace(re, '<b class="search-highlight">$1</b>');
              };

              // Create a combined results container
              var combinedHtml = '';
              var suggestionsHtml = '';
              var didYouMeanHtml = '';
              var hasDidYouMean = false;
              var leftColumnHtml = '';
              var viewAllHtml = '';
              var productsHtml = '';
              var seenRelevantIds = [];
              var seenFuzzyIds = [];
              var shownProductIds = [];
              var totalProducts = 0;
              var seeAllButtonHtml = '';
              var maxRelevant = 8;
              var maxBroad = 8;
              var maxTotal = 12;

              // 1. Handle Suggestions
              [predictiveContainer, exactContainer, fuzzyContainer].forEach(container => {
                if (!container || suggestionsHtml !== '') return;
                var suggestions = container.querySelector('.CC-Suggestions-wrapper');
                if (suggestions && suggestions.querySelector('.CC-Suggestions-li')) {
                  suggestionsHtml = suggestions.innerHTML;
                }
              });

              // Try to find a "Did you mean" from fuzzy results regardless of suggestions
              if (fuzzyContainer) {
                var fuzzyProductsForCorrection = fuzzyContainer.querySelectorAll('.grid-view-item__title');
                
                if (fuzzyProductsForCorrection.length > 0) {
                  var titles = Array.from(fuzzyProductsForCorrection).map(el => el.textContent);
                  var searchWords = term.toLowerCase().split(/\s+/);
                  var correctedWords = [];
                  var isCorrected = false;

                  searchWords.forEach(word => {
                    if (word.length < 3) { correctedWords.push(word); return; }
                    var bestMatch = word;
                    var minDistance = word.length > 6 ? 3 : 2; 
                    var foundDistance = 99;

                    titles.forEach(title => {
                      var titleWords = title.toLowerCase().replace(/[^\w\s]/g, ' ').split(/\s+/);
                      titleWords.forEach(tWord => {
                        if (tWord.length < 3) return;
                        var d = levenshtein(word, tWord);
                        if (d > 0 && d <= minDistance && d < foundDistance) {
                          foundDistance = d;
                          bestMatch = tWord;
                        }
                      });
                    });

                    if (bestMatch !== word) {
                      correctedWords.push(bestMatch);
                      isCorrected = true;
                    } else {
                      correctedWords.push(word);
                    }
                  });

                  if (isCorrected) {
                    var correctedTerm = correctedWords.join(' ');
                    
                    // "Did you mean" block sits with suggestions in the left column
                    didYouMeanHtml = '<div class="did-you-mean-wrapper"><ul class="CC-Suggestions-ul"><li class="CC-Suggestions-header">Did you mean:</li><li class="CC-Suggestions-li"><span class="at at-search-l predictive-search__icon" aria-hidden="true"></span> <a href="#" class="did-you-mean-link" data-term="' + correctedTerm + '"><b>' + correctedTerm + '</b></a></li></ul></div>';
                    hasDidYouMean = true;

                    // SMART CORRECTION: If no collections found for the typo, automatically fetch them for the corrected term
                    if (suggestionsHtml === '') {
                        var cUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(correctedTerm)}&section_id=predictive-search&options[prefix]=last&resources[type]=collection,query`;
                        try {
                            const cRes = await fetch(cUrl, { signal });
                            const cHtml = await cRes.text();
                            if (signal.aborted) return;
                            var cDoc = parser.parseFromString(cHtml, 'text/html');
                            var cContainer = cDoc.querySelector('.predictive-section');
                            if (cContainer) {
                                var cSuggestions = cContainer.querySelector('.CC-Suggestions-wrapper');
                                if (cSuggestions && cSuggestions.querySelector('.CC-Suggestions-li')) {
                                    suggestionsHtml = cSuggestions.innerHTML;
                                }
                            }
                        } catch(e) { }
                    }
                  }
                }
              }

              var debugEntriesSummary = function(label, entries) {
                if (!debugPredictiveSearch) {
                  return;
                }

                console.log(label, (entries || []).map(function(entry) {
                  return {
                    id: entry.id,
                    tier: entry.tier,
                    status: entry.status,
                    title: (function() {
                      var debugDoc = parser.parseFromString(entry.html, 'text/html');
                      var debugTitle = debugDoc.querySelector('.grid-view-item__title');
                      return debugTitle ? debugTitle.textContent.trim() : '';
                    })()
                  };
                }));
              };
              var addToTier = function(entry, tierBuckets, tier) {
                if (tier === 'unavailable') {
                  tierBuckets.unavailable.push(entry);
                  return;
                }

                if (tier === 'delayed') {
                  tierBuckets.delayed.push(entry);
                  return;
                }

                tierBuckets.available.push(entry);
              };
              var sortEntriesByTier = function(entries) {
                return entries.slice().sort(function(leftEntry, rightEntry) {
                  return getTierWeight(leftEntry && leftEntry.tier) - getTierWeight(rightEntry && rightEntry.tier);
                });
              };
              var takeTieredEntries = function(tierBuckets, limit, excludeIds) {
                var results = [];
                var seenIds = [];
                var excludedIds = excludeIds || [];
                var orderedEntries = tierBuckets.available
                  .concat(tierBuckets.delayed)
                  .concat(tierBuckets.unavailable);

                orderedEntries.forEach(function(entry) {
                  if (results.length >= limit) {
                    return;
                  }

                  if (excludedIds.indexOf(entry.id) !== -1 || seenIds.indexOf(entry.id) !== -1) {
                    return;
                  }

                  results.push(entry);
                  seenIds.push(entry.id);
                });

                return results;
              };
              var mergeUniqueById = function(source, target) {
                var ids = [];
                target.forEach(function(entry) { ids.push(entry.id); });
                source.forEach(function(entry) {
                  if (ids.indexOf(entry.id) === -1) {
                    target.push(entry);
                    ids.push(entry.id);
                  }
                });
                return target;
              };
              var addProductsToBuckets = function(container, tierBuckets, seenIds, searchTerm) {
                if (!container) {
                  return;
                }

                var products = container.querySelectorAll('[data-product-id]');
                products.forEach(function(productEl) {
                  var productId = productEl.getAttribute('data-product-id');
                  if (seenIds.indexOf(productId) !== -1) {
                    return;
                  }

                  var titleEl = productEl.querySelector('.grid-view-item__title');
                  if (titleEl) {
                    titleEl.innerHTML = highlight(titleEl.textContent, searchTerm);
                  }

                  var stockStatus = productEl.getAttribute('data-stock-status') || '';
                  var availabilityTier = getAvailabilityTier(productEl, stockStatus);
                  var entry = { id: productId, html: productEl.outerHTML, status: stockStatus, tier: availabilityTier };
                  addToTier(entry, tierBuckets, availabilityTier);
                  seenIds.push(productId);
                });
              };
              var getBucketEntries = function(tierBuckets) {
                return tierBuckets.available
                  .concat(tierBuckets.delayed)
                  .concat(tierBuckets.unavailable);
              };
              var getBroadFallbackTerms = function(searchTerm) {
                var words = (searchTerm || '').trim().toLowerCase().split(/\s+/);
                var uniqueWords = [];

                words.forEach(function(word) {
                  if (word.length < 3 || uniqueWords.indexOf(word) !== -1) {
                    return;
                  }

                  uniqueWords.push(word);
                });

                if (uniqueWords.length <= 1) {
                  return [];
                }

                return uniqueWords;
              };

              // 2. Handle "Most Relevant" (Predictive + Exact Standard Search)
              var relevantProductsHtml = [];
              var relevantBuckets = {
                available: [],
                delayed: [],
                unavailable: []
              };
              var fuzzyBuckets = {
                available: [],
                delayed: [],
                unavailable: []
              };

              if (searchType === 'article') {
                var articlesList = [];
                [predictiveContainer, exactContainer, fuzzyContainer].forEach(container => {
                  if (!container) return;
                  var items = container.querySelectorAll('.psarticles .gitem');
                  items.forEach(item => {
                    var aid = item.getAttribute('data-item-id');
                    if (shownProductIds.indexOf(aid) === -1) {
                      var titleEl = item.querySelector('.grid-view-item__title');
                      if (titleEl) titleEl.innerHTML = highlight(titleEl.textContent, term);
                      
                      var descEl = item.querySelector('.grid-view-item__desc');
                      if (descEl) descEl.innerHTML = highlight(descEl.textContent, term);
                      
                      articlesList.push(item.outerHTML);
                      shownProductIds.push(aid);
                    }
                  });
                });

                if (articlesList.length > 0) {
                  var articleHeaderHtml = '';
                  [predictiveContainer, exactContainer, fuzzyContainer].forEach(container => {
                    if (articleHeaderHtml === '' && container) {
                      var aHeader = container.querySelector('.psarticles .fl.f-jcsb.f-aic');
                      if (aHeader) articleHeaderHtml = aHeader.outerHTML;
                    }
                  });

                  if (articleHeaderHtml === '') {
                    articleHeaderHtml = '<div class="fl f-jcsb f-aic mb15 lg-extra-padding"><h2 class="popttl mb0">Blogs & Articles</h2></div>';
                  }

                  productsHtml = '<div class="predictive-results-row w_100">' + articleHeaderHtml + '<hr class="mt0 mb20"/><div class="psarticles grid rwcols-1 lg-extra-padding">' + articlesList.join('') + '</div></div>';
                }
              } else {
                // Add predictive products
                if (predictiveContainer) {
                  addProductsToBuckets(predictiveContainer, relevantBuckets, seenRelevantIds, term);
                }

              // Add exact standard search products (catches SKUs)
              if (exactContainer) {
                addProductsToBuckets(exactContainer, relevantBuckets, seenRelevantIds, term);
              }

              // Shopify prefix search cannot match from the middle of a SKU.
              if (partialSkuContainer) {
                addProductsToBuckets(partialSkuContainer, relevantBuckets, seenRelevantIds, term);
              }

              if (fuzzyContainer) {
                addProductsToBuckets(fuzzyContainer, fuzzyBuckets, seenFuzzyIds, term);
              }

              if (!hasDidYouMean) {
                var relevantToShow = sortEntriesByTier(takeTieredEntries(relevantBuckets, maxRelevant));
                debugEntriesSummary('[Predictive Search] Relevant source pool', getBucketEntries(relevantBuckets));
                debugEntriesSummary('[Predictive Search] Relevant selected', relevantToShow);
                relevantToShow.forEach(function(entry) {
                  relevantProductsHtml.push(entry.html);
                  shownProductIds.push(entry.id);
                });
              } else {
                fuzzyBuckets.available = mergeUniqueById(relevantBuckets.available, fuzzyBuckets.available);
                fuzzyBuckets.delayed = mergeUniqueById(relevantBuckets.delayed, fuzzyBuckets.delayed);
                fuzzyBuckets.unavailable = mergeUniqueById(relevantBuckets.unavailable, fuzzyBuckets.unavailable);
              }

              totalProducts = relevantProductsHtml.length;

              if (!hasDidYouMean && relevantProductsHtml.length > 0) {
                var headerHtml = '';
                var header = null;
                
                // Try to get header from predictive first
                if (predictiveContainer) {
                  header = predictiveContainer.querySelector('.fl.f-jcsb.f-aic');
                }
                
                // If not found in predictive, try exact container
                if (!header && exactContainer) {
                  header = exactContainer.querySelector('.fl.f-jcsb.f-aic');
                }

                if (header) {
                  var titleEl = header.querySelector('.popttl');
                  if (titleEl) {
                    titleEl.textContent = 'Most Relevant Products';
                  }
                  var seeAllLink = header.querySelector('.all-results-btn-wrapper a');
                  if (seeAllLink && partialSkuTerm) {
                    seeAllLink.setAttribute('href', `/search?q=${encodeURIComponent(partialSkuTerm)}&type=product`);
                  }
                  headerHtml = header.outerHTML;
                  var seeAllBtn = header.querySelector('.all-results-btn-wrapper');
                  if (seeAllBtn) seeAllButtonHtml = seeAllBtn.outerHTML;
                }

                productsHtml += '<div class="predictive-results-row w_100">' + headerHtml + '<hr class="mt0 mb20"/><div class="psproducts grid rwcols-2 rwcols-md-3 rwcols-lg-4 lg-extra-padding">' + relevantProductsHtml.join('') + '</div></div>';
              }

              // 3. Handle "Broad Matched" (Fuzzy Search)
              fuzzyBuckets.available = mergeUniqueById(relevantBuckets.available, fuzzyBuckets.available);
              fuzzyBuckets.delayed = mergeUniqueById(relevantBuckets.delayed, fuzzyBuckets.delayed);
              fuzzyBuckets.unavailable = mergeUniqueById(relevantBuckets.unavailable, fuzzyBuckets.unavailable);
              debugEntriesSummary('[Predictive Search] Fuzzy merged source pool', getBucketEntries(fuzzyBuckets));

              if (totalProducts < maxTotal) {
                var remainingTotalSlots = maxTotal - totalProducts;
                var broadSlots = Math.min(maxBroad, remainingTotalSlots);
                var fuzzyToShow = sortEntriesByTier(takeTieredEntries(fuzzyBuckets, broadSlots, shownProductIds));

                if (fuzzyToShow.length < broadSlots) {
                  var broadFallbackTerms = getBroadFallbackTerms(term);

                  for (var fallbackIndex = 0; fallbackIndex < broadFallbackTerms.length; fallbackIndex++) {
                    if (fuzzyToShow.length >= broadSlots || signal.aborted || input.val().trim() !== term) {
                      break;
                    }

                    try {
                      var broadFallbackUrl = `/search?q=${encodeURIComponent(broadFallbackTerms[fallbackIndex])}&type=product&section_id=predictive-search`;
                      var broadFallbackRes = await fetch(broadFallbackUrl, { signal });
                      var broadFallbackHtml = await broadFallbackRes.text();

                      if (signal.aborted || input.val().trim() !== term) {
                        return;
                      }

                      var broadFallbackDoc = parser.parseFromString(broadFallbackHtml, 'text/html');
                      var broadFallbackContainer = broadFallbackDoc.querySelector('.fuzzy-section');
                      if (debugPredictiveSearch) {
                        console.log('[Predictive Search] Broad fallback term', broadFallbackTerms[fallbackIndex]);
                      }
                      addProductsToBuckets(broadFallbackContainer, fuzzyBuckets, seenFuzzyIds, term);
                      fuzzyToShow = sortEntriesByTier(takeTieredEntries(fuzzyBuckets, broadSlots, shownProductIds));
                      debugEntriesSummary('[Predictive Search] Fuzzy pool after fallback', getBucketEntries(fuzzyBuckets));
                    } catch (error) {
                      if (debugPredictiveSearch) {
                        console.warn('[Predictive Search] Broad fallback failed', broadFallbackTerms[fallbackIndex], error);
                      }
                    }
                  }
                }

                totalProducts += fuzzyToShow.length;
                debugEntriesSummary('[Predictive Search] Broad selected', fuzzyToShow);

                var uniqueFuzzyProducts = fuzzyToShow.map(function(entry) { return entry.html; });

                if (uniqueFuzzyProducts.length > 0) {
                  var broadContainer = fuzzyContainer || exactContainer || predictiveContainer;
                  var fuzzyHeader = broadContainer ? broadContainer.querySelector('.fl.f-jcsb.f-aic') : null;

                  if (fuzzyHeader) {
                    var fuzzyTitleEl = fuzzyHeader.querySelector('.popttl');
                    if (fuzzyTitleEl) {
                      fuzzyTitleEl.textContent = 'Broad Matched Products';
                    }
                  }
                  
                  if (seeAllButtonHtml !== '' && fuzzyHeader) {
                    var fuzzySeeAll = fuzzyHeader.querySelector('.all-results-btn-wrapper');
                    if (fuzzySeeAll) fuzzySeeAll.remove();
                  }

                  productsHtml += '<div class="fuzzy-results-row w_100 mt30">' + (fuzzyHeader ? fuzzyHeader.outerHTML : '') + '<hr class="mt0 mb20"/><div class="psproducts grid rwcols-2 rwcols-md-3 rwcols-lg-4 lg-extra-padding">' + uniqueFuzzyProducts.join('') + '</div></div>';
                }
              }
            }

              if (suggestionsHtml || didYouMeanHtml) {
                leftColumnHtml = '<div class="CC-Suggestions-wrapper">' + didYouMeanHtml + suggestionsHtml + '</div>';
                combinedHtml += leftColumnHtml;
              }

              if (productsHtml !== '') {
                combinedHtml += '<div class="predictive-search-products-wrapper" style="flex: 1;">' + productsHtml + '</div>';
              }

              if (debugPredictiveSearch && searchType === 'product') {
                console.log('[Predictive Search] Summary', {
                  term: term,
                  shownProductIds: shownProductIds.slice(),
                  totalProducts: totalProducts,
                  maxRelevant: maxRelevant,
                  maxBroad: maxBroad,
                  maxTotal: maxTotal,
                  hasDidYouMean: hasDidYouMean
                });
              }

              var finalHtml = '';
              var resultsId = searchType === 'article' ? 'predictive-article-results' : 'predictive-search-results';
              if (combinedHtml === '') {
                var contentClasses = searchType === 'article' ? '' : 'search-page-width lg-extra-padding';
                finalHtml = '<div id="' + resultsId + '" class="tl"><div class="' + contentClasses + '"><p class="noResult">No results found for "' + term + '"</p></div></div>';
              } else {
                var displayStyle = 'display: flex;';
                var contentClasses = searchType === 'article' ? 'article-results-inner' : 'search-page-width lg-extra-padding';
                finalHtml = '<div id="' + resultsId + '" class="tl"><div class="' + contentClasses + '" style="' + displayStyle + '">' + combinedHtml + '</div></div>';
              }

              if ($(resultsList).html() !== finalHtml) {
                if ($(resultsList).is(':visible')) {
                  $(resultsList).html(finalHtml);
                } else {
                  $(resultsList).html(finalHtml).fadeIn();
                }
                
                if (searchType !== 'article') {
                  $('body').addClass('search-results-open');
                }
              }
              
              $('.s_suggestion').hide();
            }).catch((error) => {
              if (error.name === 'AbortError') {
                return;
              }
              console.error('Search error:', error);
              $(resultsList).hide();
              $('.s_suggestion').show();
              if (searchType !== 'article') {
                $('body').removeClass('search-results-open');
              }
            });
          }, 300); // 300ms debounce
        } else { 
          if (searchController) {
            searchController.abort();
            searchController = null;
          }
          if (isPopupSearch) {
            resultsList.empty().hide();
            $('.s_suggestion').show();
            $('body').removeClass('search-results-open');
          } else {
            showPopularSuggestions();
            if (!resultsList.is(':visible')) {
              $('body').removeClass('search-results-open');
            }
          }
        }
      });

      clearBtn.on('click', function(){
        if (isPopupSearch) {
          input.val('').trigger('input').focus();
          resultsList.empty().hide();
          $('.s_suggestion').show();
          return;
        }

        suggestionsDismissed = true;
        lastSearchTerm = '';
        input.val('').focus();
        resultsList.empty().hide();
        clearBtn.hide();
        $('body').removeClass('search-results-open');
      });

      $(document).off('click.searchDropdown').on('click.searchDropdown', function(e) {
        var $target = $(e.target);
        $('form[action*="/search"]').each(function() {
          var $form = $(this);
          var $results = $form.find('.search-results');
          if (!$results.length || $form.closest('#searchPopup').length > 0) {
            return;
          }
          if ($target.closest($form).length) {
            return;
          }
          if ($results.is(':visible')) {
            $results.hide();
            $('body').removeClass('search-results-open');
          }
        });
      });

      $(document).on('click', '.did-you-mean-link', function(e) {
        e.preventDefault();
        var newTerm = $(this).attr('data-term');
        input.val(newTerm).trigger('input').focus();
      });
    });
    primePopularSearchProducts();
    $('.modalOverly, .closeSearch').bind('click', function(){
      $('body').removeClass("showOverly search-results-open search-popup-open");
      $('#searchPopup').removeClass("active");
    });
    $('.searchIco').off('click.popularSearch').on('click.popularSearch', function(e){
      e.preventDefault();

      $('body').addClass("showOverly search-popup-open");
      $('#searchPopup').addClass("active");
      $('#searchPopup input[name=q]').first().focus();

      var $popupForm = $('#searchPopup form[action*="/search"]').first();
      var popularUrl = $popupForm.attr('data-search-popular-url') || '';
      var $popularContainer = $('#searchPopup [data-search-popular-popup]').first();
      if (!popularUrl || !$popularContainer.length) {
        return;
      }

      loadPopularSearchProducts(popularUrl).then(function(source) {
        if (!$('#searchPopup').hasClass('active')) {
          return;
        }
        populatePopularSearchPopup(source, true);
      }).catch(function() {});
    });
  }
    return { init:init };
})();

/*================ RESUMABLE SUPPORT AVAILABILITY ================*/
(function() {
  var scriptLoads = Object.create(null);

  function loadScript(url, key) {
    if (!url) {
      return Promise.reject(new Error('Support chat script URL is unavailable.'));
    }
    if (scriptLoads[key]) {
      return scriptLoads[key];
    }

    scriptLoads[key] = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.async = true;
      script.src = url;
      script.setAttribute('data-support-chat-script', key);
      script.addEventListener('load', function() {
        resolve();
      }, { once: true });
      script.addEventListener('error', function() {
        script.remove();
        delete scriptLoads[key];
        reject(new Error('Support chat script failed to load: ' + key));
      }, { once: true });
      document.head.appendChild(script);
    });

    return scriptLoads[key];
  }

  function primeBotStylesheet(root) {
    var stylesheetUrl = root.getAttribute('data-bot-style-url') || '';
    if (!stylesheetUrl || document.querySelector('[data-wf-chatbot-stylesheet]')) {
      return;
    }

    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = stylesheetUrl;
    stylesheet.setAttribute('data-wf-chatbot-stylesheet', 'loading');
    stylesheet.addEventListener('load', function() {
      stylesheet.setAttribute('data-wf-chatbot-stylesheet', 'loaded');
    }, { once: true });
    stylesheet.addEventListener('error', function() {
      stylesheet.setAttribute('data-wf-chatbot-stylesheet', 'failed');
    }, { once: true });
    document.head.appendChild(stylesheet);
  }

  function primeBotConversation(root) {
    if (root.__supportChatBotResumePromise) {
      return root.__supportChatBotResumePromise;
    }

    root.setAttribute('data-bot-script-status', 'loading');
    primeBotStylesheet(root);
    root.__supportChatBotResumePromise = loadScript(
      root.getAttribute('data-bot-script-url') || '',
      'product-assistant'
    ).catch(function(error) {
      root.setAttribute('data-bot-script-status', 'unavailable');
      throw error;
    });

    return root.__supportChatBotResumePromise;
  }

  function loadProvider(root, attributeName, key) {
    return loadScript(root.getAttribute(attributeName) || '', key).then(function() {
      return true;
    }).catch(function() {
      return false;
    });
  }

  function checkBotAvailability(root) {
    var configUrl = root.getAttribute('data-bot-config-url') || '';
    if (!configUrl) {
      return Promise.resolve(false);
    }

    var separator = configUrl.indexOf('?') === -1 ? '?' : '&';
    var requestUrl = configUrl + separator + 'storefront_origin=' + encodeURIComponent(window.location.origin);
    return fetch(requestUrl, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) {
        return false;
      }
      return response.json().then(function(payload) {
        return !!(payload && payload.enabled === true);
      }).catch(function() {
        return false;
      });
    }).catch(function() {
      return false;
    });
  }

  function readSessionStorageValue(root, attributeName) {
    var storageKey = root.getAttribute(attributeName) || '';
    if (!storageKey) return null;

    try {
      return window.sessionStorage
        ? window.sessionStorage.getItem(storageKey)
        : null;
    } catch (error) {
      return null;
    }
  }

  function shouldResumeBotConversation(root) {
    return readSessionStorageValue(root, 'data-bot-open-storage-key') === '1';
  }

  function shouldResumeSupportChat(root) {
    return shouldResumeBotConversation(root) ||
      !!readSessionStorageValue(root, 'data-zammad-session-storage-key');
  }

  function initializeSupportChat(root) {
    if (root.__supportChatLoadPromise) {
      return root.__supportChatLoadPromise;
    }

    var launcher = root.querySelector('[data-support-chat-launcher]');
    var statusNode = root.querySelector('[data-support-chat-status]');
    if (!launcher || !statusNode) {
      return Promise.reject(new Error('Support chat loader markup is unavailable.'));
    }

    launcher.hidden = true;
    launcher.disabled = true;
    root.setAttribute('data-support-state', 'checking');
    statusNode.textContent = 'Checking support availability…';

    var resumeBot = shouldResumeBotConversation(root);
    var botAvailabilityPromise = resumeBot
      ? Promise.resolve(true)
      : checkBotAvailability(root);
    root.__supportChatLoadPromise = Promise.all([
      loadProvider(root, 'data-zammad-script-url', 'zammad'),
      botAvailabilityPromise
    ]).then(function(providerResults) {
      if (!resumeBot || !root.getAttribute('data-bot-script-status')) {
        root.setAttribute(
          'data-bot-script-status',
          providerResults[1] ? 'available' : 'unavailable'
        );
      }
      return loadScript(
        root.getAttribute('data-controller-script-url') || '',
        'controller'
      );
    }).catch(function(error) {
      delete root.__supportChatLoadPromise;
      root.setAttribute('data-support-state', 'unavailable');
      statusNode.textContent = 'Support is unavailable right now.';
      launcher.hidden = true;
      launcher.disabled = true;
      throw error;
    });

    return root.__supportChatLoadPromise;
  }

  function startSupportAvailabilityCheck() {
    var root = document.querySelector('[data-support-chat]');
    if (!root) return;
    initializeSupportChat(root).catch(function(error) {
      console.error('Support chat availability check failed.', error);
    });
  }

  var supportRoot = document.querySelector('[data-support-chat]');
  var resumeBotConversation = supportRoot && shouldResumeBotConversation(supportRoot);
  if (resumeBotConversation) {
    primeBotConversation(supportRoot).catch(function(error) {
      console.error('Product assistant resume failed.', error);
    });
  }
  if (
    document.readyState === 'complete' ||
    (supportRoot && shouldResumeSupportChat(supportRoot))
  ) {
    startSupportAvailabilityCheck();
  } else {
    window.addEventListener('load', startSupportAvailabilityCheck, { once: true });
  }
})();
/*================ SECTIONS ================*/
window.theme = window.theme || {};
theme.HeaderSection = (function(){
  function Header() {
    theme.Header.init();
    theme.Search.init();
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function(){
      theme.Header.unload();
    }
  });
  return Header;
})();

/*CC update*/
/* eslint-disable no-new */
theme.Product = (function(){
  function Product(container) {
    this.container = container;
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id');

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      bpSmall: false,
      zoomEnabled: false
    };
    this.selectors={
      imgWrap: '.pr_zoom_' + sectionId
    }
      
    if(!customElements.get('media-gallery')){
        customElements.define('media-gallery', class MediaGallery extends HTMLElement {
            constructor(){
                super();
            }
            connectedCallback(){
                var $root = $(this),
                    $primgsl = $root.find('.primgSlider').first(),
                    $carouselNavH = $root.find('.pr_thumbsWr').first(),
                    $carouselNav = $root.find('.pr_thumbs').first(),
                    $carouselNavCells = $carouselNav.find('.pr_thumbs_item'),
                    navCellHeight = $carouselNavCells.height(),
                    navCellWidth = $carouselNavCells.width(),
                    navHeight = $carouselNav.height(),
                    navWidth = $carouselNav.width(),
                    isBottomThumbNav = $root.find('.thumbs_nav').hasClass('bottom');
                var parseSlideIndex = function(value){
                  var parsed = parseInt(value, 10);
                  return isNaN(parsed) ? null : parsed;
                };
                var getMediaKeyFromElement = function(element){
                  var $element = $(element);
                  if(!$element.length){
                    return null;
                  }
                  return $element.attr('data-media-key') || $element.attr('data-id') || ($element.attr('data-media-id') ? 'media' + $element.attr('data-media-id') : null);
                };
                var isMediaSlideElement = function(element){
                  if(!element){
                    return false;
                  }
                  var $element = $(element);
                  return $element.is('.pr_photo, product-model') || !!getMediaKeyFromElement(element);
                };
                var normalizeAuxiliarySliderNodes = function(){
                  var movedCount = 0;
                  $primgsl.children('[id^="pswp-desc-"]').each(function(){
                    var $desc = $(this);
                    var descId = $desc.attr('id');
                    var $target = $primgsl.children('.pr_photo[aria-describedby="' + descId + '"], product-model[aria-describedby="' + descId + '"]').first();

                    if(!$target.length){
                      $target = $desc.prevAll('.pr_photo, product-model').first();
                    }

                    if($target.length){
                      $target.append($desc);
                      movedCount += 1;
                    }
                  });
                };
                var getSlideElementFromIndex = function(index){
                  var sliderInstance = $primgsl.get(0).themeSwiper;
                  if(sliderInstance && sliderInstance.slides && typeof index === 'number' && sliderInstance.slides[index]){
                    var cellElement = sliderInstance.slides[index];
                    if(isMediaSlideElement(cellElement)){
                      return cellElement;
                    }
                  }
                  return $primgsl.find('.pr_photo[data-slide="' + index + '"]').get(0) || null;
                };
                var getSelectedMediaState = function(indexArg){
                  var sliderInstance = $primgsl.get(0).themeSwiper;
                  var resolvedIndex = (typeof indexArg === 'number' && indexArg >= 0) ? indexArg : (sliderInstance && typeof sliderInstance.realIndex === 'number' ? sliderInstance.realIndex : 0);
                  var selectedElement = getSlideElementFromIndex(resolvedIndex);
                  var selectedMediaKey = getMediaKeyFromElement(selectedElement);
                  if(!selectedMediaKey && sliderInstance && sliderInstance.slides && sliderInstance.slides[sliderInstance.activeIndex]){
                    selectedElement = sliderInstance.slides[sliderInstance.activeIndex];
                    selectedMediaKey = getMediaKeyFromElement(selectedElement);
                  }
                  return {
                    index: resolvedIndex,
                    mediaKey: selectedMediaKey,
                    slideId: selectedElement ? selectedElement.id || null : null,
                    slideDataSlide: selectedElement ? $(selectedElement).attr('data-slide') || null : null
                  };
                };
                var findThumbByMediaKey = function(mediaKey){
                  if(!mediaKey){
                    return $();
                  }
                  return $carouselNavCells.filter('[data-media-key="' + mediaKey + '"]').first();
                };
                var syncActiveThumb = function(indexArg, source){
                  var state = getSelectedMediaState(indexArg);
                  var $selected = findThumbByMediaKey(state.mediaKey);
                  if(!$selected.length && typeof state.index === 'number' && state.index >= 0){
                    $selected = $carouselNavCells.eq(state.index);
                  }

                  $carouselNav.find('.active-thumb').removeClass('active-thumb');
                  $selected.addClass('active-thumb');
                  if(!$selected.length){
                    return;
                  }

                  if(isBottomThumbNav || $(window).width()<767){
                    var scrollX = $selected.position().left + $carouselNavH.scrollLeft() - ( navWidth + navCellWidth) / 2.5;
                    $carouselNavH.stop(true, true).scrollLeft(scrollX);
                  } else {
                    var scrollY = $selected.position().top + $carouselNav.scrollTop() - ( navHeight + navCellHeight) / 2.5;
                    $carouselNav.stop(true, true).scrollTop(scrollY);
                  }
                };

                if(!$primgsl.length){
                  return;
                }

                normalizeAuxiliarySliderNodes();

                $primgsl.off('theme:swiper:select.mediaGallerySync').on('theme:swiper:select.mediaGallerySync', function(event){
                  var detail = event.originalEvent && event.originalEvent.detail;
                  syncActiveThumb(detail && detail.index, 'select');
                });

                $primgsl.off('theme:swiper:settle.mediaGallerySync').on('theme:swiper:settle.mediaGallerySync', function(){
                  syncActiveThumb(null, 'settle');
                });

        $root.find('.thumbs_nav .thumbs-nav-button.previous').off('click.mediaGalleryNav').on('click.mediaGalleryNav', function(e){
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
                    $carouselNav.stop(true, true);
                    $carouselNavH.stop(true, true);
                    var $activeSlider = $root.find('.primgSlider').first();
                    if($activeSlider.length && window.themeSwiper) window.themeSwiper.previous($activeSlider.get(0));
                    return false;
                });
        $root.find('.thumbs_nav .thumbs-nav-button.next').off('click.mediaGalleryNav').on('click.mediaGalleryNav', function(e){
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
                    $carouselNav.stop(true, true);
                    $carouselNavH.stop(true, true);
                    var $activeSlider = $root.find('.primgSlider').first();
                    if($activeSlider.length && window.themeSwiper) window.themeSwiper.next($activeSlider.get(0));
                    return false;
                });

               $(window).on('load', function(e){
                if(window.themeSwiper) window.themeSwiper.update($primgsl.get(0));
                $root.find('.pr_thumb[data-slide="0"] .prvideo').trigger('click');
                 var video = $root.find('.primgSlider .videoSlide.is-selected video').get(0);
                if($(video).length){ video.play(); }
               });

               $primgsl.off('theme:swiper:select.mediaGalleryVideo').on('theme:swiper:select.mediaGalleryVideo', function(){
                  if($(this).find('.videoSlide video').length){ $(this).find('.videoSlide video').get(0).pause(); }
                  var video = $(this).find('.videoSlide.is-selected video').get(0);
                  if($(video).length){ video.play(); }
               });
                let thumb = this.querySelectorAll(".pr_thumb");
                 thumb.forEach((thumb)=>{
                  thumb.addEventListener('click',(e)=>{
                      e.preventDefault();
                      this.setActiveMedia(thumb.dataset.target);
                  });
                 });
                 
                this.setActiveMedia(this.dataset.target);
            }
setActiveMedia(mediaId) {
    var breakpoint = window.matchMedia('(min-width: 768px)');
  var $gallery = $(this).find('.primgSlider').first();
  if (!$gallery.length) {
    return;
  }

  var mediaIdStr = mediaId != null ? String(mediaId) : '';
  var $targetElement = $gallery.find('.pr_photo[data-id="' + mediaIdStr + '"]');
  if(!$targetElement.length && mediaIdStr.indexOf('media') !== 0){
    $targetElement = $gallery.find('.pr_photo[data-id="media' + mediaIdStr + '"]');
  }
  if(!$targetElement.length && mediaIdStr.indexOf('media') === 0){
    var rawMediaId = mediaIdStr.replace(/^media/, '');
    $targetElement = $gallery.find('.pr_photo[data-media-id="' + rawMediaId + '"]');
  }
  var activeMedia = $targetElement.length ? parseInt($targetElement.first().attr('data-slide'), 10) : NaN;

    // Handle the case where activeMedia is -1
    if (isNaN(activeMedia) || activeMedia < 0) {
        var sliderInstance = $gallery.get(0).themeSwiper;
        activeMedia = (sliderInstance && typeof sliderInstance.realIndex === 'number' && sliderInstance.realIndex >= 0)
          ? sliderInstance.realIndex
          : 0;
    }

    if (activeMedia != undefined) {
        if (theme.productStrings.prStyle == "2" || theme.productStrings.prStyle == "3" || theme.productStrings.prStyle == "4") {
          var imgposition = $gallery.find('.pr_photo').eq(activeMedia).offset();
            if ($(window).width() > 767) {
                $("html, body").animate({ scrollTop: imgposition.top - 70 }, 700);
            } else {
            if(window.themeSwiper) window.themeSwiper.select($gallery.get(0), activeMedia);
            else if(window.themeSwiperLoad) window.themeSwiperLoad().then(function(runtime){ runtime.select($gallery.get(0), activeMedia); });
            }
        } else {
          if(window.themeSwiper) window.themeSwiper.select($gallery.get(0), activeMedia);
          else if(window.themeSwiperLoad) window.themeSwiperLoad().then(function(runtime){ runtime.select($gallery.get(0), activeMedia); });
        }
    }
}



            
        });
    }
    
    // change variant on image sections
    if(typeof vimgs !== 'undefined'){
      $('.pr_thumb').bind('click', function(e){
            e.preventDefault();
            var mid = $(this).attr('id');
            if(typeof vimgs[mid] !== 'undefined'){
                productOptions.forEach(function (value, i){
                 optionValue = vimgs[mid]['option-'+i];
                  if($('.swatch.pvOpt0').length){
                    if(optionValue !== null && $('.pvOpt'+i+' .swatchInput').filter(function(){ return $(this).val() === optionValue }).length){
                       $(".pvOpt"+i).find('.swatchInput[value="'+optionValue+'"]').trigger('click');
                     }
                  } else {
                    if(optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function(){ return $(this).text() === optionValue }).length){
                       $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
                     }
                  }
              });
            }
      });
    }

    $(".product-info .review").on('click',function(e){
        $(".product-tabs li").removeClass("active");
      	$(".tablink[href='#ptabReview']").parent().addClass("active");
        $(".tab-content").not("#ptabReview").css("display", "none");
        $("#ptabReview").fadeIn();
      	var tabposition = $('#ptabReview').offset();
      	if($(window).width()<767) {
          $("html, body").animate({ scrollTop: tabposition.top-100 }, 700);
        } else{
          $("html, body").animate({ scrollTop: tabposition.top-150 }, 700);
        }
    });
    
    this._initGalleryAccessibility(sectionId);
    this._initBreakpoints();
    this._stringOverrides();
  }

  Product.prototype = _.assignIn({},Product.prototype,{
    _initGalleryAccessibility: function(sectionId){
      var carouselId = 'pis' + sectionId;
      var carousel = document.getElementById(carouselId);
      if(!carousel){
        return;
      }
      if(carousel.getAttribute('data-aria-accessibility-ready') === 'true'){
        return;
      }

      var ariaUpdateLock = false;
      var focusableSelector = 'a, button, input, select, textarea, [tabindex]';
      var matchesFn = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

      var listToArray = function(collection){
        return collection ? Array.prototype.slice.call(collection) : [];
      };

      var matchesSelector = function(element, selector){
        if(!element || element.nodeType !== 1){
          return false;
        }
        var parts = selector.split(',');
        for(var i = 0; i < parts.length; i += 1){
          var part = parts[i].trim();
          if(part && matchesFn && matchesFn.call(element, part)){
            return true;
          }
        }
        return false;
      };

      var getElementViewport = function(container, selector){
        if(!container){
          return null;
        }
        return container.querySelector(selector) || container;
      };

      var getOverlap = function(startA, endA, startB, endB){
        return Math.min(endA, endB) - Math.max(startA, startB);
      };

      var isElementVisibleWithinViewport = function(element, viewport){
        if(!element || !viewport){
          return false;
        }

        var computedStyle = window.getComputedStyle(element);
        if(computedStyle.display === 'none' || computedStyle.visibility === 'hidden'){
          return false;
        }

        var elementRect = element.getBoundingClientRect();
        var viewportRect = viewport.getBoundingClientRect();
        if(elementRect.width <= 1 || elementRect.height <= 1 || viewportRect.width <= 1 || viewportRect.height <= 1){
          return false;
        }

        return getOverlap(elementRect.left, elementRect.right, viewportRect.left, viewportRect.right) > 1 &&
          getOverlap(elementRect.top, elementRect.bottom, viewportRect.top, viewportRect.bottom) > 1;
      };

      var setFocusableState = function(container, isVisible){
        var focusableElements = [];
        if(matchesSelector(container, focusableSelector)){
          focusableElements.push(container);
        }
        focusableElements = focusableElements.concat(listToArray(container.querySelectorAll(focusableSelector)));

        for(var i = 0; i < focusableElements.length; i += 1){
          var element = focusableElements[i];
          if(isVisible){
            if(element.hasAttribute('data-aria-orig-tabindex')){
              element.setAttribute('tabindex', element.getAttribute('data-aria-orig-tabindex'));
              element.removeAttribute('data-aria-orig-tabindex');
            } else if(element.getAttribute('tabindex') === '-1'){
              element.removeAttribute('tabindex');
            }
          } else {
            if(element.hasAttribute('tabindex') && !element.hasAttribute('data-aria-orig-tabindex')){
              element.setAttribute('data-aria-orig-tabindex', element.getAttribute('tabindex'));
            }
            element.setAttribute('tabindex', '-1');
          }
        }
      };

      var syncCollectionAccessibility = function(elements, viewport){
        for(var i = 0; i < elements.length; i += 1){
          var element = elements[i];
          var isVisible = isElementVisibleWithinViewport(element, viewport);
          element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
          setFocusableState(element, isVisible);
        }
      };

      var updateThumbAccessibility = function(){
        var galleryRoot = carousel.closest ? carousel.closest('media-gallery') : null;
        if(!galleryRoot){
          return;
        }

        var thumbTrack = galleryRoot.querySelector('.pr_thumbs');
        var thumbViewport = galleryRoot.querySelector('.pr_thumbsWr');
        if(!thumbTrack || !thumbViewport){
          return;
        }

        syncCollectionAccessibility(listToArray(thumbTrack.querySelectorAll('.pr_thumbs_item')), thumbViewport);
      };

      var lastUpdateTimestamp = 0;
      var updateAriaHiddenLinks = function(){
        if(!carousel){
          return;
        }
        if(ariaUpdateLock){
          return;
        }
        var now = Date.now();
        if(now - lastUpdateTimestamp < 120){
          return;
        }
        lastUpdateTimestamp = now;

        ariaUpdateLock = true;
        try {
          var slideTrack = carousel.querySelector('.theme-swiper-wrapper');
          var slideViewport = getElementViewport(carousel, '.theme-swiper-viewport');
          if(slideTrack && slideViewport){
            syncCollectionAccessibility(listToArray(slideTrack.children), slideViewport);
          }
          updateThumbAccessibility();
        } finally {
          ariaUpdateLock = false;
        }
      };

      var attachSliderListeners = function(){
        var sliderEvents = ['theme:swiper:init', 'theme:swiper:select', 'theme:swiper:settle'];
        for(var i = 0; i < sliderEvents.length; i += 1){
          carousel.addEventListener(sliderEvents[i], function(){
            updateAriaHiddenLinks();
          });
        }

        var galleryRoot = carousel.closest ? carousel.closest('media-gallery') : null;
        var thumbViewport = galleryRoot ? galleryRoot.querySelector('.pr_thumbsWr') : null;
        if(thumbViewport && !thumbViewport.getAttribute('data-aria-thumb-watcher')){
          thumbViewport.addEventListener('scroll', updateAriaHiddenLinks, { passive: true });
          thumbViewport.setAttribute('data-aria-thumb-watcher', 'true');
        }

        if(!carousel.getAttribute('data-aria-window-watcher')){
          window.addEventListener('resize', updateAriaHiddenLinks, { passive: true });
          window.addEventListener('orientationchange', updateAriaHiddenLinks, { passive: true });
          carousel.setAttribute('data-aria-window-watcher', 'true');
        }
      };

      var monitorMutations = function(){
        if(!window.MutationObserver){
          return;
        }

        if(carousel.getAttribute('data-aria-watcher')){
          return;
        }

        var mutationScheduled = false;
        var observer = new MutationObserver(function(mutations){
          if(ariaUpdateLock){
            return;
          }
          var needsRefresh = false;

          for(var i = 0; i < mutations.length; i += 1){
            var mutation = mutations[i];
            if(mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'tabindex' || mutation.attributeName === 'style' || mutation.attributeName === 'class'){
              needsRefresh = true;
            }
          }

          if(needsRefresh && !mutationScheduled){
            mutationScheduled = true;
            window.requestAnimationFrame(function(){
              mutationScheduled = false;
              updateAriaHiddenLinks();
            });
          }
        });

        observer.observe(carousel, {
          attributes: true,
          subtree: true,
          attributeFilter: ['aria-hidden', 'tabindex', 'style', 'class']
        });

        carousel.setAttribute('data-aria-watcher', 'true');
      };

      var initAccessibility = function(){
        if(carousel.getAttribute('data-aria-accessibility-ready') === 'true'){
          return;
        }

        carousel.setAttribute('data-aria-accessibility-ready', 'true');
        updateAriaHiddenLinks();
        attachSliderListeners();
        monitorMutations();
      };

      if(document.readyState === 'loading'){
        var readyHandler = function(){
          document.removeEventListener('DOMContentLoaded', readyHandler);
          initAccessibility();
        };
        document.addEventListener('DOMContentLoaded', readyHandler);
      } else {
        initAccessibility();
      }
    },

    _stringOverrides: function(){
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function(){
      var self = this;
      enquire.register(this.settings.mediaQuerySmall, {
        match: function(){
          // destroy image zooming if enabled
          if(self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }
          self.settings.bpSmall = true;
        },
        unmatch: function(){
          self.settings.bpSmall = false;
        }
      });
      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function(){
          if(self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.imgWrap));
          }
        }
      });
    },

    onUnload: function(){
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el){
    $($el).hover(
      function(){
        var zoomUrl = $(this).data('zoom');
        $(this).zoom({url: zoomUrl});
      }, function(){
        $(this).trigger('zoom.destroy');
      }
    );
  }

  function _destroyZoom($el){
    $($el).each(function(){
    	$(this).trigger('zoom.destroy');
     });
  }
  return Product;
})();



theme.tabs = (function(){
  function tabs(container){
    var $container = this.$container = $(container);
    var tabs = this.tabs = $container.find('.product-tabs .tablink');
    
    tabs.on('click', function(e){
      e.preventDefault();
        var $link = $(this);
        var $productTabs = $link.closest('#productTabs');
        var tab = $link.attr('href');
        var $target = $productTabs.find(tab).first();
        if(!$target.length) return;

        $link.parent().addClass('active').siblings().removeClass('active');
        tabs.attr('aria-selected', 'false');
        $link.attr('aria-selected', 'true');
        var $panels = $productTabs.find('.tab-container > .tab-content');
        $panels.not($target).stop(true, true).attr('aria-hidden', 'true').hide();
        $target.stop(true, true).attr('aria-hidden', 'false').fadeIn(theme.motion.duration);
    });
    $container.find('.acor-ttl .tablink').on('click', function(e){
      e.preventDefault();
        var $link = $(this);
        var $heading = $link.parent();
        var $panel = $heading.next('.tab-content');
        var opening = !$heading.hasClass('active');
        if(!$panel.length) return;

        $heading.toggleClass('active', opening);
        $link.attr('aria-expanded', opening ? 'true' : 'false');
        $panel.attr('aria-hidden', opening ? 'false' : 'true').stop(true, false);
        if(opening){
          $panel.slideDown(theme.motion.duration);
        } else {
          $panel.slideUp(theme.motion.duration);
        }
    });
    // Make description tab active by default instead of first tab
    $container.find('.tablink[href="#ptabDesc"]').parent().addClass('active');
    tabs.each(function(){
      $(this).attr('aria-selected', $(this).parent().hasClass('active') ? 'true' : 'false');
    });
    $container.find('.acor-ttl .tablink').each(function(){
      var expanded = $(this).parent().hasClass('active');
      $(this).attr('aria-expanded', expanded ? 'true' : 'false');
      $(this).parent().next('.tab-content').attr('aria-hidden', expanded ? 'false' : 'true');
    });
    $container.find('#ptabDesc').show().attr('aria-hidden', 'false');
  }
  return tabs;
})();

// Product quick view
theme.QuickView = (function(){
  var productModelAssetsPromise = null;

  function dispatchQuickViewEvent(eventName, trigger) {
    var event;
    if (typeof window.CustomEvent === 'function') {
      event = new CustomEvent(eventName, {
        bubbles: true,
        detail: { trigger: trigger || null }
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, false, { trigger: trigger || null });
    }
    document.dispatchEvent(event);
  }

  function matchingAsset(element, attribute, url) {
    var assets = document.querySelectorAll(element + '[' + attribute + ']');
    for (var index = 0; index < assets.length; index += 1) {
      if (assets[index].getAttribute(attribute) === url) return assets[index];
    }
    return null;
  }

  function ensureProductModelStyle(styleUrl) {
    if (!styleUrl || matchingAsset('link', 'href', styleUrl)) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = styleUrl;
    link.setAttribute('data-theme-product-model-style', '');
    document.head.appendChild(link);
  }

  function ensureProductModelScript(scriptUrl) {
    if (!scriptUrl || customElements.get('product-model')) return Promise.resolve();
    if (productModelAssetsPromise) return productModelAssetsPromise;

    productModelAssetsPromise = new Promise(function(resolve, reject) {
      var script = matchingAsset('script', 'src', scriptUrl);
      var resolveWhenDefined = function() {
        customElements.whenDefined('product-model').then(resolve, reject);
      };

      if (script) {
        script.addEventListener('load', resolveWhenDefined, { once: true });
        script.addEventListener('error', reject, { once: true });
        if (customElements.get('product-model')) resolve();
        return;
      }

      script = document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.setAttribute('data-theme-product-model-script', '');
      script.addEventListener('load', resolveWhenDefined, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    }).catch(function(error) {
      productModelAssetsPromise = null;
      throw error;
    });

    return productModelAssetsPromise;
  }

  function ensureQuickViewProductModel(container) {
    if (!container) return Promise.resolve();
    var configuration = container.querySelector('[data-product-model-script]');
    if (!configuration || !configuration.querySelector('product-model')) return Promise.resolve();

    ensureProductModelStyle(configuration.getAttribute('data-product-model-style'));
    return ensureProductModelScript(configuration.getAttribute('data-product-model-script'));
  }

  $('body').on( 'click', '.quick-view', function(e){
    var quickViewTrigger = this;
    $.ajax({
      beforeSend : function (){
        $('body').addClass("loading");
       },
      url: $(this).attr('data-href') || $(this).attr('href'),
      success: function(data) {

        $.magnificPopup.open({
          items: {
            src: '<div class="quick-view-popup mfpbox mfp-with-anim" id="content_quickview">' + data + '</div>',
            type: 'inline'
          },
          removalDelay:500,
          callbacks: {
            beforeOpen: function(){
             $('.stickyHeader').addClass('popup');
              this.st.mainClass = 'mfp-zoom-in';
            },
            open: function(){
              shopreviews();
              var quickviewContent = document.getElementById('content_quickview');
              ensureQuickViewProductModel(quickviewContent).catch(function() {
                dispatchQuickViewEvent('quick-view:model-error', quickViewTrigger);
              });
            },
            close: function(){
              $('.stickyHeader').removeClass('popup');
              var quickviewContent = document.getElementById('content_quickview');
              if (quickviewContent && window.themeSwiper) window.themeSwiper.destroyWithin(quickviewContent);
              $( '#content_quickview' ).empty();
            },
            afterClose: function() {
              dispatchQuickViewEvent('quick-view:closed', quickViewTrigger);
            }
          },
        });
      },
      error: function() {
        dispatchQuickViewEvent('quick-view:error', quickViewTrigger);
      },
      complete: function(){
        $('body').removeClass("loading");
      }
    })
    e.preventDefault();
    e.stopPropagation();
  });
})();

theme.quotesl={};
theme.Quotes = (function(){
  function Quotes(container){
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        slider = this.quotesl = '#Quotes-' + sectionId;
    if($(slider).length && window.themeSwiper) window.themeSwiper.update($(slider)[0]);
      
  }
  return Quotes;
})();

theme.slideshows={};
theme.SlideshowSection = (function(){
  function SlideshowSection(container){
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#ss' + sectionId;
    var $slideshow = $(slideshow);
    if($slideshow.is('[data-theme-swiper]') && window.themeSwiper) window.themeSwiper.update($slideshow[0]);
    
    var iframes = $slideshow.find('.embed-player');
    resizePlayer(iframes, 16/9, $slideshow);
    $(window).on("resize", function(){
      resizePlayer(iframes, 16/9, $slideshow);
    });
  }
    // Resize player
    function resizePlayer(iframes, ratio, slideshow){
      if(!iframes[0]) return;
      var win = $(slideshow),
          width = win.width(),
          playerWidth,
          height = win.height(),
          playerHeight,
          ratio = ratio || 16/9;

      iframes.each(function(){
        var current = $(this);
        if(width / ratio < height){
          playerWidth = Math.ceil(height * ratio);
          current.width(playerWidth).height(height).css({
            left: (width - playerWidth) / 2,
             top: 0
            });
        } else {
          playerHeight = Math.ceil(width / ratio);
          current.width(width).height(playerHeight).css({
            left: 0,
            top: (height - playerHeight) / 2
          });
        }
      });
    }
    
  return SlideshowSection;
})();

// CATEGORY SLIDER
theme.collectionView = (function(){
  function collectionView(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id'),
    	sliderSecond = $container.attr('data-section-timeout');
    
    $(document).on('change','#SortBySt',function(e){
		var value = $(this).val();
      	if($("#CollectionFiltersForm").length){
			$("#SortBy").val(value).trigger('change');
        } else {
          if(value.length) {
            window.location.search = 'sort_by='+value;
          } else {
            window.location.href = window.location.href.replace(window.location.search, '');
          }
        }
	});
    
	$(document).on('click', '.change-view', function(e){
      var view = $(this).data('view'),
          currentUrl = document.URL,
          url = new URL(currentUrl);
      url.searchParams.set("type", view); // setting your param
      window.location = url.href;
    });
    $(document).on('change', '.optTag', function(e){
      var URL =  $('.sidebar_tags').data('url'),
          paramString = window.location.search.substring(1),
      	  productFilters = $('input.optTag'),
          newTags = [],
          url = '';

        productFilters.each(function(){
            if($(this).val() && $(this).is(":checked") == true) {
              newTags.push($(this).val());                        
            }
        });
        if(newTags.length){
        	var tags = newTags.join('+');
       		ajaxfilter(URL+'/'+tags+'?'+paramString);
        } else {
          	ajaxfilter(URL+'?'+paramString);
        }
	});
    $(document).on('change', '.flForm .custCheck, .prRange, #SortBy', function(e){
      var URL =  '//'+window.location.hostname+window.location.pathname,
      	formdata = $('#CollectionFiltersForm').serialize();
      //window.location.replace(URL+'?'+formdata);
      ajaxfilter(URL+'?'+formdata);
	});
  	$(document).on('click', 'a.actFilter', function(e){
      e.preventDefault();
      var URL =  '//'+window.location.hostname+$(this).attr('href');
      ajaxfilter(URL);
	});
    $(document).on('click', 'span.actFilter', function(){
      var filter = $(this).attr("data-value");
      $(".filterBox input[value='"+filter+"']").trigger("click");
	});
    $('.flbytags').each(function(){
		var filter = $(this).find("li");
        if(filter.length <= 0){$(this).hide()}
	});
  
  	ajaxfilter = (function(url){
        $.ajax({
          type: 'GET',
          url: url,
          data:{},
          beforeSend:function(){
            $('body').addClass('loading hideOverly');
          },
          complete: function(data){
            var productItems = $('.productList [data-collection-product-items]');
            var nextProductItems = $(".productList [data-collection-product-items]", data.responseText);
            productItems.html(nextProductItems.html());
            productItems.attr('data-collection-bundles-visible', nextProductItems.attr('data-collection-bundles-visible'));
            productItems.closest('.productList')[0].dispatchEvent(new CustomEvent('collection:products-updated'));
            $('.filters-toolbar__product-count').html($(".filters-toolbar__product-count", data.responseText).html());
            
           	$('.sidebar_tags').html($(".sidebar_tags", data.responseText).html());
            $('.active-facets').html($(".active-facets", data.responseText).html());

            $('.pagination').html($(".pagination", data.responseText).html());
            if(!$(".pagination", data.responseText).html()){
              $('.pagination').hide();
            } else {
              $('.pagination').show();
            }
            $('.infinitpaginOuter').html($(".infinitpaginOuter", data.responseText).html());
            if(!$(".infinitpaginOuter", data.responseText).html()){
              $('.infinitpagin').remove();
            }
            if(theme.mlcurrency){ currenciesChange("sapn.money"); }
            $('body').removeClass('loading hideOverly');
            if($('.infinitpagin a.infinite').length){infiniteScroll();}
            loadMoreBtn();

            if($('.prRange').length){ priceSlider(); }
            if($('#sideProdSlider').length && window.themeSwiper){ window.themeSwiper.update($('#sideProdSlider')[0]); }

            history.pushState({page: url}, url, url);
          }
        });
    });

    infiniteScroll = function(){
      	var action = 'scroll load';
        $(window).on(action, function(){
          var moreURL = $('.infinitpagin a').attr('href');
          if($('.infinitpagin a.infinite').length){
            var bottom = $('.infinitpagin').offset();
            var docTop = ($(document).scrollTop() + $(window).height() - 50);
            if( docTop > bottom.top){
              $(window).off(action);
              loadMore(moreURL);
            }
          }
        });
    }
    loadMoreBtn = function(){
        $(document).on('click', '.infinitpagin a.loadMore', function(e){
          	e.preventDefault();
          	var moreURL = $(this).attr('href');
			loadMore(moreURL);
        });
    }
    
    loadMore = function(moreURL) {
      if(moreURL.length){
        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: moreURL,
          beforeSend:function(){
          	if($('.infinitpaginOuter').attr('data-type') == "button" ){
            	$('body').addClass('loading hideOverly');
            } else {
              $('.infinitpagin a').show();
            }
          },
          complete: function (data) {
            $('.productList [data-collection-product-items]').append(
              $(".productList [data-collection-product-items]", data.responseText).children()
            );
            if($(".infinitpagin", data.responseText).html()){
            	$('.infinitpagin').html($(".infinitpagin", data.responseText).html());
            } else {
            	$('.infinitpagin').remove();
            }
			if(theme.mlcurrency){ currenciesChange("sapn.money"); }
            if($('.infinitpagin a.infinite').length){
              infiniteScroll();
            }
            $('body').removeClass('loading hideOverly');
          }
        });
      }
    }
    
    $(document).ready(function(){
      infiniteScroll();loadMoreBtn();
    });
  }
  return collectionView;
})();

theme.instagramSection = (function(){
  function instagramSection(container) {
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id'),
        act = $container.attr('data-act'),
        limit = $container.attr('data-count');
    
    $.ajax({
		url: 'https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+act,
        type: 'GET',
        dataType: "json",
        success: function (res) {
        	var data = res.data,
				igdiv = '#instafeed'+sectionId,
               	html = '',
                bl = bl || true;
			$.each(data, function(index, el){
               if(index >= limit) return 0;
               var img_url = el.thumbnail_url || el.media_url;
               var alt_text = el.caption || 'Instagram image';
               alt_text = alt_text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
               html += '<div class="gitem insta-img"><a rel="nofollow" class="instagram-" href="'+el.permalink+'" target="_blank"><img src="' + img_url + '" alt="' + alt_text + '" class="imgFt" loading="lazy" /></a></div>';
            });
            $(igdiv).html(html);
            var instagramSlider = document.querySelector(igdiv + '[data-theme-swiper]');
            if(instagramSlider && window.themeSwiperPrepare) window.themeSwiperPrepare(instagramSlider);
            if(instagramSlider && window.themeSwiper) window.themeSwiper.update(instagramSlider);
            else if(instagramSlider && window.themeSwiperLoad) window.themeSwiperLoad().then(function(runtime){ runtime.update(instagramSlider); });
		}
	});
  }
  return instagramSection;
})();

theme.slcarousel={};
theme.carousel = (function(){
    function carousel(container) {
        var $container = this.$container = $(container),
          sliders = this.slcarousel = $container.find('[data-theme-swiper]');

    sliders.each(function(){ if(window.themeSwiper) window.themeSwiper.update(this); });
  }
  return carousel;
})();

theme.masonary = (function(){
    function masonary(container){
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          masonary = this.masonary = $($container).find('.grid-masonary');
    
      loadMasonary(masonary);
      setTimeout( function(){ loadMasonary(masonary); },1000);
      function loadMasonary(masonary) {
        $(masonary).masonry({
            columnWidth: '.grid-sizer-'+sectionId,
            itemSelector: '.ms-item',
            percentPosition: true
        });
      }
  }
  return masonary;
})();

if(!customElements.get('before-after')){
    customElements.define('before-after', class BeforeAfter extends HTMLElement {
        constructor(){
            super();
            const imageComparisonSlider = this
            this.init(imageComparisonSlider);
        }
   
  // ================= Performance-optimized slider logic =================
        // The original implementation read offsetTop/offsetHeight on every mousemove
        // causing layout thrash (forced reflows). We now:
        // 1. Cache bounding box & height on pointerdown (single layout read)
        // 2. Throttle pointermove updates with rAF
        // 3. Use transform for thumb positioning (compositor friendly) instead of top
        // 4. Detach listeners promptly to avoid unnecessary work

        init(element){
          this._elements = {
            range: element.querySelector('[data-image-comparison-range]'),
            slider: element.querySelector('[data-image-comparison-slider]'),
            overlay: element.querySelector('[data-image-comparison-overlay]'),
            thumb: element.querySelector('[data-image-comparison-thumb]')
          };

            // Bind methods once
          this._onPointerDown = this._onPointerDown.bind(this);
          this._onPointerMove = this._onPointerMove.bind(this);
          this._onPointerUp = this._onPointerUp.bind(this);
          this.moveSliderRange = this.moveSliderRange.bind(this);

          const { range } = this._elements;
          if (!range) return;

          // Range input (continuous updates)
          range.addEventListener('input', e => this.moveSliderRange(e, element), { passive: true });
          range.addEventListener('change', e => this.moveSliderRange(e, element), { passive: true });

          // Pointer interactions for vertical thumb drag
          range.addEventListener('pointerdown', this._onPointerDown, { passive: true });
          // Keyboard accessibility already works via input events
        }

        setSliderstate(e){
          const { range } = this._elements;
          if (!range) return;
          if (e.type === 'input') {
            range.classList.add('comparison-active');
          } else {
            range.classList.remove('comparison-active');
          }
        }

        moveSliderRange(e, element) {
          const { slider, overlay } = this._elements;
          if (!slider || !overlay) return;
          const value = e.target.value;
          // Use transform instead of left for better perf (avoid layout on each frame)
          slider.style.transform = `translateX(${value}%)`;
          overlay.style.width = `${value}%`;
          this.setSliderstate(e);
        }

        _onPointerDown(e){
          const { range, thumb } = this._elements;
          if (!range || !thumb) return;
          range.setPointerCapture(e.pointerId);
          // Cache metrics (single layout read per interaction)
          const rect = range.getBoundingClientRect();
          this._sliderMetrics = { top: rect.top, height: rect.height };
          this._thumbOffset = 20; // matches previous logic
          this._rafScheduled = false;
          document.addEventListener('pointermove', this._onPointerMove);
          document.addEventListener('pointerup', this._onPointerUp, { once: true });
        }

        _onPointerMove(e){
          if (this._rafScheduled) return;
          this._rafScheduled = true;
          requestAnimationFrame(() => {
            this._rafScheduled = false;
            const { thumb } = this._elements;
            if (!thumb || !this._sliderMetrics) return;
            const relativeY = e.clientY - this._sliderMetrics.top; // 0..height
            const clamped = Math.max(0, Math.min(this._sliderMetrics.height, relativeY));
            const position = clamped - this._thumbOffset;
            // Use translateY to avoid layout; keep a CSS class to position absolute if needed
            thumb.style.transform = `translateY(${position}px)`;
          });
        }

        _onPointerUp(){
          document.removeEventListener('pointermove', this._onPointerMove);
          this._sliderMetrics = null;
        }
    });
}

theme.ajaxCart = function(){

	$(".continue-shopping, .modalOverly, .closeDrawer").click(function(){
        $(".modal").fadeOut(200);
    	$("body").removeClass("loading showOverly");
    });
    
    $(document).on('click','.add-to-cart', function(e){
        e.preventDefault();
        $('body').addClass('loading');
        $(this).next().find('.cartBtn').trigger('click');
    });
    $(document).on('click','.mbCart', function(e){
        e.preventDefault();
        var cartDrawer = document.querySelector('cart-drawer');
        if(cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(this);
        } else {
          $('body').addClass('overflow-hidden').find('.ctdrawer').addClass('active');
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }
    });
    
      $(document).on('click touch', '.quickShop', function(e){
          e.preventDefault(); e.stopImmediatePropagation();
          var url = $(this).attr('href'),
              imgwrapper = $(this).parents('.grid-view-item').find(".gview-img"),
              wrapper = $(this).parents(".grid-view-item").find('.shopWrapper');

          $.ajax({
            url: url+'/?section_id=quick-shop',
            dataType: 'html',
            type: 'GET',
            beforeSend:function(){
              $(imgwrapper).append("<i class='at at-spinner4 at-spin'></i>");
              $(imgwrapper).addClass('showLoading');
            },
            success: function(data){
              $(".shopWrapper").removeClass('active').html("");
              $(wrapper).addClass('active').html(data);
            },
            complete: function(data){
              $(imgwrapper).removeClass('showLoading');
              $(imgwrapper).find('.at-spinner4').remove();
              if(theme.mlcurrency){ currenciesChange(".shopWrapper.active .priceSingle span.money"); }
            }
          });
      });
  
      $(document).on('click touch', '.closeShop', function(e){
        e.preventDefault();
        $(this).parents(".shopWrapper").removeClass("active");
      });

theme.getWishlistActiveIconMarkup = function(idSuffix, animate) {
  if (window.siteWishlistIconStyle === 'heart') {
    return '<i class="at at-heart wishlist-icon wishlist-icon--active' + (animate ? ' wishlist-icon--animate' : '') + '" aria-hidden="true"></i>';
  }

  var suffix = String(idSuffix || 'icon').replace(/[^A-Za-z0-9_-]/g, '-');
  var fillId = 'sunFill-' + suffix;
  var glowId = 'sunGlow-' + suffix;
  var highlightId = 'sunHighlight-' + suffix;
  return '' +
    '<svg class="wishlist-active-icon' + (animate ? ' wishlist-active-icon--animate' : '') + '" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Wishlist active sun" focusable="false">' +
      '<defs>' +
        '<linearGradient id="' + fillId + '" x1="7.2" y1="5.4" x2="24.9" y2="27" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0" stop-color="#ffe06a"/>' +
          '<stop offset=".38" stop-color="#f1be48"/>' +
          '<stop offset="1" stop-color="#f47b20"/>' +
        '</linearGradient>' +
        '<radialGradient id="' + glowId + '" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.2 11.5) rotate(52) scale(12)">' +
          '<stop offset="0" stop-color="#fff7c7"/>' +
          '<stop offset=".4" stop-color="#f1be48"/>' +
          '<stop offset="1" stop-color="#f47b20"/>' +
        '</radialGradient>' +
        '<linearGradient id="' + highlightId + '" x1="11.2" y1="10.2" x2="17.6" y2="17.2" gradientUnits="userSpaceOnUse">' +
          '<stop offset="0" stop-color="#fff8d4" stop-opacity=".95"/>' +
          '<stop offset="1" stop-color="#fff8d4" stop-opacity="0"/>' +
        '</linearGradient>' +
      '</defs>' +
      '<g transform="translate(0 4.2)">' +
        '<path d="M16 1.9L18.05 7.12L23.1 4.68L20.65 9.72L25.9 11.75L20.68 13.8L23.12 18.85L18.08 16.4L16.02 21.65L13.98 16.43L8.9 18.88L11.35 13.82L6.1 11.78L11.32 9.72L8.88 4.68L13.92 7.12L16 1.9Z" fill="url(#' + fillId + ')"/>' +
        '<circle cx="16" cy="11.78" r="6.15" fill="url(#' + glowId + ')"/>' +
        '<circle cx="16" cy="11.78" r="3.85" fill="url(#' + fillId + ')" fill-opacity=".72"/>' +
        '<path class="wishlist-active-icon__highlight" d="M12.85 9.25C13.52 8.54 14.43 8.18 15.58 8.18" stroke="url(#' + highlightId + ')" stroke-width="1.8" stroke-linecap="round"/>' +
      '</g>' +
    '</svg>';
};

theme.getWishlistEmptyIconMarkup = function() {
  if (window.siteWishlistIconStyle === 'heart') {
    return '<i class="at at-heart-l wishlist-icon wishlist-icon--empty" aria-hidden="true"></i>';
  }
  return '<i class="font-awesome-sun-o wishlist-icon wishlist-icon--empty" aria-hidden="true"></i>';
};

theme.renderWishlistActiveIcon = function(button, animate) {
  var node = button && button.jquery ? button[0] : button;
  if (!node) return;

  if (!node.getAttribute('data-wishlist-icon-id')) {
    theme._wishlistIconId = (theme._wishlistIconId || 0) + 1;
    node.setAttribute('data-wishlist-icon-id', theme._wishlistIconId);
  }

  var iconNodes = node.querySelectorAll('img.center-wishlist-icon, .wishlist-icon, svg.wishlist-active-icon, i.at-heart-l, i.at-heart, i.at-circle-notch-r');
  Array.prototype.forEach.call(iconNodes, function(iconNode) {
    iconNode.parentNode.removeChild(iconNode);
  });

  node.insertAdjacentHTML('afterbegin', theme.getWishlistActiveIconMarkup((node.getAttribute('rel') || 'wishlist') + '-' + node.getAttribute('data-wishlist-icon-id'), animate));
};

function getWishlistHandles() {
  var wishlist;
  try {
    wishlist = localStorage.getItem('wishlist');
  } catch (error) {
    wishlist = null;
  }
  if (!wishlist || wishlist === '+') return [];

  return String(wishlist).split('+').filter(function(handle, index, handles) {
    return handle && handles.indexOf(handle) === index;
  });
}

function saveWishlistHandles(handles) {
  try {
    localStorage.setItem('wishlist', handles.length ? '+' + handles.join('+') : '+');
  } catch (error) {
    return;
  }
}

function wishlistButtonsForHandle(handle) {
  return $('.wishlist[rel]').filter(function() {
    return $(this).attr('rel') === handle;
  });
}

function setWishlistButtonActive($buttons, animate) {
  var availableLabel = theme.wlAvailable || 'Added to wishlist';
  $buttons.each(function() {
    var $button = $(this);
    $button.removeClass('addto-wishlist');
    $button.find('.tooltip-label, .msg').text(availableLabel);
    $button.attr('aria-label', availableLabel);
    if ($button.attr('title')) $button.attr('title', availableLabel);
    theme.renderWishlistActiveIcon(this, animate);
  });
}

$(document).on('click', '.addto-wishlist', function(e) {
  e.preventDefault();
  var id = $(this).attr('rel');
  if (!id) return;

  var handles = getWishlistHandles();
  if (handles.indexOf(id) === -1) handles.push(id);
  saveWishlistHandles(handles);
  setWishlistButtonActive(wishlistButtonsForHandle(id), true);

  setTimeout(updateWishlist, 650);
});

function updateWishlist() {
  var handles = getWishlistHandles();
  handles.forEach(function(handle) {
    setWishlistButtonActive(wishlistButtonsForHandle(handle), false);
  });

  if (handles.length) {
    $('.favCount').text(handles.length).removeClass('hide');
  } else {
    $('.favCount').addClass('hide');
  }
}
updateWishlist();
};
window.addEventListener('DOMContentLoaded',function(){$(theme.ajaxCart);});

$(document).ready(function(){
  var sections = theme.getSectionsManager();
  sections.register('header-section', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.collectionView);
  sections.register('productTabs', theme.tabs);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel', theme.carousel);
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
  sections.register('instagram', theme.instagramSection);
});

theme.countdown = function(){
    $(".saleTime, .atCounter").each(function(){
        var $this = $(this), date = $(this).data('date'), countDownDate = new Date(date).getTime();
        var x = setInterval(function(){
            var now = new Date().getTime(),	            
                distance = countDownDate - now,
                days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if(days > 99){
                days = ("00" + days).substr(-3);
            } else {
                days = ("00" + days).substr(-2);
            }
            hours = ("00" + hours).substr(-2);
            minutes = ("00" + minutes).substr(-2);
            seconds = ("00" + seconds).substr(-2);

            $($this).find(".days").html(days);
            $($this).find(".hours").html(hours);
            $($this).find(".minutes").html(minutes);
            $($this).find(".seconds").html(seconds);
            if(distance < 0){clearInterval(x); $($this).hide().parents('.timerl').hide(); }
        }, 1000);
      });
}

theme.init = function(){
  slate.rte.wrapTable();
  slate.rte.iframeReset();
  theme.countdown();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt){
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt){
    evt.preventDefault();
  });
};
$(theme.init);

$(document).ready(function(){
  "use strict";
  
	$(document).on('click', '.currencyOpt', function(i){
      $('#CurrencySelector').val($(this).data('value'));
      $('#localization_form').submit();
    });
    $(document).on('click', '.clOtp', function(i){
      var form = $(this).parents('form');
      $(form).find('.slcrlg').val($(this).data('value'));
      $(form).submit();
    });
  
   // LOOKBOOK SHOP 
	$('.btn-shop').click(function(){
       $('.products .list-columns, .grid-lookbook').removeClass('active');
       $(this).next().addClass('active');
       $(this).parents('.grid-lookbook').addClass('active');
	});
	$('.btn-shop-close').click(function(){     
    	$(this).parent().removeClass('active');
	});

  	// PROMOTION HEADER show-hide
    if(getCookie('promotion') == 'true'){
    	$(".notification-bar").slideUp();
  	}
	$(".close-announcement").click(function(){
		$(".notification-bar").slideUp();
        setCookie('promotion','true',1);
	});
  
// SHOW HIDE PRODUCT Filters

$(document).on('click touch', '.btn-filter, .closeFilter', function() {
    $(".filterbar").toggleClass("active");

    // Move the filter button to the right of the 280px filter menu
    adjustFilterButtonPosition();
});

// Close the filter if a click occurs outside the filter area
$("body").click(function(event) {
    var $target = $(event.target);
    
    // Check if the click was outside the filter or filter button
    if (!$target.parents().is(".sb_filter") && !$target.is(".sb_filter") && !$target.is(".btn-filter")) {
        $(".sb_filter").removeClass("active");
        adjustFilterButtonPosition(); // Reset the button position when the filter closes
    }
});

// Function to adjust the filter button position
function adjustFilterButtonPosition() {
    if ($(".filterbar").hasClass("active")) {
        $("#filter-button").css("left", "280px"); // Position the button to the right of the filter menu
    } else {
        $("#filter-button").css("left", "0"); // Move the button back to its original position
    }
}

// Recheck the state after partial refresh
$(document).ready(function() {
    adjustFilterButtonPosition(); // Ensure button is positioned correctly after page load or partial refresh
});



  /*
  	$(document).on('click touch', '.btn-filter, .closeFilter', function(){
    	$(".filterbar").toggleClass("active");
	});
	$("body").click(function(event ){
    	var $target = $(event.target);
    	if(!$target.parents().is(".sb_filter") && !$target.is(".sb_filter")&& !$target.is(".btn-filter")){
      		$(".sb_filter").removeClass("active");
    	}
	});*/
  
  // STICKY HEADER
/*CC Revision*/
window.onscroll = function() { scrollfunction() };

function scrollfunction(){

  var $header = $('#header');

  // Keep an in-flow spacer equal to the header's natural desktop height before
  // fixing the header. This preserves document geometry as sticky mode starts.
  if (window.innerWidth > 1024) {
    if (theme.fixedHeader) {
      if ($(window).scrollTop() > 145) {
        if (!$header.hasClass('stickyHeader')) {
          $('.stickySpace').css('min-height', $header.outerHeight() || 0);
        }
        $header.addClass('stickyHeader animated fadeInDown');
      } else {
        $header.removeClass('stickyHeader fadeInDown');
        $('.stickySpace').css('min-height', '');
      }
    }
  } else {
    // The mobile header is fixed from first paint. Its CSS-reserved content
    // space must remain unchanged throughout scrolling.
    $header.removeClass('stickyHeader animated fadeInDown');
    $('.stickySpace').css('min-height', '');
  }
    
    /// sticky cart
  var stickyCartht = $(".stickyCart").outerHeight() || 0;

  var mobileBar = 0;
  var rootStyles = window.getComputedStyle ? window.getComputedStyle(document.documentElement) : null;
  if (rootStyles) {
    var toolbarVarName = document.body.classList.contains('mobile-toolbar-compact') ? '--mobile-toolbar-height-compact' : '--mobile-toolbar-height-expanded';
    var toolbarVarValue = rootStyles.getPropertyValue(toolbarVarName);
    if (toolbarVarValue) {
      var parsedToolbarValue = parseFloat(toolbarVarValue);
      if (!isNaN(parsedToolbarValue)) {
        mobileBar = parsedToolbarValue;
      }
    }
  }

  if (mobileBar && !$('.mbtlwraper:visible').length) {
    mobileBar = 0;
  }

  if (!mobileBar) {
    var $mobileToolbar = $('.mbtlwraper:visible').first();
    if ($mobileToolbar.length) {
      var rect = $mobileToolbar[0].getBoundingClientRect();
      if (rect && rect.height) {
        mobileBar = rect.height;
      } else {
        mobileBar = $mobileToolbar.outerHeight() || 0;
      }
    }
  }

  mobileBar = Math.max(0, Math.round(mobileBar * 100) / 100);
  document.documentElement.style.setProperty('--mobile-toolbar-offset', mobileBar + 'px');

    // Add complementary products height (if present) so sticky cart appears after complementary block
    var complementaryHt = 0;
    var $complementary = $(".complementary-products:visible, .complementary:visible");
    if ($complementary.length) {
      // sum heights for all matching complementary blocks (defensive)
      $complementary.each(function(){
        complementaryHt += $(this).outerHeight(true) - 150 || 0;
      });
    }

    // Total offset to consider in padding and bottom positioning
    var totalOffset = mobileBar + complementaryHt;
    // Base scroll threshold plus complementary height (show cart only after clearing complementary area)
    var baseThreshold = 700;
    var showThreshold = baseThreshold + complementaryHt;
    var currentScroll = $(window).scrollTop();

    if(currentScroll > showThreshold && $(".stickyCart").length){
        if(totalOffset){
         // $("body.template-product").css('padding-bottom', stickyCartht + totalOffset);
          $(".stickyCart").slideDown();
          // position sticky cart above mobile bar + complementary block if present
          $(".stickyCart").css('bottom', mobileBar + 'px');
        } else {
         // $("body.template-product").css('padding-bottom', stickyCartht);
          $(".stickyCart").slideDown();
          $(".stickyCart").css('bottom', mobileBar + 'px');
        }
    } else {
        //$("body.template-product").css('padding-bottom','0');
        $(".stickyCart").slideUp();
    }

    // SITE SCROLLER
    if($(window).scrollTop()>200){
      $("#site-scroll").fadeIn();
    } else {
      $("#site-scroll").fadeOut();
    }
}

  // Evaluate sticky cart immediately on load
  scrollfunction();

  // Re-evaluate when complementary content loads dynamically (lazy-loaded)
  if(window.MutationObserver && !window.__stickyCartComplementaryObserver){
    var complementaryObserver = new MutationObserver(function(){
      scrollfunction();
    });

    var observedComplementaryNodes = [];
    var observeComplementaryNode = function(node){
      if(!node || observedComplementaryNodes.indexOf(node) !== -1) return;
      complementaryObserver.observe(node, { childList: true, subtree: true });
      observedComplementaryNodes.push(node);
    };

    document.querySelectorAll('.complementary-products, .related-product').forEach(function(node){
      observeComplementaryNode(node);
    });

    var complementaryMountObserver = new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(addedNode){
          if(!addedNode || addedNode.nodeType !== 1) return;
          if(addedNode.matches && (addedNode.matches('.related-product') || addedNode.matches('.complementary-products'))){
            observeComplementaryNode(addedNode);
            scrollfunction();
          } else if(addedNode.querySelectorAll){
            addedNode.querySelectorAll('.related-product, .complementary-products').forEach(function(foundNode){
              observeComplementaryNode(foundNode);
              scrollfunction();
            });
          }
        });
      });
    });

    complementaryMountObserver.observe(document.body, { childList: true, subtree: true });

    window.__stickyCartComplementaryObserver = {
      complementaryObserver: complementaryObserver,
      complementaryMountObserver: complementaryMountObserver
    };
  }
  
  $("#site-scroll").click(function(){
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  }); 
  
   //Footer links for mobiles
  $(".footer-links .h4").click(function(){
    if($(window).width() < 750){
		var $heading = $(this);
		var opening = !$heading.hasClass('active');
		var $links = $heading.next();
		$heading.toggleClass('active', opening);
		$links.stop(true, false);
		if(opening){
			$links.slideDown(theme.motion.duration);
		} else {
			$links.slideUp(theme.motion.duration);
		}
  	}
  });
  
  $(document).on('click', '.gridSwatches li:not(.noImg)', function(e){
      var $this = $(this),
          newImage = $(this).attr('rel'),
          gridWrapper = $(this).parents('.grid-view-item').find('.gimg-link');
      $(gridWrapper).find('.variantImg').css("background-image", "url('"+newImage+"')");
      var image = document.createElement('img');
          image.src = newImage;
          image.onload = function () {
              $(gridWrapper).addClass("showVariantImg");
              $this.siblings().removeClass("active");
              $this.addClass("active");
          };
      return false;
    });
    $(document).on('click', '.gridSwatches li.numb', function(e){
      $(this).parents('.gridSwatches').find('.hide').removeClass('hide');
      $(this).addClass('hide');
    });

    // Magnific Popup
    $('.mfp-link').magnificPopup({
      delegate: '.mfp',
  	  removalDelay: 300, 
      callbacks: {
        beforeOpen: function(){
          $('.stickyHeader').addClass('popup');
           this.st.mainClass = this.st.el.attr('data-effect');
        },       
      	close:function(){ $('.stickyHeader').removeClass('popup'); }
      },
  	 midClick: true 
	});
});

function htmlDecode(input){
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
document.querySelectorAll('.mtmltxt').forEach(function(item){
    item.innerHTML = htmlDecode(item.innerHTML);
});





class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', false);
      this.setUnavailable();
    } else {
      this.toggleAddButton(false, '', false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
          return this.options[index] === option;
      }).includes(false);
    });
  }
  
  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-opt="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia(){
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`),
          crmedia = $('.primgSlider .is-selected').data('id');
    if(crmedia != `media${this.currentVariant.featured_media.id}` || Shopify.designMode){
        mediaGalleries.forEach((mediaGallery) =>
          mediaGallery.setActiveMedia(`media${this.currentVariant.featured_media.id}`, true)
        );
    }
    
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses(){
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }


  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.classList.toggle('disabled', !availableElement);
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    if($('.stickyCart').length){
        $('.selectedOpt').html(this.currentVariant.title);
        if(this.currentVariant.featured_image != null){
            $('.stickCtImg').attr('src',this.currentVariant.featured_image.src+'&width=50');
        }
    }
    
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const stockLabel = html.getElementById(`stockLabel-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const stockLabelDestination = document.getElementById(`stockLabel-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingSource = html.getElementById(`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const orderQuantityNotesSource = html.getElementById(`Order-Quantity-Notes-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const orderQuantityNotesDestination = document.getElementById(`Order-Quantity-Notes-${this.dataset.section}`);
        const shippingMessageSource = html.getElementById(`ProductShippingMessage-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const shippingMessageDestination = document.getElementById(`ProductShippingMessage-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');
        if (orderQuantityNotesDestination) orderQuantityNotesDestination.classList.remove('hidden');

        if (destination) {
          if (source) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('hidden', source.classList.contains('hidden'));
          } else {
            destination.innerHTML = '';
            destination.classList.add('hidden');
          }
        }
        if (stockLabel && stockLabelDestination) stockLabelDestination.innerHTML = stockLabel.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (orderQuantityNotesSource && orderQuantityNotesDestination) orderQuantityNotesDestination.innerHTML = orderQuantityNotesSource.innerHTML;
        if (shippingMessageSource && shippingMessageDestination) shippingMessageDestination.innerHTML = shippingMessageSource.innerHTML;
        if (skuSource && skuDestination){
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingDestination) {
          if (volumePricingSource) {
            volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
            volumePricingDestination.classList.toggle('hidden', volumePricingSource.classList.contains('hidden'));
          } else {
            volumePricingDestination.innerHTML = '';
            volumePricingDestination.classList.add('hidden');
          }
        }

        if (pricePerItemDestination) {
          if (pricePerItemSource) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
            pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
          } else {
            pricePerItemDestination.innerHTML = '';
            pricePerItemDestination.classList.add('hidden');
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if(price && source && !source.classList.contains('hidden')) price.classList.remove('hidden');
        
        
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if(disable){
      addButton.setAttribute('disabled', 'disabled');
      if(text) addButtonText.textContent = text;
      if($('.backStock').length) checkBackinstock(`${this.currentVariant.id}`);

    } else {
      addButton.removeAttribute('disabled');
      var qty = $(`#pvr-${this.currentVariant.id}`).text();
      if(qty < 1 && this.currentVariant.inventory_management == "shopify" && this.currentVariant.available){
        addButtonText.textContent = window.variantStrings.preOrder;
      } else{
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if($('.backStock').length)$('.backStock').addClass('hide');
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
    const orderQuantityNotes = document.getElementById(`Order-Quantity-Notes-${this.dataset.section}`);
    const shippingMessage = document.getElementById(`ProductShippingMessage-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
    if (orderQuantityNotes) orderQuantityNotes.classList.add('hidden');
    if (shippingMessage) shippingMessage.innerHTML = '';
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);



if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity, 10) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min, 10) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max, 10) : null,
          step: this.input.step ? parseInt(this.input.step, 10) : 1,
        };

        const cartQuantity = Number.isNaN(data.cartQuantity) ? 0 : data.cartQuantity;
        const baseMin = Number.isNaN(data.min) ? 1 : Math.max(data.min, 1);
        const step = Number.isNaN(data.step) ? 1 : Math.max(data.step, 1);
        const max = data.max === null || Number.isNaN(data.max)
          ? null
          : Math.max(data.max - cartQuantity, 1);

        let min = baseMin;
        if (max !== null) min = Math.min(min, max);
        if (cartQuantity >= baseMin) min = Math.max(1, Math.min(min, step));

        this.input.min = min;
        if (max === null) {
          this.input.removeAttribute('max');
        } else {
          this.input.max = max;
        }
        this.input.value = Math.max(min, 1);
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'min', 'max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('.qtyBtn').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback(){
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback(){
    if(this.quantityUpdateUnsubscriber){ this.quantityUpdateUnsubscriber(); }
  }
  onInputChange(event){ this.validateQtyRules(); }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const button = event.currentTarget;
    if(
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true' ||
      button.classList.contains('disabled')
    ) {
      return;
    }
    button.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if(this.input.min) {
      const min = parseInt(this.input.min);
      if(parseInt(this.input.value) < min) {
        this.input.value = min;
      }
    }
    if(this.input.max) {
      const max = parseInt(this.input.max);
      if(parseInt(this.input.value) > max) {
        this.input.value = max;
      }
    }
    if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if(this.input.min) {
      const min = parseInt(this.input.min);
      if(value < min) {
        this.input.value = min;
      }
      const buttonMinus = this.querySelector(".qtyBtn[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(this.input.value) <= min);
    }
    if(this.input.max) {
      const max = parseInt(this.input.max);
      if(value > max) {
        this.input.value = max;
      }
      const buttonPlus = this.querySelector(".qtyBtn[name='plus']");
      buttonPlus.classList.toggle('disabled', parseInt(this.input.value) >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const CONFIGURED_CART_LINE_ID_PATTERN = /^cfg1_[A-Za-z0-9_-]{43}$/;
const CONFIGURED_CART_LINE_QUANTITY_PROPERTY = '_configured_quantity';
const CONFIGURED_CART_LINE_PROTOCOL_PROPERTY = '_configured_protocol';
const CONFIGURED_CART_LINE_EXPIRES_ON_PROPERTY = '_configured_expires_on';
const CONFIGURED_CART_LINE_RECOVERY_PROPERTY = '_configured_recovery';
const CONFIGURED_CART_RECOVERY_ENDPOINT = '/tools/rv/solar-kit-bundle';
const CONFIGURED_CART_LINE_MAX_QUANTITY = 2000;
const CART_QUANTITY_SETTLE_MS = 300;
const PWB_MERGED_CART_LINE_TITLE = 'Customised Pre-Wired Power System Board';
const CONFIGURED_CART_SOURCE_CACHE_PREFIX = 'as-configured-cart-source:v1:';
const CONFIGURED_CART_SOURCE_CACHE_VERSION = 1;
const CONFIGURED_CART_SOURCE_MAX_BYTES = 64 * 1024;
const CONFIGURED_CART_SOURCE_MAX_AGE_MS = 48 * 60 * 60 * 1000;
const CART_TRANSFORM_SIGNATURE_PROPERTY = '_ct_m_s';
const CART_TRANSFORM_PAYLOAD_CHUNK_COUNT_PROPERTY = '_ct_m_c';
const CART_TRANSFORM_PAYLOAD_CHUNK_PREFIX = '_ct_m_';
const CONFIGURED_CART_INTERNAL_FETCH = Symbol('configured-cart-internal-fetch');
let activeConfiguredCartMutation = null;
let cartQuantityMutationGeneration = 0;
let configuredCartNoticeModal = null;
let configuredCartNoticePreviouslyFocused = null;

function getConfiguredCartNoticeFocusableElements() {
  if(!configuredCartNoticeModal) {
    return [];
  }
  const dialog = configuredCartNoticeModal.querySelector('.bundle-kits-modal__dialog');
  if(!dialog) {
    return [];
  }
  return Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
    .filter((element) => !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length));
}

function closeConfiguredCartNoticeModal() {
  if(!configuredCartNoticeModal || configuredCartNoticeModal.hidden) {
    return;
  }

  configuredCartNoticeModal.hidden = true;
  if(!document.querySelector('.bundle-kits-modal:not([hidden])')) {
    document.body.classList.remove('bundle-kits-modal-open');
  }

  const fallbackFocus = document.querySelector('cart-drawer.active .drawer__close');
  const focusTarget = configuredCartNoticePreviouslyFocused?.isConnected
    ? configuredCartNoticePreviouslyFocused
    : fallbackFocus;
  configuredCartNoticePreviouslyFocused = null;
  if(focusTarget && typeof focusTarget.focus === 'function') {
    focusTarget.focus();
  }
}

function handleConfiguredCartNoticeKeydown(event) {
  if(!configuredCartNoticeModal || configuredCartNoticeModal.hidden) {
    return;
  }
  if(event.key === 'Escape') {
    event.preventDefault();
    closeConfiguredCartNoticeModal();
    return;
  }
  if(event.key !== 'Tab') {
    return;
  }

  const focusableElements = getConfiguredCartNoticeFocusableElements();
  if(focusableElements.length === 0) {
    event.preventDefault();
    configuredCartNoticeModal.querySelector('.bundle-kits-modal__dialog')?.focus();
    return;
  }
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];
  if(event.shiftKey && document.activeElement === firstElement) {
    event.preventDefault();
    lastElement.focus();
  } else if(!event.shiftKey && document.activeElement === lastElement) {
    event.preventDefault();
    firstElement.focus();
  }
}

function ensureConfiguredCartNoticeModal() {
  if(configuredCartNoticeModal) {
    return configuredCartNoticeModal;
  }

  configuredCartNoticeModal = document.createElement('div');
  configuredCartNoticeModal.className = 'bundle-kits-modal configured-cart-modal';
  configuredCartNoticeModal.hidden = true;
  configuredCartNoticeModal.innerHTML = '' +
    '<div class="bundle-kits-modal__overlay" data-configured-cart-notice-close></div>' +
    '<div class="bundle-kits-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="configured-cart-notice-title" aria-describedby="configured-cart-notice-message" tabindex="-1">' +
      '<div class="bundle-kits-modal__header">' +
        '<div>' +
          '<p class="bundle-kits-modal__eyebrow" data-configured-cart-notice-eyebrow>Configured cart</p>' +
          '<h2 class="bundle-kits-modal__title" id="configured-cart-notice-title" data-configured-cart-notice-title>Bundle update</h2>' +
        '</div>' +
        '<button type="button" class="bundle-kits-modal__close" data-configured-cart-notice-close aria-label="Close cart message"><i class="at at-times-l" aria-hidden="true"></i></button>' +
      '</div>' +
      '<div class="bundle-kits-modal__body">' +
        '<p class="bundle-kits-modal__status" id="configured-cart-notice-message" data-configured-cart-notice-message></p>' +
        '<div class="configured-cart-modal__actions">' +
          '<button type="button" class="btn btn-md" data-configured-cart-continue>Continue</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(configuredCartNoticeModal);
  configuredCartNoticeModal.addEventListener('click', (event) => {
    if(event.target.closest('[data-configured-cart-notice-close], [data-configured-cart-continue]')) {
      closeConfiguredCartNoticeModal();
    }
  });
  document.addEventListener('keydown', handleConfiguredCartNoticeKeydown);
  return configuredCartNoticeModal;
}

function showConfiguredCartNoticeModal(message, options = {}) {
  const modal = ensureConfiguredCartNoticeModal();
  const messageElement = modal.querySelector('[data-configured-cart-notice-message]');
  const titleElement = modal.querySelector('[data-configured-cart-notice-title]');
  const eyebrowElement = modal.querySelector('[data-configured-cart-notice-eyebrow]');
  const dialog = modal.querySelector('.bundle-kits-modal__dialog');
  const continueButton = modal.querySelector('[data-configured-cart-continue]');
  if(!messageElement || !titleElement || !eyebrowElement || !dialog || !continueButton) {
    throw new Error('The configured cart notice modal is incomplete.');
  }

  configuredCartNoticePreviouslyFocused = document.activeElement instanceof HTMLElement
    ? document.activeElement
    : null;
  eyebrowElement.textContent = options.eyebrow || 'Configured cart';
  titleElement.textContent = options.title || 'Bundle update';
  messageElement.textContent = message;
  modal.hidden = false;
  document.body.classList.add('bundle-kits-modal-open');
  dialog.focus();
}

function isConfiguredCartLine(item) {
  const properties = item?.properties;
  if(!properties || properties.Config === undefined) {
    return false;
  }

  const configId = String(properties.Config || '').trim();
  const configuredQuantityText = String(properties[CONFIGURED_CART_LINE_QUANTITY_PROPERTY] || '').trim();
  const configuredQuantity = /^([1-9]\d{0,3})$/.test(configuredQuantityText)
    ? Number(configuredQuantityText)
    : NaN;
  return (
    CONFIGURED_CART_LINE_ID_PATTERN.test(configId) &&
    Number.isInteger(configuredQuantity) &&
    configuredQuantity <= CONFIGURED_CART_LINE_MAX_QUANTITY
  );
}

function isTransformedBundleCartLine(item) {
  const properties = item?.properties;
  if(properties && properties.Config !== undefined) {
    return true;
  }
  if(
    String(properties?._as_configurable_kit || '').trim() === '1' ||
    String(properties?._as_solar_roof_kit || '').trim() === '1'
  ) {
    return true;
  }
  return (
    String(item?.title || '').trim() === PWB_MERGED_CART_LINE_TITLE ||
    String(item?.product_title || '').trim() === PWB_MERGED_CART_LINE_TITLE
  );
}

function matchesTransformedCartLineIdentity(item, itemKey, configId = '') {
  if(
    !itemKey ||
    String(item?.key || '') !== itemKey ||
    !isTransformedBundleCartLine(item)
  ) {
    return false;
  }
  return !configId || String(item?.properties?.Config || '').trim() === configId;
}

function getEffectiveCartLineQuantity(item) {
  const fallbackQuantity = Number.isInteger(Number(item?.quantity))
    ? Number(item.quantity)
    : 0;
  const properties = item?.properties;
  if(!properties || properties.Config === undefined) {
    return fallbackQuantity;
  }
  if(!isConfiguredCartLine(item)) {
    console.error('[Configured cart] Invalid transformed quantity metadata.', {
      cartLineKey: String(item?.key || ''),
    });
    return fallbackQuantity;
  }

  return Number(item.properties[CONFIGURED_CART_LINE_QUANTITY_PROPERTY]);
}

function getEffectiveCartItemCount(cart) {
  if(!Array.isArray(cart?.items)) {
    return typeof cart?.item_count === 'number' ? cart.item_count : 0;
  }
  return cart.items.reduce((sum, item) => sum + getEffectiveCartLineQuantity(item), 0);
}

function normalizeConfiguredCartSourceItems(items, expectedConfigId) {
  if(!CONFIGURED_CART_LINE_ID_PATTERN.test(expectedConfigId) || !Array.isArray(items) || items.length === 0 || items.length > 24) {
    throw new Error('Configured bundle source items are invalid.');
  }

  let expectedSignature = '';
  let payloadJson = '';
  const normalizedItems = items.map((item) => {
    const idText = String(item?.id ?? '').trim();
    const quantity = Number(item?.quantity);
    const properties = item?.properties;
    if(
      !/^\d+$/.test(idText) ||
      !Number.isSafeInteger(quantity) ||
      quantity <= 0 ||
      quantity > CONFIGURED_CART_LINE_MAX_QUANTITY ||
      !properties ||
      typeof properties !== 'object' ||
      Array.isArray(properties) ||
      String(properties.Config || '').trim() !== expectedConfigId
    ) {
      throw new Error('Configured bundle source item data is invalid.');
    }
    const signature = String(properties[CART_TRANSFORM_SIGNATURE_PROPERTY] || '').trim();
    if(!/^h1\.[A-Za-z0-9_-]{43}$/.test(signature)) {
      throw new Error('Configured bundle source signature is invalid.');
    }
    if(expectedSignature && signature !== expectedSignature) {
      throw new Error('Configured bundle source signatures do not match.');
    }
    expectedSignature = signature;

    const chunkCountText = String(properties[CART_TRANSFORM_PAYLOAD_CHUNK_COUNT_PROPERTY] || '').trim();
    if(chunkCountText) {
      const chunkCount = Number(chunkCountText);
      if(!Number.isSafeInteger(chunkCount) || chunkCount < 1 || chunkCount > 2 || payloadJson) {
        throw new Error('Configured bundle source payload carrier is invalid.');
      }
      const chunks = [];
      for(let index = 0; index < chunkCount; index += 1) {
        const chunk = properties[`${CART_TRANSFORM_PAYLOAD_CHUNK_PREFIX}${index}`];
        if(typeof chunk !== 'string' || !chunk) {
          throw new Error('Configured bundle source payload chunk is missing.');
        }
        chunks.push(chunk);
      }
      payloadJson = chunks.join('');
    }

    return {
      id: Number(idText),
      quantity,
      properties: { ...properties },
    };
  });

  if(!payloadJson || payloadJson.length > 4096) {
    throw new Error('Configured bundle source payload is missing or too large.');
  }
  let payload;
  try {
    payload = JSON.parse(payloadJson);
  } catch(error) {
    throw new Error('Configured bundle source payload is not valid JSON.');
  }
  const expiresOn = Array.isArray(payload) ? String(payload[1] || '').trim() : '';
  if(!/^\d{4}-\d{2}-\d{2}$/.test(expiresOn)) {
    throw new Error('Configured bundle source expiry is invalid.');
  }
  return { expiresOn, items: normalizedItems, payload };
}

function cacheConfiguredCartSourcesFromAddPayload(payload, storage, now = Date.now()) {
  if(!payload || !Array.isArray(payload.items) || !storage) {
    return [];
  }
  const itemsByConfigId = new Map();
  payload.items.forEach((item) => {
    const configId = String(item?.properties?.Config || '').trim();
    if(!CONFIGURED_CART_LINE_ID_PATTERN.test(configId)) {
      return;
    }
    const items = itemsByConfigId.get(configId) || [];
    items.push(item);
    itemsByConfigId.set(configId, items);
  });

  const cachedConfigIds = [];
  itemsByConfigId.forEach((items, configId) => {
    const normalized = normalizeConfiguredCartSourceItems(items, configId);
    const value = JSON.stringify({
      capturedAt: now,
      expiresOn: normalized.expiresOn,
      items: normalized.items,
      version: CONFIGURED_CART_SOURCE_CACHE_VERSION,
    });
    if(new TextEncoder().encode(value).length > CONFIGURED_CART_SOURCE_MAX_BYTES) {
      throw new Error('Configured bundle source cache entry is too large.');
    }
    storage.setItem(`${CONFIGURED_CART_SOURCE_CACHE_PREFIX}${configId}`, value);
    cachedConfigIds.push(configId);
  });
  return cachedConfigIds;
}

function readConfiguredCartSource(configId, shopDate, storage, now = Date.now()) {
  if(!CONFIGURED_CART_LINE_ID_PATTERN.test(configId) || !/^\d{4}-\d{2}-\d{2}$/.test(shopDate) || !storage) {
    throw new Error('Configured bundle cart source request is invalid.');
  }
  const key = `${CONFIGURED_CART_SOURCE_CACHE_PREFIX}${configId}`;
  const rawValue = storage.getItem(key);
  if(!rawValue) {
    throw new Error('This bundle was added before exact cart quantity controls were available. Remove it and add it again once, then the quantity controls will work.');
  }
  let cached;
  try {
    cached = JSON.parse(rawValue);
  } catch(error) {
    storage.removeItem(key);
    throw new Error('The saved configured bundle source is invalid. Remove the bundle and add it again.');
  }
  if(
    cached?.version !== CONFIGURED_CART_SOURCE_CACHE_VERSION ||
    !Number.isSafeInteger(cached.capturedAt) ||
    cached.capturedAt > now + 60_000 ||
    now - cached.capturedAt > CONFIGURED_CART_SOURCE_MAX_AGE_MS
  ) {
    storage.removeItem(key);
    throw new Error('The saved configured bundle source has expired. Remove the bundle and add it again.');
  }
  const normalized = normalizeConfiguredCartSourceItems(cached.items, configId);
  if(normalized.expiresOn !== cached.expiresOn || normalized.expiresOn < shopDate) {
    storage.removeItem(key);
    throw new Error('The signed configured bundle source has expired. Remove the bundle and add it again.');
  }
  return normalized.items;
}

function getConfiguredCartRecoveryMetadata(item) {
  const properties = item?.properties;
  const configId = String(properties?.Config || '').trim();
  const protocolVersion = String(properties?.[CONFIGURED_CART_LINE_PROTOCOL_PROPERTY] || '').trim();
  const expiresOn = String(properties?.[CONFIGURED_CART_LINE_EXPIRES_ON_PROPERTY] || '').trim();
  const recoveryToken = String(properties?.[CONFIGURED_CART_LINE_RECOVERY_PROPERTY] || '').trim();
  if(
    !CONFIGURED_CART_LINE_ID_PATTERN.test(configId) ||
    !/^s(?:13|14)$/.test(protocolVersion) ||
    !/^\d{4}-\d{2}-\d{2}$/.test(expiresOn) ||
    !/^h1\.[A-Za-z0-9_-]{43}$/.test(recoveryToken)
  ) {
    return null;
  }
  return { configId, expiresOn, protocolVersion, recoveryToken };
}

function normalizeConfiguredCartRecoveryResponse(response, previousConfigId, configuredQuantity) {
  if(
    !response ||
    !['refresh_available', 'changed_requires_confirmation'].includes(response.status) ||
    response.configuredQuantity !== configuredQuantity ||
    String(response.previous?.cartConfigId || '') !== previousConfigId ||
    !response.replacement ||
    !CONFIGURED_CART_LINE_ID_PATTERN.test(String(response.replacement.cartConfigId || '')) ||
    response.replacement.cartConfigId === previousConfigId ||
    !Array.isArray(response.replacement.cart?.items)
  ) {
    throw new Error('The configured bundle recovery response is invalid.');
  }
  const replacementConfigId = response.replacement.cartConfigId;
  const normalized = normalizeConfiguredCartSourceItems(
    response.replacement.cart.items,
    replacementConfigId,
  );
  const validity = response.replacement.validity;
  if(
    !validity ||
    !/^s(?:13|14)$/.test(String(validity.protocolVersion || '')) ||
    normalized.expiresOn !== validity.expiresOn ||
    !/^h1\.[A-Za-z0-9_-]{43}$/.test(String(validity.recoveryToken || '')) ||
    normalized.payload[0] !== validity.protocolVersion ||
    normalized.payload[9] !== replacementConfigId ||
    normalized.payload[10] !== validity.recoveryToken
  ) {
    throw new Error('The refreshed configured bundle validity is invalid.');
  }
  return {
    configuredQuantity,
    previous: response.previous,
    replacement: response.replacement,
    sourceItems: normalized.items,
  };
}

async function requestConfiguredCartRecovery(item, configuredQuantity) {
  const metadata = getConfiguredCartRecoveryMetadata(item);
  if(!metadata) {
    throw new Error('This older configured bundle has been kept in the cart, but its exact source is unavailable. Remove and rebuild it only when you are ready.');
  }
  if(!globalThis.crypto || typeof globalThis.crypto.randomUUID !== 'function') {
    throw new Error('This browser cannot create a secure configured cart recovery request.');
  }
  const response = await fetch(CONFIGURED_CART_RECOVERY_ENDPOINT, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      intent: 'recover-cart',
      cartConfigId: metadata.configId,
      recoveryToken: metadata.recoveryToken,
      expiresOn: metadata.expiresOn,
      configuredQuantity,
      clientAttemptId: globalThis.crypto.randomUUID(),
    }),
  });
  const responseText = await response.text();
  let responseBody = null;
  try {
    responseBody = JSON.parse(responseText);
  } catch(error) {
    if(response.ok) {
      throw new Error('The configured bundle recovery service returned invalid JSON.');
    }
  }
  if(!response.ok) {
    const message = typeof responseBody?.message === 'string'
      ? responseBody.message
      : responseText.trim();
    throw new Error(message || `Unable to refresh the configured bundle (HTTP ${response.status}).`);
  }
  return normalizeConfiguredCartRecoveryResponse(
    responseBody,
    metadata.configId,
    configuredQuantity,
  );
}

function getConfiguredCartUnitPriceSnapshot(cart, item) {
  const currencyCode = String(cart?.currency || '').trim();
  const configuredQuantity = getEffectiveCartLineQuantity(item);
  const finalLinePriceCents = item?.final_line_price;
  if(
    !/^[A-Z]{3}$/.test(currencyCode) ||
    !Number.isSafeInteger(configuredQuantity) ||
    configuredQuantity <= 0 ||
    !Number.isSafeInteger(finalLinePriceCents) ||
    finalLinePriceCents < 0
  ) {
    throw new Error('Shopify returned an invalid configured bundle cart price.');
  }
  return {
    currencyCode,
    unitPriceCents: Math.round(finalLinePriceCents / configuredQuantity),
  };
}

function compareConfiguredCartUnitPrices(previous, replacement) {
  // Recovery summaries are rebuilt from catalogue prices and do not carry the
  // buyer-specific B2B context. Compare the verified Storefront cart lines so
  // this follows the same final_line_price basis rendered by the cart.
  return {
    previous,
    replacement,
    priceChanged: (
      previous.currencyCode !== replacement.currencyCode ||
      previous.unitPriceCents !== replacement.unitPriceCents
    ),
  };
}

function formatConfiguredCartPrice(price, taxExclusive) {
  const displayCents = taxExclusive
    ? Math.round(price.unitPriceCents / 1.1)
    : price.unitPriceCents;
  const formatted = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: price.currencyCode,
  }).format(displayCents / 100);
  return taxExclusive ? `${formatted} + GST` : formatted;
}

function formatConfiguredCartRecoveryPriceChange(priceComparison, targetQuantity, taxExclusive) {
  const quantityFormatter = new Intl.NumberFormat(undefined, {
    style: 'decimal',
  });
  const quantityText = targetQuantity === 1
    ? 'The quantity was updated to 1.'
    : `The quantity was updated to ${quantityFormatter.format(targetQuantity)}.`;
  return `The saved bundle price changed from ${formatConfiguredCartPrice(priceComparison.previous, taxExclusive)} to ${formatConfiguredCartPrice(priceComparison.replacement, taxExclusive)} each. Your selections were preserved. ${quantityText} Review the refreshed total before checkout.`;
}

function multiplyConfiguredCartSourceItems(items, multiplier) {
  if(!Number.isSafeInteger(multiplier) || multiplier <= 0 || multiplier > CONFIGURED_CART_LINE_MAX_QUANTITY) {
    throw new Error('The requested configured bundle quantity is invalid.');
  }
  return items.map((item) => {
    const quantity = item.quantity * multiplier;
    if(!Number.isSafeInteger(quantity) || quantity <= 0 || quantity > CONFIGURED_CART_LINE_MAX_QUANTITY) {
      throw new Error('The requested bundle quantity exceeds Shopify\'s signed component limit.');
    }
    return {
      id: item.id,
      quantity,
      properties: { ...item.properties },
    };
  });
}

function planConfiguredCartQuantityChange(currentQuantity, targetQuantity, sourceItems) {
  if(
    !Number.isSafeInteger(currentQuantity) ||
    currentQuantity <= 0 ||
    currentQuantity > CONFIGURED_CART_LINE_MAX_QUANTITY ||
    !Number.isSafeInteger(targetQuantity) ||
    targetQuantity < 0 ||
    targetQuantity > CONFIGURED_CART_LINE_MAX_QUANTITY
  ) {
    throw new Error('The requested configured bundle quantity is invalid.');
  }
  if(targetQuantity === currentQuantity) {
    return { kind: 'noop', items: [] };
  }
  if(targetQuantity === 0) {
    return { kind: 'remove', items: [] };
  }
  if(!Array.isArray(sourceItems) || sourceItems.length === 0) {
    throw new Error('The configured bundle source items are unavailable.');
  }
  if(targetQuantity > currentQuantity) {
    return {
      kind: 'add',
      items: multiplyConfiguredCartSourceItems(
        sourceItems,
        targetQuantity - currentQuantity,
      ),
    };
  }
  return {
    kind: 'replace',
    items: multiplyConfiguredCartSourceItems(sourceItems, targetQuantity),
  };
}

function installConfiguredCartSourceCapture() {
  if(typeof window === 'undefined' || window.__asConfiguredCartSourceCaptureInstalled) {
    return;
  }
  const nativeFetch = window.fetch.bind(window);
  window.fetch = function(resource, init) {
    let cartAddPayload = null;
    let cartAddPayloadPromise = null;
    try {
      const requestUrl = resource instanceof Request ? resource.url : String(resource);
      const url = new URL(requestUrl, window.location.origin);
      const method = String(init?.method || (resource instanceof Request ? resource.method : 'GET')).toUpperCase();
      if(
        method === 'POST' &&
        url.origin === window.location.origin &&
        !init?.[CONFIGURED_CART_INTERNAL_FETCH] &&
        /\/cart\/add(?:\.js)?$/.test(url.pathname)
      ) {
        if(typeof init?.body === 'string') {
          cartAddPayload = JSON.parse(init.body);
        } else if(resource instanceof Request) {
          cartAddPayloadPromise = resource.clone().json();
        }
      }
    } catch(error) {
      console.error('[Configured cart] Unable to capture signed cart source.', error);
    }
    return nativeFetch(resource, init).then((response) => {
      if(!response.ok) {
        return response;
      }
      try {
        if(cartAddPayload) {
          cacheConfiguredCartSourcesFromAddPayload(cartAddPayload, window.sessionStorage);
        } else if(cartAddPayloadPromise) {
          cartAddPayloadPromise.then((payload) => {
            cacheConfiguredCartSourcesFromAddPayload(payload, window.sessionStorage);
          }).catch((error) => {
            console.error('[Configured cart] Unable to capture signed cart source.', error);
          });
        }
      } catch(error) {
        console.error('[Configured cart] Unable to capture signed cart source.', error);
      }
      return response;
    });
  };
  window.__asConfiguredCartSourceCaptureInstalled = true;
}

installConfiguredCartSourceCapture();

function buildSafeCompleteCartUpdates(cartItems, userChangesByKey, itemKeyToQuantity, removedKeys) {
  if(!Array.isArray(cartItems)) {
    throw new Error('Shopify returned invalid cart items for the cart update.');
  }
  if(!(userChangesByKey instanceof Map) || !(itemKeyToQuantity instanceof Map) || !(removedKeys instanceof Set)) {
    throw new Error('Cart quantity tracking is invalid.');
  }

  const cartItemsByKey = new Map();
  cartItems.forEach((item) => {
    if(!item || !item.key || !item.variant_id) {
      throw new Error('Shopify returned a cart line without a stable key.');
    }
    cartItemsByKey.set(`${item.variant_id}:${item.key}`, item);
  });

  userChangesByKey.forEach((quantity, itemKey) => {
    if(!Number.isSafeInteger(quantity) || quantity < 0) {
      throw new Error('A cart quantity update is invalid.');
    }
    const item = cartItemsByKey.get(itemKey);
    if(item && isTransformedBundleCartLine(item) && quantity !== 0) {
      throw new Error('Configured bundle quantities cannot be changed from the cart. Remove the bundle and add it again with the required quantity.');
    }
  });

  userChangesByKey.forEach((quantity, itemKey) => {
    itemKeyToQuantity.set(itemKey, quantity);
    if(quantity === 0) {
      removedKeys.add(itemKey);
    }
  });

  cartItems.forEach((item) => {
    if(isTransformedBundleCartLine(item)) {
      return;
    }
    const itemKey = `${item.variant_id}:${item.key}`;
    if(!itemKeyToQuantity.has(itemKey)) {
      itemKeyToQuantity.set(
        itemKey,
        removedKeys.has(itemKey) ? 0 : getEffectiveCartLineQuantity(item),
      );
    }
  });

  const updates = {};
  cartItems.forEach((item) => {
    const itemKey = `${item.variant_id}:${item.key}`;
    if(isTransformedBundleCartLine(item)) {
      if(userChangesByKey.get(itemKey) === 0) {
        updates[item.key] = 0;
      }
      return;
    }
    if(!itemKeyToQuantity.has(itemKey)) {
      throw new Error('A cart line is missing its tracked quantity.');
    }
    updates[item.key] = itemKeyToQuantity.get(itemKey);
  });
  return updates;
}

function collapseCartUpdateQueue(updateQueue) {
  if(!Array.isArray(updateQueue)) {
    throw new Error('The cart update queue is invalid.');
  }
  const updatesByKey = new Map();
  updateQueue.forEach((update) => {
    const itemKey = String(update?.key || '').trim();
    const quantity = Number(update?.quantity);
    if(!itemKey || !Number.isSafeInteger(quantity) || quantity < 0) {
      throw new Error('A queued cart quantity update is invalid.');
    }
    updatesByKey.set(itemKey, quantity);
  });
  return updatesByKey;
}

function buildPendingCartQuantityUpdates(activeUpdates, updateQueue) {
  if(!(activeUpdates instanceof Map)) {
    throw new Error('Active cart quantity updates are invalid.');
  }
  const pendingUpdates = new Map(activeUpdates);
  collapseCartUpdateQueue(updateQueue).forEach((quantity, itemKey) => {
    pendingUpdates.set(itemKey, quantity);
  });
  return pendingUpdates;
}

function getConfirmedRemovedCartLineKeys(cartItems, removedKeys) {
  if(!Array.isArray(cartItems) || !(removedKeys instanceof Set)) {
    throw new Error('Cart removal confirmation data is invalid.');
  }
  const serverKeys = new Set(cartItems.map((item) => {
    if(!item?.key || !item?.variant_id) {
      throw new Error('Shopify returned a cart line without a stable key.');
    }
    return `${item.variant_id}:${item.key}`;
  }));
  return new Set(Array.from(removedKeys).filter((itemKey) => !serverKeys.has(itemKey)));
}

function assertCartQuantityUpdatesApplied(cartItems, userChangesByKey) {
  if(!Array.isArray(cartItems) || !(userChangesByKey instanceof Map)) {
    throw new Error('Cart quantity verification data is invalid.');
  }
  const cartItemsByKey = new Map(cartItems.map((item) => {
    if(!item?.key || !item?.variant_id) {
      throw new Error('Shopify returned a cart line without a stable key.');
    }
    return [`${item.variant_id}:${item.key}`, item];
  }));

  userChangesByKey.forEach((expectedQuantity, itemKey) => {
    const item = cartItemsByKey.get(itemKey);
    if(expectedQuantity === 0) {
      if(item) {
        throw new Error('Shopify did not confirm removal of a cart line.');
      }
      return;
    }
    if(!item) {
      throw new Error('Shopify removed a cart line while its quantity was being updated.');
    }
    const actualQuantity = getEffectiveCartLineQuantity(item);
    if(actualQuantity !== expectedQuantity) {
      throw new Error(`Shopify returned cart quantity ${actualQuantity}; expected ${expectedQuantity}.`);
    }
  });
}

function throttle(fn, delay){
  let lastCall = 0;
  return function (...args){
    const now = new Date().getTime();
    if(now - lastCall < delay){
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json'){
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if(elementToFocus) elementToFocus.focus();
}

var trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  if(!container) {
    if(elementToFocus && typeof elementToFocus.focus === 'function') {
      elementToFocus.focus();
    }
    return;
  }
  var elements = getFocusableElements(container);
  if(!elements.length) {
    if(elementToFocus && typeof elementToFocus.focus === 'function') {
      elementToFocus.focus();
    }
    return;
  }
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (e) => {
    if( e.target !== container && e.target !== last && e.target !== first )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function(){
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(e) {
    if(e.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if(e.target === last && !e.shiftKey) {
      e.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if((e.target === container || e.target === first) && e.shiftKey){
      e.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
  if(elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value){
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      e.preventDefault();
      var cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      var fallbackLink = this.querySelector('a[href]');

      if(!cartItems){
        if(fallbackLink){ window.location.href = fallbackLink.href; }
        return;
      }

      var removalPromise = cartItems.updateQuantity(this.dataset.index, 0);

      if(removalPromise && typeof removalPromise.catch === 'function'){
        removalPromise.catch(function(){
          if(fallbackLink){ window.location.href = fallbackLink.href; }
        });
      }
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    // Queue system for handling rapid quantity updates.
    this.updateQueue = []; // Queue of { key, quantity, name, variantId, line }
    this.activeQueueChanges = new Map();
    this.pendingQuantityChanges = new Map();
    this.isProcessingQueue = false;
    this.itemKeyToQuantity = new Map(); // Track by composite item key: variantId:key (persistent across line number changes)
    this.removedKeys = new Set(); // Track composite keys that user explicitly removed (never re-add these)

    this.addEventListener('change', this.onChange.bind(this));
    this.addEventListener('keydown', this.onCartQuantityKeyDown.bind(this));
    this.addEventListener('submit', this.onCartFormSubmit.bind(this));
  }
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if(event.source === 'cart-items') {
        return;
      }
      // If the event came from product-form (add to cart), skip onCartUpdate
      // because renderContents() already handles the update with the server response
      if(event.source === 'product-form') {
        return;
      }
      // Use debounced update to prevent multiple rapid calls
      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => {
        this.onCartUpdate();
      }, 100);
    });
  }

  disconnectedCallback() {
    if(this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    clearTimeout(this.updateTimeout);
    this.pendingQuantityChanges.forEach((change) => clearTimeout(change.timer));
    this.pendingQuantityChanges.clear();
  }

  onChange(event) {
    const input = event.target;
    if(!input || !input.dataset || !input.dataset.index) {
      return;
    }

    const activeElementName = document.activeElement && typeof document.activeElement.getAttribute === 'function'
      ? document.activeElement.getAttribute('name')
      : input.getAttribute('name');

    this.scheduleQuantityChange(input, activeElementName);
  }

  scheduleQuantityChange(input, name) {
    const itemKey = `${String(input.dataset.variantId || '').trim()}:${String(input.dataset.key || '').trim()}`;
    const quantityText = String(input.value ?? '').trim();
    const quantity = /^\d+$/.test(quantityText) ? Number(quantityText) : NaN;
    const line = Number(input.dataset.index);
    if(
      !input.dataset.variantId ||
      !input.dataset.key ||
      !Number.isSafeInteger(quantity) ||
      quantity < 0 ||
      !Number.isSafeInteger(line) ||
      line <= 0
    ) {
      this.updateLiveRegions(line, 'Enter a valid cart quantity.');
      return;
    }
    if(
      input.dataset.transformedCartLine === 'true' &&
      quantity > CONFIGURED_CART_LINE_MAX_QUANTITY
    ) {
      input.value = String(input.dataset.transformedQuantity || 1);
      this.updateLiveRegions(line, 'Configured bundle quantity cannot exceed 2000.');
      return;
    }

    const previousChange = this.pendingQuantityChanges.get(itemKey);
    if(previousChange) {
      clearTimeout(previousChange.timer);
    }

    cartQuantityMutationGeneration += 1;
    const pendingChange = {
      itemKey,
      line,
      name,
      quantity,
      timer: null,
    };
    pendingChange.timer = setTimeout(() => {
      this.flushPendingQuantityChange(itemKey, pendingChange);
    }, CART_QUANTITY_SETTLE_MS);
    this.pendingQuantityChanges.set(itemKey, pendingChange);
    this.showSpinnerForItemKey(itemKey);
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  async flushPendingQuantityChange(itemKey, pendingChange) {
    if(this.pendingQuantityChanges.get(itemKey) !== pendingChange) {
      return;
    }

    if(activeConfiguredCartMutation) {
      try {
        await activeConfiguredCartMutation;
      } catch(error) {
        // The earlier mutation already surfaced its own error. This exact
        // pending intent is still validated against the refreshed cart below.
      }
    }
    if(this.pendingQuantityChanges.get(itemKey) !== pendingChange) {
      return;
    }

    const input = this.findCartQuantityInput(itemKey);
    if(!input) {
      this.pendingQuantityChanges.delete(itemKey);
      this.hideSpinnerForItemKey(itemKey);
      this.updateLiveRegions(
        pendingChange.line,
        'The cart line changed before its quantity could be updated. Refresh the cart and try again.',
      );
      return;
    }

    this.pendingQuantityChanges.delete(itemKey);
    const updatePromise = this.updateQuantity(
      input.dataset.index,
      pendingChange.quantity,
      pendingChange.name,
      input.dataset.quantityVariantId,
    );
    if(updatePromise && typeof updatePromise.catch === 'function') {
      updatePromise.catch(() => {
        this.hideSpinnerForItemKey(itemKey);
      });
    }
  }

  onCartQuantityKeyDown(event) {
    const input = document.activeElement;
    if(
      event.key !== 'Enter' ||
      !input?.dataset ||
      input.dataset.transformedCartLine !== 'true'
    ) {
      return;
    }
    event.preventDefault();
    input.blur();
  }

  onCartFormSubmit(event) {
    if(event.submitter?.name === 'checkout') {
      return;
    }
    if(!event.target.querySelector('[data-transformed-cart-line="true"]')) {
      return;
    }
    event.preventDefault();
    const input = document.activeElement;
    if(input?.dataset?.index && typeof input.blur === 'function') {
      input.blur();
    }
  }
  
  // Process queued updates - response-driven, no timers
  async processQueue() {
    if(this.isProcessingQueue) {
      return; // Already processing, new items will be picked up in next cycle
    }
    
    if(this.updateQueue.length === 0) {
      return;
    }
    
    this.isProcessingQueue = true;

    // Snapshot the queue. Changes that arrive during the request stay queued
    // and remain visible until the next response-driven cycle.
    const queueSnapshot = [...this.updateQueue];
    this.updateQueue = [];
    let userChangesByKey = new Map();
    let startingQuantitiesByKey = new Map();
    let shopifyUpdateSucceeded = false;

    try {
      userChangesByKey = collapseCartUpdateQueue(queueSnapshot);
      this.activeQueueChanges = new Map(userChangesByKey);
      userChangesByKey.forEach((_quantity, itemKey) => {
        this.showSpinnerForItemKey(itemKey);
      });

      const cartResponse = await fetch(`${routes.cart_url}.js`);
      if(!cartResponse.ok) {
        throw new Error(`Unable to load the cart before updating it (HTTP ${cartResponse.status}).`);
      }
      const cartData = await cartResponse.json();
      if(!Array.isArray(cartData?.items)) {
        throw new Error('Shopify returned invalid cart data before the quantity update.');
      }
      startingQuantitiesByKey = new Map(cartData.items.map((item) => (
        [`${item.variant_id}:${item.key}`, getEffectiveCartLineQuantity(item)]
      )));

      // Ordinary lines retain complete-cart batching. Configured merge wrappers
      // are omitted unless the customer explicitly removes one with quantity 0.
      const parsedState = await this.sendCompleteCartUpdate(userChangesByKey, cartData);
      shopifyUpdateSucceeded = true;

      // A full items refresh is required only for an explicitly removed line
      // that Shopify confirms is absent. Comparing server items with every cart
      // surface in the DOM incorrectly double-counts cart-page + drawer lines.
      const confirmedRemovedKeys = getConfirmedRemovedCartLineKeys(
        parsedState.items,
        this.removedKeys,
      );
      confirmedRemovedKeys.forEach((itemKey) => {
        this.itemKeyToQuantity.delete(itemKey);
        this.removedKeys.delete(itemKey);
      });

      if(parsedState.sections) {
        this.updateCartFromSections(parsedState.sections, confirmedRemovedKeys.size > 0);
      }

      // A legitimate removal replaces item markup and can renumber lines.
      // Restore every active/queued value and spinner by stable Shopify key.
      this.restorePendingCartFeedback();
    } catch(error) {
      const firstChangedLine = Number(queueSnapshot[0]?.line);
      if(Number.isSafeInteger(firstChangedLine) && firstChangedLine > 0) {
        this.updateLiveRegions(
          firstChangedLine,
          error && error.message ? error.message : 'Unable to update the cart.',
        );
      }
      console.error('[Cart queue] Cart quantity update failed.', {
        changedLineCount: userChangesByKey.size,
        reason: error && error.message ? error.message : 'Unknown cart update error.',
      });
    } finally {
      const queuedChanges = collapseCartUpdateQueue(this.updateQueue);
      this.activeQueueChanges = new Map();
      userChangesByKey.forEach((_quantity, itemKey) => {
        if(!shopifyUpdateSucceeded && !queuedChanges.has(itemKey)) {
          const input = this.findCartQuantityInput(itemKey);
          const startingQuantity = startingQuantitiesByKey.get(itemKey);
          if(input && Number.isSafeInteger(startingQuantity)) {
            input.value = String(startingQuantity);
          }
        }
        if(!queuedChanges.has(itemKey)) {
          this.hideSpinnerForItemKey(itemKey);
        }
      });
      this.restorePendingCartFeedback();
      this.isProcessingQueue = false;
    }

    // If new items were added during processing, start a new batch immediately
    if(this.updateQueue.length > 0) {
      return this.processQueue();
    }
  }

  findCartQuantityInput(itemKey) {
    return Array.from(this.querySelectorAll('input.quantity__input[data-key][data-variant-id]'))
      .find((input) => `${input.dataset.variantId}:${input.dataset.key}` === itemKey) || null;
  }

  showSpinnerForItemKey(itemKey) {
    const input = this.findCartQuantityInput(itemKey);
    const spinner = input?.closest('.cart-item__quantity-wrapper, .cquantity')?.querySelector('.loading__spinner');
    if(spinner) {
      spinner.classList.remove('hidden');
    }
  }

  hideSpinnerForItemKey(itemKey) {
    const input = this.findCartQuantityInput(itemKey);
    const spinner = input?.closest('.cart-item__quantity-wrapper, .cquantity')?.querySelector('.loading__spinner');
    if(spinner) {
      spinner.classList.add('hidden');
    }
  }

  restorePendingCartFeedback() {
    buildPendingCartQuantityUpdates(this.activeQueueChanges, this.updateQueue)
      .forEach((quantity, itemKey) => {
        const input = this.findCartQuantityInput(itemKey);
        if(!input) {
          return;
        }
        input.value = String(quantity);
        this.showSpinnerForItemKey(itemKey);
      });
  }
  
  // Send a complete update for ordinary lines while omitting untouched
  // configured merge wrappers. Positive quantities multiply a linesMerge
  // wrapper's current source BOM, so only an explicit zero is safe here.
  async sendCompleteCartUpdate(userChangesByKey, cartData) {
    const nextItemKeyToQuantity = new Map(this.itemKeyToQuantity);
    const nextRemovedKeys = new Set(this.removedKeys);
    const updatesObject = buildSafeCompleteCartUpdates(
      cartData && cartData.items,
      userChangesByKey,
      nextItemKeyToQuantity,
      nextRemovedKeys,
    );

    const body = JSON.stringify({
      updates: updatesObject,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_update_url}.js`, { 
        ...fetchConfig(), 
        ...{ body } 
      });
      
      if(!response.ok) {
        const errorText = await response.text();
        let errorMessage = 'Cart update failed';
        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorJson.description || errorMessage;
        } catch(e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }
      
      const state = await response.text();
      const parsedState = JSON.parse(state);
      
  const effectiveCount = getEffectiveCartItemCount(parsedState);
      
      if(parsedState.errors) {
        throw new Error(parsedState.errors);
      }

      assertCartQuantityUpdatesApplied(parsedState.items, userChangesByKey);

      // Commit local cart tracking only after Shopify persisted the update.
      this.itemKeyToQuantity = nextItemKeyToQuantity;
      this.removedKeys = nextRemovedKeys;
      
      // Basic state updates
  this.classList.toggle('is-empty', effectiveCount === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      
      if(cartFooter) cartFooter.classList.toggle('is-empty', effectiveCount === 0);
      if(cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', effectiveCount === 0);

      updateCartDrawerCountDisplay(effectiveCount);
      if(effectiveCount === 0) {
        refreshCartDrawerSection();
      }

      // Publish update event
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
      
      return parsedState;
    } catch(error) {
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if(errors && window.cartStrings && window.cartStrings.error){ 
        errors.textContent = window.cartStrings.error; 
      }
      throw error;
    }
  }
  
  // Execute bulk update using /cart/update.js with line item keys
  async executeBulkUpdateByLineKeys(updates) {
    if(updates.length === 0) return;
    
    // First, get current cart to get line item keys
    const cartResponse = await fetch(`${routes.cart_url}.js`);
    const cartData = await cartResponse.json();
    
    // Build updates object using line item keys: { "key1": 5, "key2": 0, "key3": 10 }
    const updatesObject = {};
    updates.forEach(update => {
      const lineIndex = parseInt(update.line) - 1; // Convert to 0-based index
      const item = cartData.items[lineIndex];
      if(item && item.key) {
        const quantity = parseInt(update.quantity);
        if(isTransformedBundleCartLine(item) && quantity !== 0) {
          throw new Error('Configured bundle quantities cannot be changed from the cart. Remove the bundle and add it again with the required quantity.');
        }
        updatesObject[item.key] = quantity;
      }
    });
    
    const body = JSON.stringify({
      updates: updatesObject,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_update_url}.js`, { 
        ...fetchConfig(), 
        ...{ body } 
      });
      
      if(!response.ok) {
        const errorText = await response.text();
        let errorMessage = 'Cart bulk update failed';
        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorJson.description || errorMessage;
        } catch(e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }
      
      const state = await response.text();
      const parsedState = JSON.parse(state);

      const effectiveCount = getEffectiveCartItemCount(parsedState);

      if(parsedState.errors) {
        throw new Error(parsedState.errors);
      }
      
      // Basic state updates
      this.classList.toggle('is-empty', effectiveCount === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      
      if(cartFooter) cartFooter.classList.toggle('is-empty', effectiveCount === 0);
      if(cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', effectiveCount === 0);

      updateCartDrawerCountDisplay(effectiveCount);
      if(effectiveCount === 0) {
        refreshCartDrawerSection();
      }

      // Publish update event
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
      
      return parsedState;
    } catch(error) {
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if(errors && window.cartStrings && window.cartStrings.error){ 
        errors.textContent = window.cartStrings.error; 
      }
      throw error;
    }
  }
  
  // Update cart using sections from /cart/change.js response
  updateCartFromSections(sections, fullRefresh = false) {
    // If fullRefresh, update entire cart HTML (for removals)
    // Otherwise, update ONLY footer/totals from sections
    
    if(fullRefresh) {
      if(this.tagName === 'CART-DRAWER-ITEMS'){
        const footerSection = sections['cart-drawer'];
        if(footerSection) {
          const html = new DOMParser().parseFromString(footerSection, 'text/html');
          
          // Update entire cart-drawer-items content
          const sourceItems = html.querySelector('cart-drawer-items');
          if(sourceItems) {
            this.innerHTML = sourceItems.innerHTML;
          }

          // Update footer as well during full refresh
          const sourceFooter = html.querySelector('.cart-drawer__footer');
          const targetFooter = document.querySelector('.cart-drawer__footer');
          if(sourceFooter && targetFooter) {
            targetFooter.innerHTML = sourceFooter.innerHTML;
            updateAllPricesWithGST('.cart-drawer__footer');
          }
        }
      } else {
        // For the main cart page, replace the complete server-rendered items
        // region. Empty-cart section responses intentionally omit the table,
        // so updating tbody alone leaves the removed rows visible.
        const mainCartItems = document.getElementById('main-cart-items');
        const sectionId = mainCartItems?.dataset?.id;
        const cartSection = sections[sectionId];
        
        if(cartSection) {
          const html = new DOMParser().parseFromString(cartSection, 'text/html');

          const sourceContents = html.querySelector('#main-cart-items .js-contents');
          const targetContents = mainCartItems?.querySelector('.js-contents');

          if(sourceContents && targetContents) {
            targetContents.innerHTML = sourceContents.innerHTML;
          }
        }
        
        // Also update the footer
        const mainCartFooter = document.getElementById('main-cart-footer');
        const footerSectionId = mainCartFooter?.dataset?.id;
        const footerSection = sections[footerSectionId];
        
        if(footerSection) {
          const html = new DOMParser().parseFromString(footerSection, 'text/html');
          const sourceFooter = html.querySelector('.cartTotal');
          const targetFooter = document.querySelector('.cartTotal');
          
          if(sourceFooter && targetFooter) {
            targetFooter.innerHTML = sourceFooter.innerHTML;
            updateAllPricesWithGST('.cartTotal');
          }
        }
      }
      return;
    }
    
    // Normal update - footer and line item totals
    // DO NOT sync quantities here - they're synced from items array (more reliable)
    if(this.tagName === 'CART-DRAWER-ITEMS'){
      // For cart drawer, update footer and line item totals
      const footerSection = sections['cart-drawer'];
      if(footerSection) {
        const html = new DOMParser().parseFromString(footerSection, 'text/html');
        
        // Update footer
        const sourceFooter = html.querySelector('.cart-drawer__footer');
        const targetFooter = document.querySelector('.cart-drawer__footer');
        if(sourceFooter && targetFooter) {
          targetFooter.innerHTML = sourceFooter.innerHTML;
          updateAllPricesWithGST('.cart-drawer__footer');
        }

        // Update line item totals
        html.querySelectorAll('.cart-item').forEach((sourceItem) => {
          const targetItem = this.querySelector(`#${sourceItem.id}`);
          if(targetItem) {
            const sourceTotal = sourceItem.querySelector('.cart-item__totals');
            const targetTotal = targetItem.querySelector('.cart-item__totals');
            if(sourceTotal && targetTotal) {
              targetTotal.innerHTML = sourceTotal.innerHTML;
              updateAllPricesWithGST(`#${sourceItem.id} .cart-item__totals`);
            }
          }
        });
      }
    } else {
      // For main cart page, update footer and line item totals
      const sectionId = document.getElementById('main-cart-footer')?.dataset?.id;
      const footerSection = sections[sectionId];
      if(footerSection) {
        const html = new DOMParser().parseFromString(footerSection, 'text/html');
        
        // Update footer
        const sourceFooter = html.querySelector('.cartTotal');
        const targetFooter = document.querySelector('.cartTotal');
        if(sourceFooter && targetFooter) {
          targetFooter.innerHTML = sourceFooter.innerHTML;
          updateAllPricesWithGST('.cartTotal');
        }
      }

      // Update line item totals from main-cart-items section
      const itemsSectionId = document.getElementById('main-cart-items')?.dataset?.id;
      const itemsSection = sections[itemsSectionId];
      if(itemsSection) {
        const html = new DOMParser().parseFromString(itemsSection, 'text/html');
        html.querySelectorAll('.cart-item').forEach((sourceItem) => {
          const targetItem = this.querySelector(`#${sourceItem.id}`);
          if(targetItem) {
            const updatedPriceWrappers = this.syncCartItemFragments(targetItem, sourceItem, '.cart__price-wrapper');
            const updatedTotals = this.syncCartItemFragments(targetItem, sourceItem, '.cart-totals');

            if(updatedPriceWrappers || updatedTotals) {
              updateAllPricesWithGST(`#${sourceItem.id}`);
            }
          }
        });
      }
    }
  }

  syncCartItemFragments(targetItem, sourceItem, selector) {
    const sourceFragments = Array.from(sourceItem.querySelectorAll(selector));
    const targetFragments = Array.from(targetItem.querySelectorAll(selector));

    if(!sourceFragments.length || !targetFragments.length) {
      return false;
    }

    let updated = false;

    targetFragments.forEach((targetFragment, index) => {
      const sourceFragment = sourceFragments[index];
      if(!sourceFragment) {
        return;
      }

      targetFragment.innerHTML = sourceFragment.innerHTML;
      updated = true;
    });

    return updated;
  }
  
  // Refresh cart with final accurate state after queue completes
  async refreshCartAfterQueue() {
    try {
      // Add cache-busting timestamp to ensure fresh data
      const cacheBuster = `&_=${Date.now()}`;
      
      if(this.tagName === 'CART-DRAWER-ITEMS'){
        const response = await fetch(`${routes.cart_url}?section_id=cart-drawer${cacheBuster}`);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if(targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
            if(selector === '.cart-drawer__footer') {
              updateAllPricesWithGST('.cart-drawer__footer');
            }
          }
        }
      } else {
        const sectionId = document.getElementById('main-cart-items')?.dataset?.id;
        if(sectionId) {
          const response = await fetch(`${routes.cart_url}?section_id=${sectionId}${cacheBuster}`);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          if(sourceQty) {
            this.innerHTML = sourceQty.innerHTML;
            // Recalculate GST prices after replacing content
            updateAllPricesWithGST('.cartTotal');
          }
        }
      }
    } catch(e) {
      console.error('Error refreshing cart:', e);
    }
  }
    
  onCartUpdate(){
    // Skip if we have an active fetch in progress
    if(this.activeUpdatePromise) {
      return;
    }
    
    if(this.tagName === 'CART-DRAWER-ITEMS'){
      this.activeUpdatePromise = fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if(targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
              if(selector === '.cart-drawer__footer') {
                updateAllPricesWithGST('.cart-drawer__footer');
              }
            }
          }
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.activeUpdatePromise = null;
        });
    } else {
      const sectionId = document.getElementById('main-cart-items')?.dataset?.id;
      if(sectionId) {
        this.activeUpdatePromise = fetch(`${routes.cart_url}?section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            if(sourceQty) {
              this.innerHTML = sourceQty.innerHTML;
              updateAllPricesWithGST('.cartTotal');
            }
          }).catch((e) => {
            console.error(e);
          }).finally(() => {
            this.activeUpdatePromise = null;
          });
      }
    }
  }
    
  getSectionsToRender(){
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cartTotal',
      }
    ];
  }

  async loadVerifiedStorefrontCart() {
    const response = await fetch(`${routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if(!response.ok) {
      throw new Error(`Unable to inspect the cart (HTTP ${response.status}).`);
    }
    const cart = await response.json();
    if(!cart || !Array.isArray(cart.items)) {
      throw new Error('Shopify returned an invalid cart response.');
    }
    return cart;
  }

  findConfiguredCartLine(cart, configId) {
    const matches = cart.items.filter((item) => (
      isTransformedBundleCartLine(item) &&
      String(item?.properties?.Config || '').trim() === configId
    ));
    if(matches.length !== 1) {
      throw new Error(
        matches.length === 0
          ? 'The configured bundle is no longer present in the cart.'
          : 'The cart contains duplicate lines for this configured bundle.',
      );
    }
    return matches[0];
  }

  async postConfiguredCartMutation(url, body, fallbackMessage) {
    const requestInit = {
      ...fetchConfig(),
      body: JSON.stringify({
        ...body,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
      credentials: 'same-origin',
    };
    requestInit[CONFIGURED_CART_INTERNAL_FETCH] = true;
    const response = await fetch(url, requestInit);
    if(!response.ok) {
      const responseText = await response.text();
      let message = fallbackMessage;
      try {
        const responseJson = JSON.parse(responseText);
        message = responseJson.description || responseJson.message || message;
      } catch(error) {
        if(responseText.trim()) {
          message = responseText.trim();
        }
      }
      throw new Error(message);
    }
    const cartResponse = await response.json();
    if(!cartResponse || typeof cartResponse !== 'object') {
      throw new Error('Shopify returned an invalid configured cart mutation response.');
    }
    return cartResponse;
  }

  async verifyConfiguredCartQuantity(configId, expectedQuantity) {
    const cart = await this.loadVerifiedStorefrontCart();
    const matches = cart.items.filter((item) => (
      isTransformedBundleCartLine(item) &&
      String(item?.properties?.Config || '').trim() === configId
    ));
    if(expectedQuantity === 0) {
      if(matches.length !== 0) {
        throw new Error('Shopify did not confirm removal of the configured bundle.');
      }
      return cart;
    }
    if(matches.length !== 1) {
      throw new Error('Shopify did not return exactly one matching configured bundle line.');
    }
    const quantity = getEffectiveCartLineQuantity(matches[0]);
    if(quantity !== expectedQuantity) {
      throw new Error(`Shopify returned configured quantity ${quantity}; expected ${expectedQuantity}.`);
    }
    return cart;
  }

  async restoreConfiguredCartQuantity(configId, sourceItems, quantity) {
    const cart = await this.loadVerifiedStorefrontCart();
    const matches = cart.items.filter((item) => (
      isTransformedBundleCartLine(item) &&
      String(item?.properties?.Config || '').trim() === configId
    ));
    if(matches.length > 1) {
      throw new Error('Cannot restore a duplicated configured bundle line.');
    }
    if(matches.length === 1) {
      await this.postConfiguredCartMutation(
        `${routes.cart_change_url}`,
        { id: matches[0].key, quantity: 0 },
        'Unable to remove the unexpected configured bundle before rollback.',
      );
      await this.verifyConfiguredCartQuantity(configId, 0);
    }
    const rollbackResponse = await this.postConfiguredCartMutation(
      `${routes.cart_add_url}`,
      { items: multiplyConfiguredCartSourceItems(sourceItems, quantity) },
      'Unable to restore the original configured bundle quantity.',
    );
    const verifiedCart = await this.verifyConfiguredCartQuantity(configId, quantity);
    return { cartResponse: rollbackResponse, verifiedCart };
  }

  renderVerifiedConfiguredCart(cartResponse, verifiedCart) {
    if(!cartResponse.sections) {
      throw new Error('Shopify updated the bundle without returning refreshed cart sections. Refresh the page before making another cart change.');
    }
    this.updateCartFromSections(cartResponse.sections, true);
    const effectiveCount = getEffectiveCartItemCount(verifiedCart);
    updateCartDrawerCountDisplay(effectiveCount);
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cart-items',
      cartData: verifiedCart,
    });
  }

  showConfiguredCartNotice(message, options = {}) {
    showConfiguredCartNoticeModal(message, options);
  }

  async addRecoveredConfiguredCartSource(recovery, targetQuantity) {
    const replacementConfigId = recovery.replacement.cartConfigId;
    const items = multiplyConfiguredCartSourceItems(
      recovery.sourceItems,
      targetQuantity,
    );
    let cartResponse;
    try {
      cartResponse = await this.postConfiguredCartMutation(
        `${routes.cart_add_url}`,
        { items },
        'Unable to add the refreshed configured bundle.',
      );
    } catch(addError) {
      let reconciledCart;
      try {
        reconciledCart = await this.loadVerifiedStorefrontCart();
      } catch(reconciliationError) {
        throw new Error(
          `Shopify did not confirm whether the refreshed bundle was added. Refresh the cart before trying again; no second add was attempted. ${addError.message}`,
        );
      }
      const matches = reconciledCart.items.filter(
        (item) => String(item?.properties?.Config || '').trim() === replacementConfigId,
      );
      if(matches.length === 1) {
        const actualQuantity = getEffectiveCartLineQuantity(matches[0]);
        if(actualQuantity !== targetQuantity) {
          throw new Error(
            `Shopify returned refreshed bundle quantity ${actualQuantity}; expected ${targetQuantity}. No duplicate add was attempted.`,
          );
        }
        return { cartResponse: null, verifiedCart: reconciledCart };
      }
      if(matches.length > 1) {
        throw new Error(
          'Shopify returned duplicate refreshed bundle lines. No duplicate add was attempted.',
        );
      }
      cartResponse = await this.postConfiguredCartMutation(
        `${routes.cart_add_url}`,
        { items },
        'Unable to restore the saved configured bundle after Shopify confirmed it was absent.',
      );
    }
    const verifiedCart = await this.verifyConfiguredCartQuantity(
      replacementConfigId,
      targetQuantity,
    );
    return { cartResponse, verifiedCart };
  }

  async performRecoveredConfiguredCartReplacement({
    recovery,
    shopDate,
    startingLine,
    targetQuantity,
  }) {
    const previousConfigId = String(startingLine?.properties?.Config || '').trim();
    const metadata = getConfiguredCartRecoveryMetadata(startingLine);
    if(!metadata || metadata.configId !== previousConfigId) {
      throw new Error('The configured bundle recovery metadata changed before replacement.');
    }
    try {
      cacheConfiguredCartSourcesFromAddPayload(
        recovery.replacement.cart,
        window.sessionStorage,
      );
    } catch(cacheError) {
      console.error('[Configured cart] Unable to cache refreshed signed source.', {
        configId: recovery.replacement.cartConfigId,
        reason: cacheError && cacheError.message ? cacheError.message : 'Unknown cache error.',
      });
    }

    const oldPayloadExpired = metadata.expiresOn < shopDate;
    if(oldPayloadExpired) {
      const removalResponse = await this.postConfiguredCartMutation(
        `${routes.cart_change_url}`,
        { id: startingLine.key, quantity: 0 },
        'Unable to remove the expired configured bundle before restoring it.',
      );
      await this.verifyConfiguredCartQuantity(previousConfigId, 0);
      let added;
      try {
        added = await this.addRecoveredConfiguredCartSource(
          recovery,
          targetQuantity,
        );
      } catch(addError) {
        this.renderVerifiedConfiguredCart(
          removalResponse,
          await this.loadVerifiedStorefrontCart(),
        );
        throw new Error(
          `The expired cart line was removed, but Shopify rejected its refreshed replacement after two verified attempts. Do not continue to checkout; reload the cart and contact us so the configuration can be restored safely. ${addError.message}`,
        );
      }
      if(!added.cartResponse) {
        throw new Error(
          'The refreshed bundle was restored, but Shopify did not return refreshed cart sections. Refresh the page before another cart change.',
        );
      }
      this.renderVerifiedConfiguredCart(added.cartResponse, added.verifiedCart);
      return added.verifiedCart;
    }

    const staged = await this.addRecoveredConfiguredCartSource(
      recovery,
      targetQuantity,
    );
    let removalResponse;
    let verifiedCart;
    try {
      removalResponse = await this.postConfiguredCartMutation(
        `${routes.cart_change_url}`,
        { id: startingLine.key, quantity: 0 },
        'Unable to remove the previous configured bundle after staging its replacement.',
      );
      verifiedCart = await this.loadVerifiedStorefrontCart();
      if(verifiedCart.items.some((item) => String(item?.key || '') === startingLine.key)) {
        throw new Error('Shopify did not confirm removal of the previous configured bundle.');
      }
      this.findConfiguredCartLine(verifiedCart, recovery.replacement.cartConfigId);
    } catch(removalError) {
      const reconciledCart = await this.loadVerifiedStorefrontCart();
      const oldLineRemains = reconciledCart.items.some(
        (item) => String(item?.key || '') === startingLine.key,
      );
      if(oldLineRemains) {
        const stagedLine = this.findConfiguredCartLine(
          reconciledCart,
          recovery.replacement.cartConfigId,
        );
        const rollbackResponse = await this.postConfiguredCartMutation(
          `${routes.cart_change_url}`,
          { id: stagedLine.key, quantity: 0 },
          'Unable to remove the staged replacement after the original bundle was preserved.',
        );
        const rollbackCart = await this.verifyConfiguredCartQuantity(
          recovery.replacement.cartConfigId,
          0,
        );
        this.renderVerifiedConfiguredCart(rollbackResponse, rollbackCart);
        throw new Error(
          `The original bundle was kept because its refreshed replacement could not be completed. ${removalError.message}`,
        );
      }
      verifiedCart = reconciledCart;
      removalResponse = null;
    }
    if(!removalResponse) {
      throw new Error('The refreshed bundle is in the cart and the original is gone, but Shopify did not return current cart sections. Refresh the page before another cart change.');
    }
    this.renderVerifiedConfiguredCart(removalResponse, verifiedCart);
    return verifiedCart;
  }

  async removeUnverifiableTransformedCartLine({
    configId = '',
    itemKey,
    notice = '',
  }) {
    const startingCart = await this.loadVerifiedStorefrontCart();
    const matches = startingCart.items.filter((item) => (
      matchesTransformedCartLineIdentity(item, itemKey, configId)
    ));
    if(matches.length !== 1) {
      throw new Error('The older configured bundle could not be identified safely. Refresh the cart before checkout.');
    }

    let removalResponse;
    let verifiedCart;
    try {
      removalResponse = await this.postConfiguredCartMutation(
        `${routes.cart_change_url}`,
        { id: itemKey, quantity: 0 },
        'Unable to remove the older configured bundle.',
      );
      verifiedCart = await this.loadVerifiedStorefrontCart();
      if(verifiedCart.items.some((item) => String(item?.key || '') === itemKey)) {
        throw new Error('Shopify did not confirm removal of the older configured bundle.');
      }
    } catch(removalError) {
      const reconciledCart = await this.loadVerifiedStorefrontCart();
      if(reconciledCart.items.some((item) => String(item?.key || '') === itemKey)) {
        throw new Error(`The older configured bundle could not be removed. ${removalError.message}`);
      }
      throw new Error('The older configured bundle was removed, but Shopify did not return a renderable response. Refresh the cart before checkout.');
    }

    this.renderVerifiedConfiguredCart(removalResponse, verifiedCart);
    if(notice) {
      this.showConfiguredCartNotice(notice);
    }
  }

  async performConfiguredCartQuantityUpdate({
    configId,
    currentQuantity,
    itemKey,
    shopDate,
    targetQuantity,
  }) {
    const startingCart = await this.loadVerifiedStorefrontCart();
    const startingLine = this.findConfiguredCartLine(startingCart, configId);
    const verifiedStartingQuantity = getEffectiveCartLineQuantity(startingLine);
    if(startingLine.key !== itemKey || verifiedStartingQuantity !== currentQuantity) {
      throw new Error('The configured bundle changed in another cart action. Refresh the page and try again.');
    }
    if(targetQuantity === currentQuantity) {
      return;
    }

    let sourceItems = null;
    if(targetQuantity > 0) {
      try {
        sourceItems = readConfiguredCartSource(
          configId,
          shopDate,
          window.sessionStorage,
        );
      } catch(sourceError) {
        console.warn('[Configured cart] Browser source unavailable; requesting server recovery.', {
          cartLineKey: itemKey,
          configId,
          reason: sourceError && sourceError.message ? sourceError.message : 'Unknown source validation error.',
        });
        const recovery = await requestConfiguredCartRecovery(
          startingLine,
          currentQuantity,
        );
        const previousPrice = getConfiguredCartUnitPriceSnapshot(
          startingCart,
          startingLine,
        );
        const replacementCart = await this.performRecoveredConfiguredCartReplacement({
          recovery,
          shopDate,
          startingLine,
          targetQuantity,
        });
        const replacementLine = this.findConfiguredCartLine(
          replacementCart,
          recovery.replacement.cartConfigId,
        );
        const priceComparison = compareConfiguredCartUnitPrices(
          previousPrice,
          getConfiguredCartUnitPriceSnapshot(replacementCart, replacementLine),
        );
        if(priceComparison.priceChanged) {
          this.showConfiguredCartNotice(
            formatConfiguredCartRecoveryPriceChange(
              priceComparison,
              targetQuantity,
              theme.CustomerPriceDisplay.isTaxExclusive(),
            ),
            {
              eyebrow: 'Saved configuration',
              title: 'Bundle price updated',
            },
          );
        }
        return;
      }
    }
    const quantityPlan = planConfiguredCartQuantityChange(
      currentQuantity,
      targetQuantity,
      sourceItems,
    );
    let finalResponse = null;
    let verifiedCart = null;

    if(quantityPlan.kind === 'add') {
      try {
        finalResponse = await this.postConfiguredCartMutation(
          `${routes.cart_add_url}`,
          { items: quantityPlan.items },
          'Unable to increase the configured bundle quantity.',
        );
        verifiedCart = await this.verifyConfiguredCartQuantity(configId, targetQuantity);
      } catch(updateError) {
        try {
          verifiedCart = await this.verifyConfiguredCartQuantity(configId, targetQuantity);
        } catch(verificationError) {
          let rollback;
          try {
            rollback = await this.restoreConfiguredCartQuantity(
              configId,
              sourceItems,
              currentQuantity,
            );
            this.renderVerifiedConfiguredCart(rollback.cartResponse, rollback.verifiedCart);
          } catch(rollbackError) {
            throw new Error(
              `The bundle quantity update failed and the original quantity could not be restored. Remove the configured bundle before checkout. ${rollbackError.message}`,
            );
          }
          throw new Error(
            `The bundle quantity was not changed. Its original quantity was restored. ${updateError.message}`,
          );
        }
      }
    } else {
      let removalResponse;
      try {
        removalResponse = await this.postConfiguredCartMutation(
          `${routes.cart_change_url}`,
          { id: startingLine.key, quantity: 0 },
          'Unable to remove the configured bundle for its quantity change.',
        );
        verifiedCart = await this.verifyConfiguredCartQuantity(configId, 0);
      } catch(removalError) {
        try {
          verifiedCart = await this.verifyConfiguredCartQuantity(configId, 0);
        } catch(verificationError) {
          throw removalError;
        }
      }

      if(quantityPlan.kind === 'remove') {
        finalResponse = removalResponse;
      } else {
        try {
          finalResponse = await this.postConfiguredCartMutation(
            `${routes.cart_add_url}`,
            { items: quantityPlan.items },
            'Unable to add the requested configured bundle quantity.',
          );
          verifiedCart = await this.verifyConfiguredCartQuantity(configId, targetQuantity);
        } catch(updateError) {
          try {
            verifiedCart = await this.verifyConfiguredCartQuantity(configId, targetQuantity);
          } catch(verificationError) {
            let rollback;
            try {
              rollback = await this.restoreConfiguredCartQuantity(
                configId,
                sourceItems,
                currentQuantity,
              );
              this.renderVerifiedConfiguredCart(rollback.cartResponse, rollback.verifiedCart);
            } catch(rollbackError) {
              throw new Error(
                `The bundle quantity update failed and the original quantity could not be restored. Remove the configured bundle before checkout. ${rollbackError.message}`,
              );
            }
            throw new Error(
              `The bundle quantity was not changed. Its original quantity was restored. ${updateError.message}`,
            );
          }
        }
      }
    }

    if(!finalResponse) {
      throw new Error('The configured cart mutation completed without a renderable response. Refresh the page before checkout.');
    }
    this.renderVerifiedConfiguredCart(finalResponse, verifiedCart);
  }

  updateLegacyTransformedCartRemoval(line, input, itemKey, currentQuantity, notice = '') {
    if(activeConfiguredCartMutation) {
      input.value = String(currentQuantity);
      const error = new Error('Another configured cart update is already in progress.');
      this.updateLiveRegions(line, error.message);
      return Promise.reject(error);
    }
    cartQuantityMutationGeneration += 1;
    this.enableLoading(line);
    this.setCartMutationControlsDisabled(true);
    const mutation = this.removeUnverifiableTransformedCartLine({
      itemKey,
      notice,
    }).catch((error) => {
      input.value = String(currentQuantity);
      this.updateLiveRegions(
        line,
        error && error.message ? error.message : 'Unable to remove the older configured bundle.',
      );
      throw error;
    }).finally(() => {
      this.disableLoading(line);
      this.setCartMutationControlsDisabled(false);
      if(activeConfiguredCartMutation === mutation) {
        activeConfiguredCartMutation = null;
      }
    });
    activeConfiguredCartMutation = mutation;
    return mutation;
  }

  updateTransformedCartQuantity(line, input, targetQuantity) {
    const itemKey = String(input.dataset.key || '').trim();
    const configId = String(input.dataset.cartConfigId || '').trim();
    const shopDate = String(input.dataset.shopDate || '').trim();
    const currentQuantity = Number(input.dataset.transformedQuantity);
    if(!itemKey || !Number.isSafeInteger(currentQuantity) || currentQuantity <= 0) {
      input.value = String(currentQuantity || 1);
      this.updateLiveRegions(
        line,
        'This configured bundle has invalid cart metadata. Use Remove before checkout.',
      );
      return Promise.reject(new Error('Configured bundle cart metadata is unavailable.'));
    }
    if(!CONFIGURED_CART_LINE_ID_PATTERN.test(configId) || !/^\d{4}-\d{2}-\d{2}$/.test(shopDate)) {
      if(targetQuantity === 0) {
        return this.updateLegacyTransformedCartRemoval(
          line,
          input,
          itemKey,
          currentQuantity,
        );
      }
      input.value = String(currentQuantity);
      const error = new Error(
        'This older configured bundle has been kept in the cart. Its quantity cannot be changed safely; remove and rebuild it only when you are ready.',
      );
      this.updateLiveRegions(line, error.message);
      return Promise.reject(error);
    }

    if(activeConfiguredCartMutation) {
      input.value = String(currentQuantity);
      const error = new Error('Another configured cart update is already in progress.');
      this.updateLiveRegions(line, error.message);
      return Promise.reject(error);
    }

    cartQuantityMutationGeneration += 1;
    this.enableLoading(line);
    this.setCartMutationControlsDisabled(true);
    const mutation = this.performConfiguredCartQuantityUpdate({
      configId,
      currentQuantity,
      itemKey,
      shopDate,
      targetQuantity,
    }).catch((error) => {
      input.value = String(currentQuantity);
      this.updateLiveRegions(
        line,
        error && error.message ? error.message : 'Unable to update the configured bundle quantity.',
      );
      throw error;
    }).finally(() => {
      this.disableLoading(line);
      this.setCartMutationControlsDisabled(false);
      if(activeConfiguredCartMutation === mutation) {
        activeConfiguredCartMutation = null;
      }
    });
    activeConfiguredCartMutation = mutation;
    return mutation;
  }

  updateQuantity(line, quantity, name, variantId){
    // Keep the delayed intent attached to the cart surface where it originated.
    // The cart page and drawer can both exist in the DOM with the same line
    // numbers, so a document-wide lookup can pick the other surface's stale row.
    const input = this.querySelector(`#Drawer-quantity-${line}`) ||
                  this.querySelector(`#Quantity-${line}`);
    
    if(!input) {
      return;
    }
    
    // Extract the key and variant_id from the DOM element
    const key = input.dataset.key;
    const dataVariantId = input.dataset.variantId;
    
    if(!key || !dataVariantId) {
      return;
    }

    const requestedQuantityText = String(quantity ?? '').trim();
    const requestedQuantity = /^\d+$/.test(requestedQuantityText)
      ? Number(requestedQuantityText)
      : NaN;
    if(!Number.isSafeInteger(requestedQuantity) || requestedQuantity < 0) {
      this.updateLiveRegions(line, 'Enter a valid cart quantity.');
      return;
    }
    if(input.dataset.transformedCartLine === 'true') {
      if(requestedQuantity > CONFIGURED_CART_LINE_MAX_QUANTITY) {
        input.value = String(input.dataset.transformedQuantity || 1);
        this.updateLiveRegions(line, 'Configured bundle quantity cannot exceed 2000.');
        return Promise.reject(new Error('Configured bundle quantity cannot exceed 2000.'));
      }
      return this.updateTransformedCartQuantity(line, input, requestedQuantity);
    }
    if(activeConfiguredCartMutation) {
      input.value = input.defaultValue;
      const error = new Error('Wait for the configured cart update to finish before changing another item.');
      this.updateLiveRegions(line, error.message);
      return Promise.reject(error);
    }
    
    // Create the item key in format: variantId:key
    const itemKey = `${dataVariantId}:${key}`;

    if(requestedQuantity === 0) {
      const pendingChange = this.pendingQuantityChanges.get(itemKey);
      if(pendingChange) {
        clearTimeout(pendingChange.timer);
        this.pendingQuantityChanges.delete(itemKey);
      }
    }
    
    // Queue the update using the item key instead of line number
    cartQuantityMutationGeneration += 1;
    this.updateQueue.push({ key: itemKey, quantity: requestedQuantity, name, variantId: dataVariantId, line });
    this.enableLoading(line);
    
    // Start processing the queue
    return this.processQueue();
  }
  
  // Execute a single update (called by queue processor)
  async executeUpdate(line, quantity, name, variantId){
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
      
      // Check for HTTP errors (422, 404, etc.)
      if(!response.ok) {
        const errorText = await response.text();
        let errorMessage = 'Cart update failed';
        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorJson.description || errorMessage;
        } catch(e) {
          // If not JSON, use text as-is
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }
      
      const state = await response.text();
      const parsedState = JSON.parse(state);
      
  const effectiveCount = getEffectiveCartItemCount(parsedState);

  if(effectiveCount !== parsedState.item_count) {
  }
      
      if(parsedState.errors) {
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        if(quantityElement){ quantityElement.value = quantityElement.getAttribute('value'); }
        this.updateLiveRegions(line, parsedState.errors);
        throw new Error(parsedState.errors);
      }
      
      // Basic state updates - full refresh will happen after queue completes
      this.classList.toggle('is-empty', effectiveCount === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      
      if(cartFooter) cartFooter.classList.toggle('is-empty', effectiveCount === 0);
      if(cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', effectiveCount === 0);

      updateCartDrawerCountDisplay(effectiveCount);
      if(effectiveCount === 0) {
        refreshCartDrawerSection();
      }

      // Publish update event
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      
      return parsedState;
    } catch(error) {
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if(errors && window.cartStrings && window.cartStrings.error){ 
        errors.textContent = window.cartStrings.error; 
      }
      throw error;
    }
    // Note: Loading states are cleared after entire queue completes in processQueue()
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if(lineItemError) lineItemError.querySelector('.ctItem-error').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    freeShippMsg();

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  setCartMutationControlsDisabled(disabled) {
    document.querySelectorAll(
      'cart-items quantity-input input, cart-items quantity-input .qtyBtn, cart-drawer-items quantity-input input, cart-drawer-items quantity-input .qtyBtn',
    ).forEach((control) => {
      if(disabled) {
        if(control.dataset.configuredCartPreviousAriaDisabled === undefined) {
          control.dataset.configuredCartPreviousAriaDisabled = control.getAttribute('aria-disabled') ?? '';
        }
        if('disabled' in control && control.dataset.configuredCartPreviousDisabled === undefined) {
          control.dataset.configuredCartPreviousDisabled = control.disabled ? 'true' : 'false';
          control.disabled = true;
        }
        control.setAttribute('aria-disabled', 'true');
        return;
      }
      const previousAriaDisabled = control.dataset.configuredCartPreviousAriaDisabled;
      if(previousAriaDisabled !== undefined) {
        if(previousAriaDisabled) {
          control.setAttribute('aria-disabled', previousAriaDisabled);
        } else {
          control.removeAttribute('aria-disabled');
        }
        delete control.dataset.configuredCartPreviousAriaDisabled;
      }
      const previousDisabled = control.dataset.configuredCartPreviousDisabled;
      if(previousDisabled !== undefined && 'disabled' in control) {
        control.disabled = previousDisabled === 'true';
        delete control.dataset.configuredCartPreviousDisabled;
      }
    });
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}
customElements.define('cart-items', CartItems);

function isCartQuantityMutationActive() {
  if(activeConfiguredCartMutation) {
    return true;
  }
  return Array.from(document.querySelectorAll('cart-items, cart-drawer-items'))
    .some((cartItems) => (
      cartItems.isProcessingQueue ||
      (Array.isArray(cartItems.updateQueue) && cartItems.updateQueue.length > 0) ||
      (cartItems.pendingQuantityChanges instanceof Map && cartItems.pendingQuantityChanges.size > 0)
    ));
}

const customerNotePrefix = 'CUSTOMER NOTE: ';
const CART_NOTE_SAVE_DELAY_MS = 300;
let cartNoteSaveChain = Promise.resolve();
let confirmedCartNote;

function getPrefixedCustomerNote(note) {
  const noteValue = (note || '').trim();
  if(!noteValue) return '';
  return noteValue.startsWith(customerNotePrefix) ? noteValue : `${customerNotePrefix}${noteValue}`;
}

if(!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.noteField = this.querySelector('textarea[name="note"]');
      if(this.noteField?.getAttribute('form') === 'cart') {
        this.noteField.removeAttribute('form');
      }
      if(confirmedCartNote === undefined) {
        confirmedCartNote = getPrefixedCustomerNote(this.noteField?.value);
      }
      this.saveTimer = null;
      this.addEventListener('input', (event) => {
        if(event.target !== this.noteField) return;
        this.scheduleNoteSave();
      });
      this.addEventListener('change', (event) => {
        if(event.target !== this.noteField) return;
        this.scheduleNoteSave(true);
      });
      this.addEventListener('click', (e) => {
        const saveButton = e.target.closest('.saveBtn');
        if(saveButton && !saveButton.classList.contains('closeCtf')) {
          this.scheduleNoteSave(true);
        }
      });
    }

    disconnectedCallback() {
      clearTimeout(this.saveTimer);
    }

    scheduleNoteSave(immediate = false) {
      if(!this.noteField) return Promise.resolve();
      clearTimeout(this.saveTimer);
      this.saveTimer = null;
      if(immediate) {
        const savePromise = this.updateNote(this.noteField.value);
        savePromise.catch(() => {});
        return savePromise;
      }
      this.saveTimer = setTimeout(() => {
        this.saveTimer = null;
        this.updateNote(this.noteField.value).catch(() => {});
      }, CART_NOTE_SAVE_DELAY_MS);
      return Promise.resolve();
    }

    updateNote(note) {
      const expectedNote = getPrefixedCustomerNote(note);
      cartNoteSaveChain = cartNoteSaveChain
        .catch(() => {})
        .then(() => this.persistNote(expectedNote));
      return cartNoteSaveChain;
    }

    async persistNote(expectedNote) {
      if(expectedNote === confirmedCartNote) return;
      const body = JSON.stringify({ note: expectedNote });
      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body,
        keepalive: true,
      });
      if(!response.ok) {
        throw new Error(`Unable to save the cart note (HTTP ${response.status}).`);
      }
      const cart = await response.json();
      const savedNote = String(cart?.note || '');
      if(savedNote !== expectedNote) {
        throw new Error('Shopify did not confirm the saved cart note.');
      }
      confirmedCartNote = expectedNote;
    }
  });
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    var cartLink = document.querySelector('#cartLink');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (e) => {
      if(e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener('transitionend', () => {
      var containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      var focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.remove('loading');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.hasAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (e) => {
      e.currentTarget.setAttribute('aria-expanded', !e.currentTarget.closest('details').hasAttribute('open'));
    });

    //cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Cancel any pending onCartUpdate calls since we have fresh data
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if(cartDrawerItems && cartDrawerItems.updateTimeout) {
      clearTimeout(cartDrawerItems.updateTimeout);
    }
    
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    
    // Check if we have the sections we need in the response
    let hasAllSections = parsedState.sections && this.getSectionsToRender().every(section => 
      parsedState.sections[section.id]
    );
    
    if(hasAllSections) {
      // Use the sections returned from the add-to-cart response (most reliable)
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if(sectionElement) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));
      
      updateCartDrawerCountDisplay(parsedState.item_count);

      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    } else {
      // Fallback: Fetch fresh cart data if sections are missing
      console.warn('CartDrawer: Sections missing from response, fetching cart');
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const drawerInner = html.querySelector('.drawer__inner');
          if(drawerInner) {
            this.querySelector('.drawer__inner').innerHTML = drawerInner.innerHTML;
          }

          updateCartDrawerCountDisplay(parsedState.item_count);
          
          setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
          });
        })
        .catch((e) => {
          console.error('CartDrawer: Error fetching cart', e);
          // Still try to open drawer even if fetch fails
          setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
          });
        });
    }
  }
  getSectionInnerHTML(html, selector = '.shopify-section'){
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

/*******CART DRAWER START********/

document.addEventListener('DOMContentLoaded', () => {
    const getShippingEstimatorShells = () => document.querySelectorAll('[data-shipping-estimator-shell]');

    const isShippingEstimatorReady = (shell) => {
      if (!shell) {
        return false;
      }

      const estimator = shell.querySelector('.srs-shipping-estimator');

      if (!estimator) {
        return false;
      }

      if (estimator.getAttribute('data-srs-initialized') === 'true') {
        return true;
      }

      return Boolean(estimator.querySelector('.srs-se__inner, .srs-se__form, .srs-se__results'));
    };

    const syncShippingEstimatorShellState = () => {
      getShippingEstimatorShells().forEach((shell) => {
        const isReady = isShippingEstimatorReady(shell);

        shell.classList.toggle('is-loading', !isReady);
        shell.setAttribute('aria-busy', (!isReady).toString());
      });
    };

    // Keep the loading shell in sync when the app initializes or the cart drawer is recreated.
    const observeBlockRecreation = () => {
        const cartContainer = document.body;
        if (!cartContainer) {
            console.error('Cart container not found.');
            return;
        }

        const observer = new MutationObserver(() => {
            syncShippingEstimatorShellState();
        });

        observer.observe(cartContainer, { childList: true, subtree: true });
    };
  
  // Initial setup
  syncShippingEstimatorShellState();
  observeBlockRecreation();

  window.addEventListener('load', syncShippingEstimatorShellState, { once: true });
});



/***************SHIPPING CART DRAWER END *****************/

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if(localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`).then((response) => response.text()).then((responseText) =>{

      });
      if(document.querySelector('#cartCoupon')){
        document.querySelector('#cartCoupon').classList.remove("active");
      }
    })
  }
}
customElements.define('coupon-code', CouponCode);

class CartOption extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.cftBtn').forEach((button) => button.addEventListener("click", function(e){
        e.preventDefault()
        var ftbk = this.hash.substr(1);
        $('.cftDraw.active').removeClass('active');
        document.getElementById(ftbk).classList.add("active");
    }));
    document.querySelectorAll('.saveBtn').forEach((button) => button.addEventListener("click", function(e){
        var box = document.querySelectorAll('.cftDraw');
        box.forEach(box => { box.classList.remove("active"); });
    }));
  }
}
customElements.define('cart-option', CartOption);

function startTimer(duration, display){
    var timer = duration, minutes, seconds;
    setInterval(function(){
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.textContent = minutes + ":" + seconds;

        if(--timer < 0){
            clearInterval(startTimer);
            document.querySelector('.cartCountdown').remove();
        }
    }, 1000);
}
window.onload = function(){
    if(document.querySelector('.cartCountdown')){
        var minutes = document.querySelector('.cartCountdown').getAttribute('data-countdown'),
            display = document.querySelector('#cartTime');
        startTimer(minutes, display);
    }
};

if(!customElements.get('product-form')){
  customElements.define('product-form',class ProductForm extends HTMLElement{
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.getButtonTextElement(this.submitButton);
        const formId = this.form ? this.form.getAttribute('id') : null;
        this.stickyButtons = formId ? Array.from(document.querySelectorAll(`[data-sticky-submit="${formId}"]`)) : [];

        if(document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt){
        evt.preventDefault();
        if(this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        const inlineOffer = Array.from(document.querySelectorAll('customer-product-offer'))
          .find((element) => element.dataset.formId === this.form.getAttribute('id'));
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.btn_spinner').classList.remove('hidden');
        this.toggleButtonText(this.submitButton, true);
        this.toggleStickyButtonsLoading(true);

        try {
          const formData = new FormData(this.form);
          if (!(await this.validateMaxQuantityBeforeAdd(formData))) return;
          let offerClaim = null;
          if (inlineOffer) {
            if (typeof inlineOffer.prepare !== 'function') {
              throw new Error('Customer offer could not load. Reload the product page before adding.');
            }
            offerClaim = await inlineOffer.prepare(formData);
          }
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          if(this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          const cartResponse = await fetch(routes.cart_add_url, config);
          const response = await cartResponse.json();
          if (!cartResponse.ok || response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            throw new Error(response.description || 'Add to cart failed with HTTP ' + cartResponse.status + '.');
          }
          if (inlineOffer) await inlineOffer.verify(response, offerClaim, routes.cart_url);
          if(!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if(quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => this.cart.renderContents(response));
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        } catch (error) {
          console.error('Add to cart error:', error);
          if (inlineOffer && typeof inlineOffer.showError === 'function') {
            inlineOffer.showError(error);
          } else {
            this.handleErrorMessage(error.message || 'Unable to add item to cart.');
          }
        } finally {
          this.submitButton.classList.remove('loading');
          if(this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.btn_spinner').classList.add('hidden');
          this.toggleButtonText(this.submitButton, false);
          this.toggleStickyButtonsLoading(false);
        }
      }

      getQuantityInputElement() {
        const productInfo = this.closest('product-info');
        if (productInfo) {
          const scopedInput = productInfo.querySelector('.quantity__input[name="quantity"]');
          if (scopedInput) return scopedInput;
        }

        const sectionId = this.dataset.section || this.getAttribute('data-section-id');
        if (sectionId) {
          const sectionInput = document.getElementById(`Quantity-${sectionId}`);
          if (sectionInput) return sectionInput;
        }

        return this.form.querySelector('.quantity__input[name="quantity"]') || this.form.querySelector('[name="quantity"]');
      }

      async validateMaxQuantityBeforeAdd(formData) {
        const quantityInput = this.getQuantityInputElement();
        if (!quantityInput) return true;

        const maxRaw = quantityInput.dataset.max || quantityInput.getAttribute('data-max');
        const maxAllowed = maxRaw ? parseInt(maxRaw, 10) : null;
        if (maxAllowed === null || Number.isNaN(maxAllowed)) return true;

        const requestedVariantId = parseInt(formData.get('id'), 10);
        const requestedQty = Math.max(parseInt(formData.get('quantity'), 10) || 1, 1);

        try {
          const cartResponse = await fetch(`${routes.cart_url}.js`);
          if (!cartResponse.ok) return true;

          const cartData = await cartResponse.json();
          const existingItem = cartData.items.find((item) => item.variant_id === requestedVariantId);
          const cartQty = existingItem ? existingItem.quantity : 0;

          if (cartQty + requestedQty > maxAllowed) {
            this.handleErrorMessage(`A maximum order quantity of ${maxAllowed} can be ordered.`);
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: `A maximum order quantity of ${maxAllowed} can be ordered.`,
            });
            return false;
          }

          quantityInput.dataset.cartQuantity = cartQty;
          return true;
        } catch (error) {
          console.error('Max quantity validation error:', error);
          return true;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if(this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if(!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if(errorMessage){ this.errorMessage.textContent = errorMessage; }
      }

      getButtonTextElement(button) {
        if(!button) return null;
        let text = button.querySelector('[data-button-text]');
        if(text) return text;
        text = button.querySelector('.txt');
        if(text) return text;
        const spans = Array.from(button.querySelectorAll('span'));
        return spans.find((span) => !span.closest('.btn_spinner') && !span.classList.contains('v-hidden')) || null;
      }

      toggleButtonText(button, hide) {
        const textElement = this.getButtonTextElement(button);
        if(!textElement) return;
        if(hide){
          textElement.classList.add('hidden');
        } else {
          textElement.classList.remove('hidden');
        }
      }

      toggleStickyButtonsLoading(isLoading) {
        if(!this.stickyButtons || !this.stickyButtons.length) return;
        this.stickyButtons.forEach((button) => {
          if(!button) return;
          const spinner = button.querySelector('.btn_spinner');
          if(isLoading){
            button.setAttribute('aria-disabled', true);
            button.classList.add('loading');
            if(spinner) spinner.classList.remove('hidden');
            this.toggleButtonText(button, true);
          } else {
            if(!this.error) button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
            if(spinner) spinner.classList.add('hidden');
            this.toggleButtonText(button, false);
          }
        });
      }
    }
  );
}
function freeShippMsg(){
    fetch(window.routes.cart_url+'?section_id=cart-template').then((response) => response.text()).then((responseText) => {
        var html = new DOMParser().parseFromString(responseText, 'text/html')
        var destination = document.querySelector('#CartCount');
        var source = html.querySelector('#cartItems');
        if(source && destination) destination.innerHTML = source.innerHTML;

        if(document.querySelector('.freeShipMsg')){
            var freeship = document.querySelector('.freeShipMsg');
            var shipsource = html.querySelector('.freeShipget');
            if(shipsource && freeship) freeship.innerHTML = shipsource.innerHTML;
            if(theme.mlcurrency){ currenciesChange(".freeShipMsg span.money"); }
        }
    });
}
function shopreviews(){
    
}

function refreshCartDrawerSection(){
  const cartDrawer = document.querySelector('cart-drawer');
  if(!cartDrawer || isCartQuantityMutationActive()) {
    return Promise.resolve();
  }
  const refreshGeneration = cartQuantityMutationGeneration;

  return fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      if(
        isCartQuantityMutationActive() ||
        refreshGeneration !== cartQuantityMutationGeneration
      ) {
        return;
      }
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const drawerInner = html.querySelector('.drawer__inner');
      if(drawerInner) {
        const targetInner = cartDrawer.querySelector('.drawer__inner');
        if(targetInner) {
          targetInner.innerHTML = drawerInner.innerHTML;
        }
      }
    })
    .catch((e) => console.warn('Failed to refresh cart drawer:', e));
}

// Cart sync monitor (shipping estimator + focus/visibility + resilient network hooks)
(function() {
  if(window.__cartSyncMonitorInstalled) {
    return;
  }
  window.__cartSyncMonitorInstalled = true;

  // Lightweight observability for QA / debugging
  const stats = window.__cartSyncStats = window.__cartSyncStats || {
    installedAt: Date.now(),
    syncCount: 0,
    lastReason: null,
    lastBackendCount: null,
    lastUiCount: null,
    lastSyncAt: null,
    lastError: null,
  };

  let inFlight = null;
  let lastSyncAt = 0;
  const MIN_INTERVAL_MS = 800;

  const getCartCountFromUI = () => {
    const el = document.querySelector('#CartCount');
    const text = el ? (el.textContent || '') : '';
    const count = parseInt(String(text).replace(/\D/g, ''), 10);
    return Number.isFinite(count) ? count : 0;
  };

  const setCartCountInUI = (count) => {
    const numericCount = Number(count);
    if(!Number.isFinite(numericCount)) {
      return;
    }

    document.querySelectorAll('#CartCount').forEach((el) => {
      if(el) {
        el.textContent = String(numericCount);
      }
    });

    if(typeof updateCartDrawerCountDisplay === 'function') {
      try { updateCartDrawerCountDisplay(numericCount); } catch(e) {}
    }
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    return res.json();
  };

  const syncCartUI = (reason, options) => {
    const now = Date.now();
    const opts = options || {};

    stats.lastReason = reason;

    // The cart queue owns quantities, spinners, totals, and counts while a
    // mutation is active. Replacing the drawer here would discard a later
    // queued line's optimistic value and loading state.
    if(isCartQuantityMutationActive()) {
      return Promise.resolve();
    }

    if(inFlight) {
      return inFlight;
    }

    if(!opts.force && (now - lastSyncAt < MIN_INTERVAL_MS)) {
      return Promise.resolve();
    }

    lastSyncAt = now;
    stats.lastSyncAt = now;

    stats.syncCount += 1;
    const syncGeneration = cartQuantityMutationGeneration;

    inFlight = fetchCart()
      .then((cart) => {
        if(
          isCartQuantityMutationActive() ||
          syncGeneration !== cartQuantityMutationGeneration
        ) {
          return;
        }
        const backendCount = typeof cart?.item_count === 'number' ? cart.item_count : 0;
        const uiCount = getCartCountFromUI();

        stats.lastBackendCount = backendCount;
        stats.lastUiCount = uiCount;

        if(backendCount !== uiCount) {
          setCartCountInUI(backendCount);
          if(typeof refreshCartDrawerSection === 'function') {
            try { refreshCartDrawerSection(); } catch(e) {}
          }
        }
      })
      .catch((e) => {
        stats.lastError = e;
      })
      .finally(() => { inFlight = null; });

    return inFlight;
  };

  // Trigger sync when the user returns from login/logout (or bfcache restores)
  window.addEventListener('pageshow', () => syncCartUI('pageshow'), { passive: true });
  window.addEventListener('focus', () => syncCartUI('focus'), { passive: true });
  document.addEventListener('visibilitychange', () => {
    if(!document.hidden) {
      syncCartUI('visibility');
    }
  }, { passive: true });

  // Shipping estimator: event delegation (survives DOM replacement)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if(form && form.matches && form.matches('.srs-se__form')) {
      // Sync immediately; additionally observe DOM changes below for results completion.
      syncCartUI('shipping-form-submit', { force: true });
    }
  }, true);

  // Shipping estimator: watch results/status changes (survives block recreation)
  const observedRoots = new WeakSet();
  const attachEstimatorObserver = (root) => {
    if(!root || observedRoots.has(root)) {
      return;
    }
    observedRoots.add(root);

    const mo = new MutationObserver(() => {
      // Any results/status change is a good time to validate cart count.
      syncCartUI('shipping-estimator-dom');
    });

    mo.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden', 'aria-disabled', 'aria-busy', 'class']
    });
  };

  const scanForEstimatorRoots = () => {
    document.querySelectorAll('#shipping-estimator-anchor, .srs-shipping-estimator').forEach((el) => {
      attachEstimatorObserver(el);
    });
  };

  scanForEstimatorRoots();

  // Detect estimator being removed/re-added dynamically
  if(window.MutationObserver) {
    const bodyObserver = new MutationObserver((mutations) => {
      let shouldRescan = false;
      mutations.forEach((m) => {
        if(m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach((node) => {
            if(!node || node.nodeType !== 1) {
              return;
            }
            if(
              (node.matches && (node.matches('#shipping-estimator-anchor') || node.matches('.srs-shipping-estimator'))) ||
              (node.querySelector && node.querySelector('#shipping-estimator-anchor, .srs-shipping-estimator'))
            ) {
              shouldRescan = true;
            }
          });
        }
      });
      if(shouldRescan) {
        scanForEstimatorRoots();
      }
    });
    bodyObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  // Network hooks: best-effort triggers for shipping rates calls.
  // NOTE: This is intentionally conservative to avoid loops (we exclude /cart.js).
  const shouldTriggerFromUrl = (url) => {
    if(!url) {
      return false;
    }
    const u = String(url);
    if(u.indexOf('/cart.js') !== -1) {
      return false;
    }
    return (
      /\/cart\/shipping_rates(\.json)?/i.test(u) ||
      /shipping_rates/i.test(u) ||
      /shipping-estimator/i.test(u) ||
      /shipping-calculator/i.test(u)
    );
  };

  const wrapFetch = (fetchFn) => {
    if(typeof fetchFn !== 'function') {
      return fetchFn;
    }
    if(fetchFn.__cartSyncWrapped) {
      return fetchFn;
    }
    const wrapped = function(...args) {
      try {
        const first = args && args.length ? args[0] : null;
        const url = typeof first === 'string' ? first : (first && first.url ? first.url : '');
        if(shouldTriggerFromUrl(url)) {
          syncCartUI('network-fetch');
        }
      } catch(e) {}
      return fetchFn.apply(this, args);
    };
    wrapped.__cartSyncWrapped = true;
    return wrapped;
  };

  // Install fetch hook and keep it wrapped even if another script replaces window.fetch later.
  try {
    let currentFetch = wrapFetch(window.fetch);
    // Define getter/setter so future replacements get wrapped too.
    Object.defineProperty(window, 'fetch', {
      configurable: true,
      get() { return currentFetch; },
      set(next) {
        currentFetch = wrapFetch(next);
      }
    });
  } catch(e) {
    stats.lastError = e;
  }

  // XHR hook (covers jQuery.ajax); can be overwritten by other scripts, but usually stable.
  try {
    const originalOpen = XMLHttpRequest.prototype.open;
    if(!originalOpen.__cartSyncWrapped) {
      XMLHttpRequest.prototype.open = function(method, url) {
        try {
          if(shouldTriggerFromUrl(url)) {
            syncCartUI('network-xhr');
          }
        } catch(e) {}
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.open.__cartSyncWrapped = true;
    }
  } catch(e) {
    stats.lastError = e;
  }

  // Initial sanity sync
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncCartUI('init'), { once: true });
  } else {
    syncCartUI('init');
  }

  // Expose a tiny API for QA / edge-case testing.
  // This is safe: it only reads /cart.js and updates #CartCount + optional drawer refresh.
  window.__cartSyncMonitor = window.__cartSyncMonitor || {
    sync: syncCartUI,
    stats,
    // Backwards compatible no-ops (older test harnesses may call these)
    isDebug: () => false,
    setDebug: () => {},
  };
})();

function updateCartDrawerCountDisplay(count){
  const cartDrawer = document.querySelector('cart-drawer');
  if(!cartDrawer) {
    return;
  }
  if(count === undefined || count === null) {
    return;
  }
  const numericCount = Number(count);
  if(!Number.isFinite(numericCount)) {
    return;
  }
  const title = cartDrawer.querySelector('.drawer__inner h4');
  if(!title) {
    return;
  }
  const textNode = Array.from(title.childNodes).find((node) => node.nodeType === 3 && node.textContent);
  if(textNode) {
    const baseText = textNode.textContent.replace(/\(\d+\)/, '').trim() || textNode.textContent.trim() || 'YOUR CART';
    textNode.textContent = `${baseText.replace(/\s+$/,'')} (${numericCount}) `;
  }
}

// Keep header/mobile cart count in sync immediately on cart updates
document.addEventListener('DOMContentLoaded', () => {
  const setHeaderCartCount = (count) => {
    document.querySelectorAll('#CartCount').forEach((el) => {
      if(el) {
        el.textContent = String(count);
      }
    });
  };

  const updateHeaderCartCount = (cartUpdateEvent = null) => {
    if(
      cartUpdateEvent?.source === 'cart-items' &&
      Array.isArray(cartUpdateEvent?.cartData?.items)
    ) {
      setHeaderCartCount(getEffectiveCartItemCount(cartUpdateEvent.cartData));
      return;
    }
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const count = typeof cart?.item_count === 'number' ? cart.item_count : 0;
          setHeaderCartCount(count);
        })
        .catch((e) => console.warn('Could not update cart count:', e));
    } catch (e) {
      console.warn('Cart count update failed:', e);
    }
  };

  updateHeaderCartCount();

  try {
    if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        updateHeaderCartCount(event);
      });
    }
  } catch (e) {
    // No pub/sub available
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Spinner URLs are emitted through Liquid so preview/live theme IDs do not leak into static JS.
  const spinnerImages = (window.theme && Array.isArray(window.theme.spinnerImages) && window.theme.spinnerImages.length)
    ? window.theme.spinnerImages
    : [];

  // Preload all spinner images to avoid flickering
  spinnerImages.forEach((image) => {
    const img = new Image();
    img.src = image;
  });

  // Function to randomly select a spinner
  function setRandomSpinner() {
    const spinnerElement = document.querySelector('.at-spinner4');
    if (!spinnerElement || spinnerImages.length === 0) {
      return;
    }
    const randomIndex = Math.floor(Math.random() * spinnerImages.length);
    const selectedSpinner = spinnerImages[randomIndex];
    
    // Set the background image of the spinner dynamically
    spinnerElement.style.setProperty('background-image', `url('${selectedSpinner}')`, 'important');
  }

  // Set up MutationObserver to monitor class changes on the body
  const observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        // Check if the 'loading' class has been added to the body
        if (document.body.classList.contains('loading')) {
          setRandomSpinner(); // Set a new random spinner immediately
        }
      }
    });
  });

  // Start observing class changes on the body element
  observer.observe(document.body, { attributes: true });
});

/*CC*/
document.addEventListener("DOMContentLoaded", () => {
    const header = document.getElementById("header");

    if (!header) {
        return;
    }

    // Only apply sticky behavior if the screen width is 768px or smaller (small screens)
    function isSmallScreen() {
        return window.innerWidth <= 768;
    }

    let lastScrollTop = 0;
    let lastScrollTime = Date.now();
    const scrollThreshold = 3500; // Increased scroll speed threshold for faster scrolling

    let isTicking = false;

    window.addEventListener("scroll", () => {
        if (!isTicking) {
            window.requestAnimationFrame(() => {
                // Check if we're on a small screen
                if (isSmallScreen()) {
                    const currentScrollTop = window.scrollY;
                    const currentTime = Date.now();

                    // Keep the fixed header visible at the top of the page.
                    if (currentScrollTop === 0) {
                        header.classList.remove("header--hidden-mobile");
                        isTicking = false;
                        return;
                    }

                    const scrollDistance = lastScrollTop - currentScrollTop;
                    const timeDiff = currentTime - lastScrollTime;
                    const scrollSpeed = (scrollDistance / timeDiff) * 1000; // Convert to pixels per second

                    if (scrollDistance > 0 && scrollSpeed > scrollThreshold) {
                        header.classList.remove("header--hidden-mobile");
                    } else if (scrollDistance < 0) {
                        header.classList.add("header--hidden-mobile");
                    }

                    lastScrollTop = currentScrollTop;
                    lastScrollTime = currentTime;
                } else {
                    header.classList.remove("header--hidden-mobile");
                }
                isTicking = false;
            });
            isTicking = true;
        }
    }, { passive: true });
});

//DR CART

// Apply the shared customer tax display to every current-price element.
function updateAllPricesWithGST(containerSelector) {
    const container = typeof containerSelector === 'string' ? document.querySelector(containerSelector) : containerSelector;
    if (!container) return;

    const moneyElements = [];
    if (container.matches && container.matches('.money[data-price]')) {
        moneyElements.push(container);
    }
    container.querySelectorAll('.money[data-price]').forEach((el) => moneyElements.push(el));
    moneyElements.forEach((el) => {
        if (el.children.length > 0) {
            return;
        }
        const priceCents = el.getAttribute('data-price');
        if (priceCents !== null && priceCents !== '') {
            const formatted = theme.Currency.formatMoney(priceCents);
            // Only update if different to avoid unnecessary DOM manipulation
            if (el.textContent.trim() !== formatted.trim()) {
                el.textContent = formatted;
            }
        }
    });

    // Handle specific shipping rate elements if they exist in the container
    const shippingRates = container.querySelectorAll('.srs-se__rate');
    shippingRates.forEach((rate) => {
        const priceEl = rate.querySelector('.srs-se__rate-price');
        if (priceEl) {
            let priceInCents = parseFloat(rate.getAttribute('data-price-cents'));
            if (!isNaN(priceInCents)) {
                const formattedPrice = theme.Currency.formatMoney(priceInCents);
                if (priceEl.textContent.trim() !== formattedPrice.trim()) {
                    priceEl.textContent = formattedPrice;
                }
            }
        }
    });
}

// Observe the complete theme so AJAX-rendered prices use the same display rule.
function setupMutationObserver() {
    if (!theme.CustomerPriceDisplay.isTaxExclusive()) {
        return;
    }

    var scheduled = false;
    var pendingRoots = new Set();
    var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(cb){ return setTimeout(cb, 16); };

    function runUpdates() {
        pendingRoots.forEach(function(root) {
            updateAllPricesWithGST(root);
        });
        pendingRoots.clear();
    }

    function scheduleUpdate(root) {
        if (root) {
            pendingRoots.add(root);
        }
        if (scheduled) {
            return;
        }
        scheduled = true;
        raf(function() {
            scheduled = false;
            runUpdates();
        });
    }

    var domObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes') {
                scheduleUpdate(mutation.target);
            }
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    scheduleUpdate(node);
                }
            });
        });
    });

    updateAllPricesWithGST(document.body);
    domObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['data-price'],
        childList: true,
        subtree: true
    });
}

// Run the setup on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    setupMutationObserver();
});

//END DR CART
  
// Ensure .gitem elements always get full height. Use setProperty so we can apply !important.
document.addEventListener('DOMContentLoaded', function() {
  if(document.body && document.body.classList && document.body.classList.contains('template-search')) {
    return;
  }
  // If document div id contains wishProducts, skip this script (to avoid conflict with Wishlist app)
  if(document.getElementById('wishProducts')) {
    return;
  }
  // Helper to detect if a .gitem lives in a context we should ignore entirely
  var gitemIgnoreSelectors = [
    '.grid.rwcols-2.rwcols-md-3.rwcols-lg-3.grid-products.grid--view-items',
    '.mm6bx',
    '.product-rows'
  ];
  // Also ignore any .gitem that lives within a custom block wrapper
  gitemIgnoreSelectors.push('.custom-block');
  function shouldSkipGitem(el) {
    if(!el) return false;
    return gitemIgnoreSelectors.some(function(selector) {
      return !!el.closest(selector);
    });
  }

  // Apply to any existing elements (skip product grid entries)
  document.querySelectorAll('.gitem').forEach(function(element) {
    if(shouldSkipGitem(element)) return;
    try { element.style.setProperty('height', '100%', 'important'); } catch(e) {}
  });

  // Also ensure currently-selected items are handled
  document.querySelectorAll('.gitem.is-selected').forEach(function(element) {
    if(shouldSkipGitem(element)) return;
    try { element.style.setProperty('height', '100%', 'important'); } catch(e) {}
  });

  // Observe class changes on .gitem elements (some carousels add/remove .is-selected later)
  var gitems = document.querySelectorAll('.gitem');
  if (gitems.length) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var target = mutation.target;
          if (target && target.classList && target.classList.contains('gitem')) {
            if(shouldSkipGitem(target)) return;
            try { target.style.setProperty('height', '100%', 'important'); } catch(e) {}
          }
        }
      });
    });

    gitems.forEach(function(el) { observer.observe(el, { attributes: true, attributeFilter: ['class'] }); });
  }

  // Reapply on user interaction (click/touchstart). Attach both events correctly.
  ['click', 'touchstart'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      document.querySelectorAll('.gitem').forEach(function(element) {
        if(shouldSkipGitem(element)) return;
        try { element.style.setProperty('height', '100%', 'important'); } catch(e) {}
      });
    }, { passive: true });
  });
  // Also run again after window.load in case some widgets finish after DOMContentLoaded
    window.addEventListener('load', function(){
    document.querySelectorAll('.gitem').forEach(function(element) {
      if(shouldSkipGitem(element)) return;
      try { element.style.setProperty('height', '100%', 'important'); } catch(e) {}
    });
  });

  // Retry a few times with short delays to cover late-initialized carousels
  [100, 500, 1000].forEach(function(ms){
    setTimeout(function(){
      document.querySelectorAll('.gitem').forEach(function(element) {
        if(shouldSkipGitem(element)) return;
        try { element.style.setProperty('height', '100%', 'important'); } catch(e) {}
      });
    }, ms);
  });

  // Observe additions to the document so newly inserted .gitem nodes get style applied
  var bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.gitem')) {
              if(!shouldSkipGitem(node)) try { node.style.setProperty('height', '100%', 'important'); } catch(e) {}
            }
            // Also check descendants
            node.querySelectorAll && node.querySelectorAll('.gitem').forEach(function(el){
              if(shouldSkipGitem(el)) return;
              try { el.style.setProperty('height', '100%', 'important'); } catch(e) {}
            });
          }
        });
      }
    });
  });
  bodyObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
});

// Product Navigation Hide Functionality
document.addEventListener('DOMContentLoaded', function() {
  const STORAGE_KEY = 'hideProductNavigation';
  const container = document.querySelector('.sprnav-container');
  const modal = document.getElementById('sprnav-modal');
  const confirmBtn = document.getElementById('sprnav-confirm');
  const cancelBtn = document.getElementById('sprnav-cancel');
  const closeButtons = document.querySelectorAll('.sprnav-close');

  // Check if navigation should be hidden
  if (localStorage.getItem(STORAGE_KEY) === 'true' && container) {
    container.classList.add('hidden');
  }

  // Handle close button clicks
  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (modal) {
        modal.style.display = 'flex';
      }
    });
  });

  // Handle confirm button
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function() {
      localStorage.setItem(STORAGE_KEY, 'true');
      if (container) {
        container.classList.add('hidden');
      }
      if (modal) {
        modal.style.display = 'none';
      }
    });
  }

  // Handle cancel button
  if (cancelBtn) {
    cancelBtn.addEventListener('click', function() {
      if (modal) {
        modal.style.display = 'none';
      }
    });
  }

  // Close modal when clicking outside
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }
});


(function () {
  const STORAGE_KEY = "cc_hide_mps_sales_notification";
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

  function readStorageValue() {
    try {
      return window.localStorage ? window.localStorage.getItem(STORAGE_KEY) : null;
    } catch (error) {
      return null;
    }
  }

  function writeStorageValue(value) {
    try {
      if (window.localStorage) {
        window.localStorage.setItem(STORAGE_KEY, value);
      }
    } catch (error) {
      // Ignore storage access errors and rely on cookies instead.
    }
  }

  function readCookieValue() {
    const cookiePrefix = `${STORAGE_KEY}=`;
    const cookie = document.cookie
      .split("; ")
      .find((part) => part.indexOf(cookiePrefix) === 0);

    return cookie ? cookie.slice(cookiePrefix.length) : null;
  }

  function writeCookieValue(value) {
    document.cookie = `${STORAGE_KEY}=${value}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  }

  function isHidden() {
    return readStorageValue() === "1" || readCookieValue() === "1";
  }

  function hideToastie() {
    const elements = document.querySelectorAll("#mps-sales-notification");
    if (!elements.length) return false;

    elements.forEach(function (element) {
      element.style.setProperty("display", "none", "important");
      element.style.setProperty("visibility", "hidden", "important");
      element.style.setProperty("opacity", "0", "important");
      element.style.setProperty("pointer-events", "none", "important");
      element.setAttribute("data-cc-hidden", "1");
      element.setAttribute("aria-hidden", "true");
    });

    return true;
  }

  function persistHiddenState() {
    writeStorageValue("1");
    writeCookieValue("1");
  }

  function handleCloseInteraction(event) {
    const closeBtn = event.target && event.target.closest
      ? event.target.closest("#mps-sales-notification .sn-close-noty")
      : null;

    if (!closeBtn) return;

    persistHiddenState();
    hideToastie();
  }

  if (isHidden()) {
    hideToastie();
  }

  document.addEventListener("pointerdown", handleCloseInteraction, true);
  document.addEventListener("click", handleCloseInteraction, true);

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    handleCloseInteraction(event);
  }, true);

  const obs = new MutationObserver(function (mutations) {
    if (!isHidden()) return;

    for (const mutation of mutations) {
      if (mutation.type !== "childList" || !mutation.addedNodes?.length) continue;

      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        if (node.id === "mps-sales-notification" || node.querySelector?.("#mps-sales-notification")) {
          hideToastie();
          return;
        }
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  function forceProp(el, key, value) {
    if (!(el instanceof HTMLElement)) return;
    el.style.setProperty(key, value, 'important');
  }

  function applyAccountStyles(accountEl) {
    if (!(accountEl instanceof HTMLElement)) return;

    //forceProp(accountEl, '--minimum-touch-target', '0px');
    //forceProp(accountEl, '--shopify-account-button-text-color', '#000');
    //forceProp(accountEl, '--shopify-account-button-icon-color', '#000');
    //forceProp(accountEl, 'color', '#000');

    var inlineWrapper = accountEl.querySelector('#shopify-element-wrapper');
    if (inlineWrapper instanceof HTMLElement) {
      //forceProp(inlineWrapper, '--minimum-touch-target', '0px');
      //forceProp(inlineWrapper, '--shopify-account-button-text-color', '#000');
      //forceProp(inlineWrapper, '--shopify-account-button-icon-color', '#000');
      //forceProp(inlineWrapper, 'color', '#000');
    }

    if (accountEl.shadowRoot) {
      var shadowWrapper = accountEl.shadowRoot.getElementById('shopify-element-wrapper');
      if (shadowWrapper instanceof HTMLElement) {
        //forceProp(shadowWrapper, '--minimum-touch-target', '0px');
        //forceProp(shadowWrapper, '--shopify-account-button-text-color', '#000');
        //forceProp(shadowWrapper, '--shopify-account-button-icon-color', '#000');
        //forceProp(shadowWrapper, 'color', '#000');
      }
    }
  }

  function applyAllAccountStyles(root) {
    if (!root) return;
    if (root instanceof HTMLElement && root.matches('shopify-account')) {
      //applyAccountStyles(root);
    }
    if (root.querySelectorAll) {
      //root.querySelectorAll('shopify-account').forEach(applyAccountStyles);
    }
  }

  function initAccountStyleFixer() {
    //applyAllAccountStyles(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          applyAllAccountStyles(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('shopify-account').then(function () {
        applyAllAccountStyles(document);
      });
    }
  }

  function openShopifyAccountFromTrigger(triggerEl) {
    if (!(triggerEl instanceof HTMLElement)) return;

    var scope = triggerEl.closest('.header-account-button, .shopify-account-toolbar, .overhead-account-inline, li');
    var accountEl = scope ? scope.querySelector('shopify-account') : null;
    if (!accountEl) {
      accountEl = document.querySelector('shopify-account');
    }
    if (!(accountEl instanceof HTMLElement)) return;

    var rect = accountEl.getBoundingClientRect();
    if (!rect.width || !rect.height) {
      accountEl.click();
      return;
    }
    var x = rect.left + (rect.width / 2);
    var y = rect.top + (rect.height / 2);
    var clickTarget = document.elementFromPoint(x, y);

    if (clickTarget instanceof HTMLElement) {
      clickTarget.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true, cancelable: true, view: window, clientX: x, clientY: y }));
      clickTarget.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window, clientX: x, clientY: y }));
      clickTarget.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window, clientX: x, clientY: y }));
      clickTarget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window, clientX: x, clientY: y }));
      return;
    }

    accountEl.click();
  }

  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var trigger = event.target && event.target.closest ? event.target.closest('[data-account-trigger]') : null;
    if (!trigger) return;

    // Check if the click target itself is already inside the shopify-account component
    // If it is, let the component's own handlers process it normally without hijacking
    if (event.target.closest('shopify-account')) return;

    event.preventDefault();
    openShopifyAccountFromTrigger(trigger);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = event.target && event.target.closest ? event.target.closest('[data-account-trigger]') : null;
    if (!trigger) return;
    event.preventDefault();
    openShopifyAccountFromTrigger(trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountStyleFixer);
  } else {
    initAccountStyleFixer();
  }
})();

// Bundle kit modal: merges Print Sprint product bundles with Website Functions customisable bundle pages.
(function () {
  var triggerSelector = '[data-bundle-kits-trigger]';
  var priceContext = theme.CustomerPriceDisplay.isTaxExclusive() ? 'wholesale' : 'retail';
  var cacheKey = 's4rvs:bundleProductCache:v8:' + priceContext;
  var detailsSectionId = 'bundle-kit-card-data';
  var contextualPricingEndpoint = '/tools/rv/contextual-prices';
  var bundleMerchandisingEndpoint = '/tools/rv/solar-kit-bundle/merchandising';
  var contextualPricingBatchSize = 20;
  var contextualPricingMaxVariants = 100;
  var cacheTtl = 30 * 60 * 1000;
  var state = loadCache();
  var inFlightDetails = {};
  var inFlightBundleData = {};
  var loadedBundleDataUrls = {};
  var customisableBundlePriceStates = {};
  var customisableBundlePriceQueue = Promise.resolve();
  var hoverTimers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var intentPrefetchQueue = [];
  var intentPrefetchQueueScheduled = false;
  var intentPrefetchRunning = false;
  var intentPrefetchStarted = false;
  var intentPrefetchObserver = null;
  var intentMutationObserver = null;
  var intentViewportScanScheduled = false;
  var modal = null;
  var dialog = null;
  var bodyEl = null;
  var titleEl = null;
  var subtitleEl = null;
  var previouslyFocused = null;
  var activeTrigger = null;
  var modalTrigger = null;
  var restoreAfterQuickView = false;

  function loadCache() {
    var fallback = { products: {}, savedAt: Date.now() };
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem(cacheKey);
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.savedAt || Date.now() - parsed.savedAt > cacheTtl) return fallback;
      parsed.products = parsed.products || {};
      return parsed;
    } catch (error) {
      return fallback;
    }
  }

  function saveCache() {
    try {
      if (!window.sessionStorage) return;
      state.savedAt = Date.now();
      window.sessionStorage.setItem(cacheKey, JSON.stringify(state));
    } catch (error) {
      // Storage quota is non-critical; memory cache still works for this page.
    }
  }

  function storefrontRoot() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    } else if (window.routes && window.routes.root_url) {
      root = window.routes.root_url;
    }
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function resizeImage(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function detailsUrl(product) {
    if (!product || !product.url || product.url === '#') return '';
    return product.url + (product.url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + detailsSectionId;
  }

  function parsePositiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return parsed > 0 ? parsed : fallback;
  }

  function parseOptionalInteger(value) {
    if (value === null || typeof value === 'undefined' || value === '') return null;
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function normalizeEmbeddedProduct(product) {
    if (!product || typeof product !== 'object') return null;

    var id = extractProductId(product.id);
    if (!id) return null;

    var variantsCount = parseOptionalInteger(product.variant_count);
    var available = product.available === true || product.available === 'true';
    var variantAvailable = product.variant_available === true || product.variant_available === 'true';

    return {
      id: id,
      title: product.title || '',
      handle: product.handle || '',
      url: product.url || (product.handle ? storefrontRoot() + 'products/' + product.handle : '#'),
      vendor: product.vendor || '',
      product_type: product.product_type || '',
      image: resizeImage(product.image || '', 240),
      price: parseOptionalInteger(product.price) || 0,
      compare_at_price: parseOptionalInteger(product.compare_at_price) || 0,
      available: available,
      variant_id: product.variant_id ? String(product.variant_id) : '',
      variant_available: variantAvailable,
      variant_title: product.variant_title || '',
      variant_count: variantsCount || 1,
      subtitle: '',
      availability_html: '',
      availability_rank: available ? 0 : 2,
      button_label: 'Add to Cart',
      button_disabled: !product.variant_id || !variantAvailable,
      button_obsolete: false,
      button_stock_status: '',
      button_inventory: 0,
      button_rule_soldout: false,
      button_victron: false,
      min_qty: 1,
      step_qty: 1,
      max_qty: null,
      view_only: false,
      details_loaded: false
    };
  }

  function restoreLoadedProductDetails(product, existing) {
    if (!existing || !existing.details_loaded) return product;

    [
      'subtitle',
      'availability_html',
      'availability_rank',
      'variant_id',
      'variant_available',
      'button_label',
      'button_disabled',
      'button_obsolete',
      'button_stock_status',
      'button_inventory',
      'button_rule_soldout',
      'button_victron',
      'min_qty',
      'step_qty',
      'max_qty',
      'show_moq_note',
      'view_only',
      'details_loaded'
    ].forEach(function (key) {
      product[key] = existing[key];
    });

    return product;
  }

  function seedEmbeddedProducts(trigger) {
    if (!trigger || trigger.__bundleProductsSeeded) return;

    var raw = trigger.getAttribute('data-bundle-product-details') || '';
    var parsed = safeJsonParse(raw);
    if (typeof parsed === 'string') {
      parsed = safeJsonParse(parsed);
    }
    if (!Array.isArray(parsed)) return;

    var changed = false;
    parsed.forEach(function (item) {
      var product = normalizeEmbeddedProduct(item);
      if (!product) return;
      var existing = state.products[product.id] || null;
      state.products[product.id] = restoreLoadedProductDetails(Object.assign({}, existing || {}, product), existing);
      changed = true;
    });

    trigger.__bundleProductsSeeded = true;
    if (changed) saveCache();
  }

  function normalizeDetails(data) {
    var details = {
      subtitle: data.subtitle || '',
      availability_html: data.availability_html || '',
      availability_rank: parseOptionalInteger(data.availability_rank),
      variant_id: data.variant_id ? String(data.variant_id) : '',
      variant_available: data.variant_available === true || data.variant_available === 'true',
      button_label: data.button_label || 'Add to Cart',
      button_disabled: data.button_disabled === true || data.button_disabled === 'true',
      button_obsolete: data.button_obsolete === true || data.button_obsolete === 'true',
      button_stock_status: data.button_stock_status || '',
      button_inventory: parseOptionalInteger(data.button_inventory) || 0,
      button_rule_soldout: data.button_rule_soldout === true || data.button_rule_soldout === 'true',
      button_victron: data.button_victron === true || data.button_victron === 'true',
      min_qty: parsePositiveInteger(data.min_qty, 1),
      step_qty: parsePositiveInteger(data.step_qty, 1),
      max_qty: parseOptionalInteger(data.max_qty),
      show_moq_note: data.show_moq_note === true || data.show_moq_note === 'true',
      view_only: data.view_only === true || data.view_only === 'true',
      details_loaded: true
    };

    var price = parseOptionalInteger(data.price);
    var compareAtPrice = parseOptionalInteger(data.compare_at_price);
    if (price !== null) {
      details.price = price;
    }
    if (compareAtPrice !== null) {
      details.compare_at_price = compareAtPrice;
    }

    return details;
  }

  function mergeProductDetails(product, details) {
    var normalized = normalizeDetails(details || {});
    Object.keys(normalized).forEach(function (key) {
      product[key] = normalized[key];
    });
    return product;
  }

  function fetchProductDetails(product, options) {
    if (!product || product.details_loaded) return Promise.resolve(product);

    var url = detailsUrl(product);
    if (!url) return Promise.resolve(product);

    var id = product.id;
    if (inFlightDetails[id]) return inFlightDetails[id];

    var requestOptions = {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html, */*;q=0.01' }
    };
    if (options && options.priority === 'low') {
      requestOptions.priority = 'low';
    }

    inFlightDetails[id] = fetch(url, requestOptions)
      .then(function (response) {
        if (!response.ok) throw new Error('Bundle product detail lookup failed');
        return response.text();
      })
      .then(function (text) {
        var details = parseDetailsPayload(text);
        if (!details) throw new Error('Bundle product detail response was invalid');
        state.products[id] = mergeProductDetails(state.products[id] || product, details);
        saveCache();
        return state.products[id];
      })
      .catch(function () {
        return product;
      })
      .finally(function () {
        delete inFlightDetails[id];
      });

    return inFlightDetails[id];
  }

  function safeJsonParse(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function isDetailsPayload(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    return Object.prototype.hasOwnProperty.call(value, 'variant_id') ||
      Object.prototype.hasOwnProperty.call(value, 'subtitle') ||
      Object.prototype.hasOwnProperty.call(value, 'availability_html') ||
      Object.prototype.hasOwnProperty.call(value, 'availability_rank') ||
      Object.prototype.hasOwnProperty.call(value, 'button_label') ||
      Object.prototype.hasOwnProperty.call(value, 'min_qty') ||
      Object.prototype.hasOwnProperty.call(value, 'max_qty') ||
      Object.prototype.hasOwnProperty.call(value, 'view_only');
  }

  function parseDetailsPayload(responseText) {
    var text = String(responseText || '').trim();
    var parsed = safeJsonParse(text);
    if (isDetailsPayload(parsed)) return parsed;

    if (window.DOMParser && text.indexOf('<') !== -1) {
      var html = new DOMParser().parseFromString(text, 'text/html');
      var bodyText = html && html.body ? html.body.textContent.trim() : '';
      parsed = safeJsonParse(bodyText);
      if (isDetailsPayload(parsed)) return parsed;
    }

    var firstBrace = text.indexOf('{');
    var lastBrace = text.lastIndexOf('}');
    if (firstBrace !== -1 && lastBrace > firstBrace) {
      parsed = safeJsonParse(text.slice(firstBrace, lastBrace + 1));
      if (isDetailsPayload(parsed)) return parsed;
    }

    return null;
  }

  function extractProductId(value) {
    var match = String(value || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function normalizeBundleItems(trigger) {
    var raw = trigger.getAttribute('data-bundle-items') || '';
    var parsed = safeJsonParse(raw);
    if (typeof parsed === 'string') {
      parsed = safeJsonParse(parsed);
    }
    if (parsed && parsed.value && Array.isArray(parsed.value)) {
      parsed = parsed.value;
    }
    if (!Array.isArray(parsed)) return [];

    var seen = {};
    return parsed.map(function (item) {
      var sourceId = typeof item === 'object' && item !== null ? (item.id || item.product_id || item.productId) : item;
      var id = extractProductId(sourceId);
      if (!id || seen[id]) return null;
      seen[id] = true;
      var saveValue = typeof item === 'object' && item !== null ? parseFloat(item.save || item.saving || 0) : 0;
      return {
        id: id,
        save: isNaN(saveValue) ? 0 : saveValue
      };
    }).filter(Boolean);
  }

  function normalizeCustomisableBundlePages(trigger) {
    var raw = trigger.getAttribute('data-customisable-bundle-pages') || '';
    var parsed = safeJsonParse(raw);
    if (typeof parsed === 'string') {
      parsed = safeJsonParse(parsed);
    }
    if (!Array.isArray(parsed)) return [];

    var seen = {};
    return parsed.map(function (item) {
      if (!item || typeof item !== 'object') return null;
      var id = String(item.id || item.url || '');
      var title = String(item.title || '');
      var url = String(item.url || '');
      if (!id || !title || !url || seen[id]) return null;
      seen[id] = true;
      return {
        id: id,
        title: title,
        subtitle: String(item.subtitle || ''),
        url: url,
        image: String(item.image || ''),
        badge: String(item.badge || ''),
        storefrontKey: String(item.storefront_key || ''),
        formattedStartingPrice: String(item.formatted_starting_price || ''),
        currencyCode: String(item.currency_code || ''),
        savingsText: String(item.savings_text || '')
      };
    }).filter(Boolean);
  }

  function fetchBundleJson(url, options, failureMessage) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    return fetch(url, Object.assign({}, options, { signal: controller.signal })).then(function (response) {
      return response.text().then(function (responseText) {
        if (!response.ok) {
          throw new Error(failureMessage + ' (HTTP ' + response.status + ').');
        }
        var payload = safeJsonParse(responseText);
        if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
          throw new Error(failureMessage + ' Shopify returned invalid JSON.');
        }
        return payload;
      });
    }).finally(function () { window.clearTimeout(timeout); });
  }

  function fetchCustomisableBundlePricingVariants(bundle) {
    var url = new URL(bundleMerchandisingEndpoint, window.location.origin);
    url.searchParams.set('storefrontKey', bundle.storefrontKey);
    return fetchBundleJson(
      url.pathname + url.search,
      {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      },
      'Unable to load the bundle pricing components'
    ).then(function (payload) {
      if (
        payload.v !== 1 ||
        payload.storefrontKey !== bundle.storefrontKey ||
        !Array.isArray(payload.variantIds) ||
        payload.variantIds.length < 1 ||
        payload.variantIds.length > contextualPricingMaxVariants
      ) {
        throw new Error('The bundle pricing component response is invalid.');
      }
      var seen = {};
      return payload.variantIds.map(function (variantId) {
        var normalizedId = String(variantId || '');
        if (
          !/^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/.test(normalizedId) ||
          seen[normalizedId]
        ) {
          throw new Error('The bundle pricing component response is invalid.');
        }
        seen[normalizedId] = true;
        return normalizedId;
      });
    });
  }

  function fetchContextualPricingBatch(variantIds) {
    var url = new URL(contextualPricingEndpoint, window.location.origin);
    url.searchParams.set('variants', variantIds.join(','));
    return fetchBundleJson(
      url.pathname + url.search,
      {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      },
      'Unable to load the customer bundle prices'
    ).then(function (payload) {
      if (
        payload.v !== 2 ||
        !/^[A-Z]{3}$/.test(String(payload.currencyCode || '')) ||
        payload.taxDisplay !== 'ex-gst' ||
        !Array.isArray(payload.prices) ||
        payload.prices.length !== variantIds.length
      ) {
        throw new Error('The customer bundle price response is invalid.');
      }
      var expected = {};
      var received = {};
      variantIds.forEach(function (variantId) { expected[variantId] = true; });
      var prices = payload.prices.map(function (price) {
        var variantId = String(price && price.variantId || '');
        var priceCents = Number(price && price.priceCents);
        if (
          !expected[variantId] ||
          received[variantId] ||
          !Number.isSafeInteger(priceCents) ||
          priceCents < 0
        ) {
          throw new Error('The customer bundle price response is invalid.');
        }
        received[variantId] = true;
        return { variantId: variantId, priceCents: priceCents };
      });
      return {
        currencyCode: payload.currencyCode,
        taxDisplay: payload.taxDisplay,
        prices: prices
      };
    });
  }

  function loadCustomisableBundleContextualPricing(variantIds) {
    var contextualPricing = {
      v: 2,
      currencyCode: '',
      taxDisplay: 'ex-gst',
      prices: []
    };
    var request = Promise.resolve();
    for (var index = 0; index < variantIds.length; index += contextualPricingBatchSize) {
      (function (batch) {
        request = request.then(function () {
          return fetchContextualPricingBatch(batch).then(function (response) {
            if (
              contextualPricing.currencyCode &&
              contextualPricing.currencyCode !== response.currencyCode
            ) {
              throw new Error('Shopify returned inconsistent bundle price currencies.');
            }
            contextualPricing.currencyCode = response.currencyCode;
            Array.prototype.push.apply(contextualPricing.prices, response.prices);
          });
        });
      })(variantIds.slice(index, index + contextualPricingBatchSize));
    }
    return request.then(function () {
      contextualPricing.prices.sort(function (left, right) {
        return left.variantId.localeCompare(right.variantId);
      });
      return contextualPricing;
    });
  }

  function calculateCustomisableBundleStartingPrice(bundle, contextualPricing) {
    return fetchBundleJson(
      bundleMerchandisingEndpoint,
      {
        cache: 'no-store',
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          v: 1,
          storefrontKey: bundle.storefrontKey,
          contextualPricing: contextualPricing
        })
      },
      'Unable to calculate the customer bundle starting price'
    ).then(function (payload) {
      if (
        payload.v !== 1 ||
        payload.storefrontKey !== bundle.storefrontKey ||
        payload.currencyCode !== contextualPricing.currencyCode ||
        payload.taxDisplay !== contextualPricing.taxDisplay ||
        !Number.isSafeInteger(payload.startingPriceCents) ||
        payload.startingPriceCents < 0
      ) {
        throw new Error('The customer bundle starting price response is invalid.');
      }
      return {
        currencyCode: payload.currencyCode,
        startingPriceCents: payload.startingPriceCents
      };
    });
  }

  function loadCustomisableBundleStartingPrice(bundle) {
    var storefrontKey = bundle.storefrontKey;
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(storefrontKey)) {
      return Promise.resolve({ status: 'failed' });
    }
    var existing = customisableBundlePriceStates[storefrontKey];
    if (existing) {
      return existing.promise || Promise.resolve(existing);
    }

    var state = { status: 'loading' };
    customisableBundlePriceStates[storefrontKey] = state;
    state.promise = customisableBundlePriceQueue
      .then(function () { return fetchCustomisableBundlePricingVariants(bundle); })
      .then(loadCustomisableBundleContextualPricing)
      .then(function (contextualPricing) {
        return calculateCustomisableBundleStartingPrice(bundle, contextualPricing);
      })
      .then(function (price) {
        state.status = 'ready';
        state.currencyCode = price.currencyCode;
        state.startingPriceCents = price.startingPriceCents;
        return state;
      })
      .catch(function (error) {
        state.status = 'failed';
        console.error(
          '[Bundle kits] Contextual starting price failed for ' + storefrontKey + '.',
          error
        );
        return state;
      })
      .finally(function () {
        delete state.promise;
      });
    customisableBundlePriceQueue = state.promise;
    return state.promise;
  }

  function loadCustomisableBundleStartingPrices(bundles, onPriceSettled) {
    if (!theme.CustomerPriceDisplay.isTaxExclusive()) return Promise.resolve();
    var request = Promise.resolve();
    (bundles || []).forEach(function (bundle) {
      request = request
        .then(function () { return loadCustomisableBundleStartingPrice(bundle); })
        .then(function () {
          if (typeof onPriceSettled === 'function') onPriceSettled();
        });
    });
    return request;
  }

  function initializeBundleStartingPrices(root) {
    var selector = '[data-bundle-starting-price]:not([data-bundle-price-initialized])';
    var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    elements.forEach(function (element) {
      element.setAttribute('data-bundle-price-initialized', '');
      var bundle = { storefrontKey: element.getAttribute('data-bundle-starting-price') };
      loadCustomisableBundleStartingPrice(bundle).then(function (price) {
        if (!element.isConnected) return;
        element.setAttribute('aria-busy', 'false');
        element.setAttribute('data-bundle-price-status', price.status);
        element.textContent = price.status === 'ready'
          ? 'From ' + formatMoney(price.startingPriceCents)
          : 'From price unavailable';
      });
    });
  }

  function watchBundleStartingPrices() {
    initializeBundleStartingPrices(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) initializeBundleStartingPrices(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () { observer.disconnect(); });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        initializeBundleStartingPrices(document);
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBundleStartingPrices, { once: true });
  } else {
    watchBundleStartingPrices();
  }

  function isBundleDataPayload(value) {
    return !!(value && typeof value === 'object' && !Array.isArray(value) && Array.isArray(value.items));
  }

  function parseBundleDataPayload(responseText) {
    var text = String(responseText || '').trim();
    var parsed = safeJsonParse(text);
    if (isBundleDataPayload(parsed)) return parsed;

    if (window.DOMParser && text.indexOf('<') !== -1) {
      var html = new DOMParser().parseFromString(text, 'text/html');
      var bodyText = html && html.body ? html.body.textContent.trim() : '';
      parsed = safeJsonParse(bodyText);
      if (isBundleDataPayload(parsed)) return parsed;
    }

    var firstBrace = text.indexOf('{');
    var lastBrace = text.lastIndexOf('}');
    if (firstBrace !== -1 && lastBrace > firstBrace) {
      parsed = safeJsonParse(text.slice(firstBrace, lastBrace + 1));
      if (isBundleDataPayload(parsed)) return parsed;
    }

    return null;
  }

  function normalizeBundleDataItem(item) {
    if (!item || typeof item !== 'object') return null;

    var source = item.product && typeof item.product === 'object' ? item.product : item;
    var product = normalizeEmbeddedProduct(source);
    if (!product) return null;

    var existing = state.products[product.id] || null;
    state.products[product.id] = mergeProductDetails(Object.assign({}, existing || {}, product), source);

    var saveValue = parseFloat(item.save || item.saving || source.save || source.saving || 0);
    return {
      id: product.id,
      save: isNaN(saveValue) ? 0 : saveValue
    };
  }

  function updateTriggerBundleItems(trigger, bundleItems) {
    if (!trigger || !bundleItems || !bundleItems.length) return;

    var currentItems = normalizeBundleItems(trigger);
    var changed = false;
    var nextItems = currentItems.map(function (item) {
      return {
        id: item.id,
        save: item.save
      };
    });

    bundleItems.forEach(function (item) {
      var existing = nextItems.find(function (current) { return current.id === item.id; });
      if (existing) {
        if (item.save && existing.save !== item.save) {
          existing.save = item.save;
          changed = true;
        }
      } else {
        nextItems.push({ id: item.id, save: item.save });
        changed = true;
      }
    });

    if (!currentItems.length && nextItems.length) {
      changed = true;
    }

    if (changed) {
      trigger.setAttribute('data-bundle-items', JSON.stringify(nextItems));
    }
  }

  function applyBundleData(trigger, data) {
    if (!isBundleDataPayload(data)) return false;

    var bundleItems = [];
    data.items.forEach(function (item) {
      var normalized = normalizeBundleDataItem(item);
      if (normalized) bundleItems.push(normalized);
    });

    if (bundleItems.length) {
      updateTriggerBundleItems(trigger, bundleItems);
      saveCache();
    }

    return bundleItems.length > 0;
  }

  function bundleDataUrl(trigger) {
    if (!trigger) return '';
    var url = trigger.getAttribute('data-bundle-data-url') || '';
    if (url) return url;

    var productUrl = trigger.getAttribute('data-product-url') || '';
    return productUrl ? appendSectionParam(productUrl, 'bundle-kits-data') : '';
  }

  function fetchBundleData(trigger, options) {
    if (!trigger || trigger.__bundleKitsDataLoaded) return Promise.resolve(null);

    var url = bundleDataUrl(trigger);
    if (!url) return Promise.resolve(null);
    if (loadedBundleDataUrls[url]) {
      trigger.__bundleKitsDataLoaded = true;
      return Promise.resolve(null);
    }

    var currentItems = normalizeBundleItems(trigger);
    if (currentItems.length && bundleProductsAreReady(currentItems)) {
      trigger.__bundleKitsDataLoaded = true;
      loadedBundleDataUrls[url] = true;
      return Promise.resolve(null);
    }

    if (inFlightBundleData[url]) return inFlightBundleData[url];

    var requestOptions = {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html, */*;q=0.01' }
    };
    if (options && options.priority === 'low') {
      requestOptions.priority = 'low';
    }

    inFlightBundleData[url] = fetch(url, requestOptions)
      .then(function (response) {
        if (!response.ok) throw new Error('Bundle kit data lookup failed');
        return response.text();
      })
      .then(function (text) {
        var data = parseBundleDataPayload(text);
        if (!data) throw new Error('Bundle kit data response was invalid');
        applyBundleData(trigger, data);
        trigger.__bundleKitsDataLoaded = true;
        loadedBundleDataUrls[url] = true;
        return data;
      })
      .finally(function () {
        delete inFlightBundleData[url];
      });

    return inFlightBundleData[url];
  }

  function resolveProductsForTrigger(trigger, items, options) {
    seedEmbeddedProducts(trigger);
    return fetchBundleData(trigger, options).then(function () {
      var latestItems = normalizeBundleItems(trigger);
      return resolveProductsWithDetails(latestItems.length ? latestItems : items, options);
    });
  }

  function bundleProductsAreReady(items) {
    return items.every(function (item) {
      return !!(state.products[item.id] && state.products[item.id].details_loaded);
    });
  }

  function resolveProductsWithDetails(items, options) {
    var ids = items.map(function (item) { return item.id; });
    var products = ids.map(function (id) { return state.products[id]; }).filter(Boolean);
    if (!products.length) return Promise.resolve(state.products);
    return Promise.all(products.map(function (product) {
      return fetchProductDetails(product, options);
    })).then(function () {
      return state.products;
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function formatSave(value) {
    var fixed = Number(value || 0).toFixed(2);
    return fixed.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
  }

  function formatBundleSave(value) {
    var numeric = Number(value || 0);
    return numeric > 50 ? '$' + formatSave(numeric) : formatSave(numeric) + '%';
  }

  function normalizeBundleStockStatus(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getBundleAvailabilityRank(product) {
    if (!product) return 2;

    var explicitRank = parseOptionalInteger(product.availability_rank);
    if (explicitRank !== null) return explicitRank;

    var status = normalizeBundleStockStatus(product.button_stock_status);
    var availabilityText = normalizeBundleStockStatus(product.availability_html);
    var inventory = parseOptionalInteger(product.button_inventory) || 0;

    if (
      product.button_disabled ||
      product.button_rule_soldout ||
      product.variant_available === false ||
      status === 'out of stock' ||
      status === 'obsolete' ||
      status === 'discontinued' ||
      availabilityText.indexOf('out of stock') !== -1
    ) {
      return 2;
    }

    if (
      status === 'due in soon' ||
      status === 'pre-order' ||
      status === 'special order' ||
      (status === 'built to order' && inventory <= 0) ||
      availabilityText.indexOf('expected ') !== -1 ||
      availabilityText.indexOf('backorder') !== -1 ||
      availabilityText.indexOf('built to order') !== -1 ||
      availabilityText.indexOf('special order') !== -1
    ) {
      return 1;
    }

    return 0;
  }

  function focusableElements() {
    if (!dialog) return [];
    return Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
      });
  }

  function handleModalKeydown(event) {
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') {
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = focusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function ensureModal() {
    if (modal) return;

    modal = document.createElement('div');
    modal.className = 'bundle-kits-modal';
    modal.hidden = true;
    modal.innerHTML = '' +
      '<div class="bundle-kits-modal__overlay" data-bundle-kits-close></div>' +
      '<div class="bundle-kits-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="bundle-kits-modal-title" tabindex="-1">' +
        '<div class="bundle-kits-modal__header">' +
          '<div>' +
            '<p class="bundle-kits-modal__eyebrow">Bundle kits</p>' +
            '<h2 class="bundle-kits-modal__title" id="bundle-kits-modal-title">Available bundles</h2>' +
            '<p class="bundle-kits-modal__subtitle" data-bundle-kits-subtitle></p>' +
          '</div>' +
          '<button type="button" class="bundle-kits-modal__close" data-bundle-kits-close aria-label="Close bundle kits"><i class="at at-times-l" aria-hidden="true"></i></button>' +
        '</div>' +
        '<div class="bundle-kits-modal__body" data-bundle-kits-body></div>' +
      '</div>';

    document.body.appendChild(modal);
    dialog = modal.querySelector('.bundle-kits-modal__dialog');
    bodyEl = modal.querySelector('[data-bundle-kits-body]');
    titleEl = modal.querySelector('#bundle-kits-modal-title');
    subtitleEl = modal.querySelector('[data-bundle-kits-subtitle]');

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-bundle-kits-close]')) {
        closeModal();
      }
    });
    document.addEventListener('keydown', handleModalKeydown);
  }

  function setActiveTriggerExpanded(trigger, expanded) {
    if (activeTrigger && activeTrigger !== trigger) {
      activeTrigger.setAttribute('aria-expanded', 'false');
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    activeTrigger = expanded ? trigger : null;
  }

  function renderStatus(message, extraClass) {
    return '<p class="bundle-kits-modal__status' + (extraClass ? ' ' + extraClass : '') + '" role="status" aria-live="polite">' + escapeHtml(message) + '</p>';
  }

  function showLoading(trigger, count) {
    ensureModal();
    var productTitle = trigger.getAttribute('data-product-title') || '';
    titleEl.textContent = 'Available bundles';
    subtitleEl.textContent = productTitle ? 'Kits that include ' + productTitle : 'Kits that include this product';

    var skeletonCount = Math.max(2, Math.min(count || 3, 4));
    var skeletons = [];
    for (var index = 0; index < skeletonCount; index += 1) {
      skeletons.push(
        '<div class="bundle-kits-modal__skeleton">' +
          '<div class="bundle-kits-modal__skeleton-img"></div>' +
          '<div class="bundle-kits-modal__skeleton-copy">' +
            '<div class="bundle-kits-modal__skeleton-line"></div>' +
            '<div class="bundle-kits-modal__skeleton-line"></div>' +
            '<div class="bundle-kits-modal__skeleton-line"></div>' +
          '</div>' +
        '</div>'
      );
    }
    bodyEl.innerHTML = renderStatus('Loading bundle kits...', 'v-hidden') +
      '<div class="bundle-kits-modal__grid" aria-hidden="true">' + skeletons.join('') + '</div>';
  }

  function openModal(trigger) {
    var items = normalizeBundleItems(trigger);
    var customisableBundles = normalizeCustomisableBundlePages(trigger);
    ensureModal();
    seedEmbeddedProducts(trigger);
    previouslyFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modalTrigger = trigger;
    modal.hidden = false;
    setActiveTriggerExpanded(trigger, true);
    showLoading(trigger, items.length + customisableBundles.length);
    document.body.classList.add('bundle-kits-modal-open');
    dialog.focus();

    if (!items.length && !customisableBundles.length) {
      renderEmpty('No bundle kits are currently linked to this product.');
      return;
    }

    if (!items.length) {
      renderProductsWithContextualPrices(trigger, [], {}, customisableBundles);
      return;
    }

    resolveProductsForTrigger(trigger, items)
      .then(function (productMap) {
        var latestItems = normalizeBundleItems(trigger);
        renderProductsWithContextualPrices(trigger, latestItems.length ? latestItems : items, productMap, customisableBundles);
      })
      .catch(function () {
        if (customisableBundles.length) {
          renderProductsWithContextualPrices(
            trigger,
            [],
            {},
            customisableBundles,
            'Normal bundle kit details are unavailable right now. Please try again shortly.'
          );
          return;
        }
        renderEmpty('Bundle kit details are unavailable right now. Please try again shortly.');
      });
  }

  function closeModal() {
    if (!modal) return;
    restoreAfterQuickView = false;
    setActiveTriggerExpanded(modalTrigger || activeTrigger, false);
    modalTrigger = null;
    modal.hidden = true;
    document.body.classList.remove('bundle-kits-modal-open');
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function suspendModalForQuickView() {
    if (!modal || modal.hidden) return;
    restoreAfterQuickView = true;
    setActiveTriggerExpanded(modalTrigger || activeTrigger, false);
    modal.hidden = true;
    document.body.classList.remove('bundle-kits-modal-open');
  }

  function restoreModalAfterQuickView() {
    if (!restoreAfterQuickView || !modal) return;
    restoreAfterQuickView = false;
    window.setTimeout(function () {
      if (!modal) return;
      modal.hidden = false;
      if (modalTrigger) {
        setActiveTriggerExpanded(modalTrigger, true);
      }
      document.body.classList.add('bundle-kits-modal-open');
      if (dialog && typeof dialog.focus === 'function') {
        dialog.focus();
      }
    }, 0);
  }

  function renderEmpty(message) {
    bodyEl.innerHTML = renderStatus(message);
  }

  function renderProducts(trigger, items, productMap, customisableBundles, normalBundleError) {
    var isB2B = theme.CustomerPriceDisplay.isTaxExclusive();
    var productTitle = trigger.getAttribute('data-product-title') || '';
    var options = {
      quickViewEnabled: trigger.getAttribute('data-enable-quick-view') !== 'false',
      wishlistEnabled: trigger.getAttribute('data-enable-wishlist') !== 'false',
      wishlistUrl: trigger.getAttribute('data-wishlist-url') || storefrontRoot() + 'pages/wishlist'
    };
    var rows = [];
    var missingCount = 0;
    var customisableBundleCards = (customisableBundles || []).map(renderCustomisableBundleCard);

    items.forEach(function (item, index) {
      var product = productMap[item.id];
      if (!product) {
        missingCount += 1;
        return;
      }
      rows.push({
        item: item,
        product: product,
        index: index,
        availabilityRank: getBundleAvailabilityRank(product)
      });
    });

    if (!rows.length && !customisableBundleCards.length) {
      renderEmpty('Bundle kit details are still syncing. Please check this product again shortly.');
      return;
    }

    rows.sort(function (left, right) {
      var rankDiff = left.availabilityRank - right.availabilityRank;
      return rankDiff !== 0 ? rankDiff : left.index - right.index;
    });

    var cards = rows.map(function (row) {
      return renderProductCard(row.product, row.item, isB2B, options);
    }).concat(customisableBundleCards);

    titleEl.textContent = cards.length === 1 ? '1 bundle kit available' : cards.length + ' bundle kits available';
    subtitleEl.textContent = productTitle ? 'Kits that include ' + productTitle : 'Kits that include this product';
    bodyEl.innerHTML = '<div class="bundle-kits-modal__grid">' + cards.join('') + '</div>' +
      (normalBundleError ? renderStatus(normalBundleError, 'bundle-kits-modal__status--error') : '');
    syncWishlistButtons(bodyEl);
  }

  function renderProductsWithContextualPrices(
    trigger,
    items,
    productMap,
    customisableBundles,
    normalBundleError
  ) {
    renderProducts(
      trigger,
      items,
      productMap,
      customisableBundles,
      normalBundleError
    );
    loadCustomisableBundleStartingPrices(customisableBundles, function () {
      if (!modal || modal.hidden || modalTrigger !== trigger) return;
      renderProducts(
        trigger,
        items,
        productMap,
        customisableBundles,
        normalBundleError
      );
    });
  }

  function renderCustomisableBundleCard(bundle) {
    var title = escapeHtml(bundle.title);
    var url = escapeHtml(bundle.url);
    var image = bundle.image ? escapeHtml(bundle.image) : '';
    var subtitle = bundle.subtitle ? '<p class="bundle-kit-card__subtitle">' + escapeHtml(bundle.subtitle) + '</p>' : '';
    var badge = escapeHtml(bundle.badge || 'Customisable bundle');
    var pricesTaxExclusive = theme.CustomerPriceDisplay.isTaxExclusive();
    var showSavings = !pricesTaxExclusive;
    var savingsBadge = showSavings && bundle.savingsText ? '<span class="bundle-kit-card__badge bundle-kit-card__badge--save">' + escapeHtml(bundle.savingsText) + '</span>' : '';
    var startingPrice = '';
    if (pricesTaxExclusive) {
      var priceState = customisableBundlePriceStates[bundle.storefrontKey];
      if (priceState && priceState.status === 'ready') {
        startingPrice = '<div class="bundle-kit-card__price" aria-live="polite">From ' + escapeHtml(formatMoney(priceState.startingPriceCents)) + '</div>';
      } else if (
        !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(bundle.storefrontKey) ||
        (priceState && priceState.status === 'failed')
      ) {
        startingPrice = '<div class="bundle-kit-card__price bundle-kit-card__price--error" role="status">From price unavailable</div>';
      } else {
        startingPrice = '<div class="bundle-kit-card__price bundle-kit-card__price--loading" role="status" aria-live="polite">Checking price&hellip;</div>';
      }
    } else if (bundle.formattedStartingPrice) {
      startingPrice = '<div class="bundle-kit-card__price">From ' + escapeHtml(bundle.formattedStartingPrice) + '</div>';
    }

    return '' +
      '<article class="bundle-kit-card bundle-kit-card--customisable">' +
        '<div class="bundle-kit-card__media">' +
          '<a class="bundle-kit-card__image-wrap" href="' + url + '" aria-label="' + title + '">' +
            (image ? '<img class="bundle-kit-card__image" src="' + image + '" alt="' + title + '" loading="lazy" decoding="async" width="104" height="104" sizes="104px">' : '') +
          '</a>' +
        '</div>' +
        '<div class="bundle-kit-card__content">' +
          '<div class="bundle-kit-card__top">' +
            '<div class="bundle-kit-card__main">' +
              '<h3 class="bundle-kit-card__title"><a href="' + url + '">' + title + '</a></h3>' +
              subtitle +
              '<div class="bundle-kit-card__badges"><span class="bundle-kit-card__badge bundle-kit-card__badge--value">' + badge + '</span>' + savingsBadge + '</div>' +
            '</div>' +
            '<div class="bundle-kit-card__side bundle-kit-card__side--customisable">' +
              startingPrice +
              '<div class="bundle-kit-card__purchase">' +
                '<a class="btn pr_btn product-form__view-nav bundle-kit-card__submit bundle-kit-card__submit--link" href="' + url + '">' +
                  '<span class="txt">Configure bundle</span>' +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function appendSectionParam(url, sectionId) {
    if (!url || url === '#') return '#';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;
  }

  function syncWishlistButtons(root) {
    var wishlist;
    try {
      wishlist = window.localStorage ? window.localStorage.getItem('wishlist') : null;
    } catch (error) {
      wishlist = null;
    }
    if (!wishlist || wishlist === '+') return;

    var handles = String(wishlist).split('+').filter(Boolean);
    if (!handles.length) return;

    var buttons = Array.prototype.slice.call((root || document).querySelectorAll('.wishlist[rel]'));
    buttons.forEach(function (button) {
      if (handles.indexOf(button.getAttribute('rel')) === -1) return;
      button.classList.remove('addto-wishlist');
      var label = button.querySelector('span');
      if (label) label.textContent = theme.wlAvailable || 'Added to wishlist';
      if (window.theme && typeof theme.renderWishlistActiveIcon === 'function') {
        theme.renderWishlistActiveIcon(button, false);
      }
    });

    var favCounts = document.querySelectorAll('.favCount');
    Array.prototype.forEach.call(favCounts, function (count) {
      count.textContent = handles.length;
      count.classList.remove('hide');
    });
  }

  function renderProductCard(product, item, isB2B, options) {
    var title = escapeHtml(product.title);
    var vendor = escapeHtml(product.vendor);
    var url = escapeHtml(product.url);
    var image = product.image ? escapeHtml(product.image) : '';
    var subtitle = product.subtitle ? '<p class="bundle-kit-card__subtitle">' + escapeHtml(product.subtitle) + '</p>' : '';
    var availability = product.availability_html || fallbackAvailability(product);
    var saveValue = Number(item.save || 0);
    var badges = [];

    if (!isB2B && saveValue > 0) {
      badges.push('<span class="bundle-kit-card__badge bundle-kit-card__badge--save">Save ' + escapeHtml(formatBundleSave(saveValue)) + ' by buying in a bundle</span>');
    }

    return '' +
      '<article class="bundle-kit-card">' +
        '<div class="bundle-kit-card__media">' +
          '<a class="bundle-kit-card__image-wrap" href="' + url + '" aria-label="' + title + '">' +
            (image ? '<img class="bundle-kit-card__image" src="' + image + '" alt="' + title + '" loading="lazy" decoding="async" width="104" height="104" sizes="104px">' : '') +
          '</a>' +
          '<div class="bundle-kit-card__media-controls">' +
            renderCardActions(product, title, options) +
          '</div>' +
        '</div>' +
        '<div class="bundle-kit-card__content">' +
          '<div class="bundle-kit-card__top">' +
            '<div class="bundle-kit-card__main">' +
              '<h3 class="bundle-kit-card__title"><a href="' + url + '">' + title + '</a></h3>' +
              (vendor ? '<p class="bundle-kit-card__vendor">' + vendor + '</p>' : '') +
              subtitle +
              '<div class="bundle-kit-card__availability">' + availability + '</div>' +
              '<div class="bundle-kit-card__badges">' + badges.join('') + '</div>' +
            '</div>' +
            '<div class="bundle-kit-card__side">' +
              '<div class="bundle-kit-card__price">' + escapeHtml(formatMoney(product.price)) + '</div>' +
              renderPurchaseControls(product, title) +
            '</div>' +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function fallbackAvailability(product) {
    var availabilityText = product.available ? 'In Stock' : 'Check availability';
    var availabilityClass = product.available ? 'in-stock' : 'out-of-stock';
    return '<div class="product-stock"><span style="color:#000;">Availability: <span class="' + availabilityClass + '">' + availabilityText + '</span></span></div>';
  }

  function renderCardActions(product, escapedTitle, options) {
    var url = escapeHtml(product.url);
    var actions = [];

    if (options.quickViewEnabled) {
      actions.push(
        '<a href="' + url + '" data-href="' + escapeHtml(appendSectionParam(product.url, 'quick-view')) + '" class="btn quick-view bundle-kit-card__quick-view" aria-label="Quick view ' + escapedTitle + '" title="Quick view">' +
          '<i class="at at-search-plus" aria-hidden="true"></i><span class="tooltip-label">Quick view</span>' +
        '</a>'
      );
    } else {
      actions.push(
        '<a href="' + url + '" class="btn" aria-label="View ' + escapedTitle + '" title="View product">' +
          '<i class="at at-eye" aria-hidden="true"></i><span class="tooltip-label">View product</span>' +
        '</a>'
      );
    }

    if (options.wishlistEnabled) {
      actions.push(
        '<a href="' + escapeHtml(options.wishlistUrl) + '" class="btn wishlist addto-wishlist" rel="' + escapeHtml(product.handle) + '" aria-label="Add ' + escapedTitle + ' to wishlist" title="Add to wishlist">' +
          theme.getWishlistEmptyIconMarkup() +
          '<span class="tooltip-label">Add to wishlist</span>' +
        '</a>'
      );
    }

    return '<div class="button-set bundle-kit-card__actions">' + actions.join('') + '</div>';
  }

  function renderPurchaseControls(product, escapedTitle) {
    var url = escapeHtml(product.url);
    var variantId = product.variant_id ? String(product.variant_id) : '';

    if (!variantId) {
      return '' +
        '<div class="bundle-kit-card__purchase">' +
          '<a class="btn pr_btn product-form__view-nav bundle-kit-card__submit bundle-kit-card__submit--link" href="' + url + '">' +
            '<span class="txt">View product</span>' +
          '</a>' +
        '</div>';
    }

    var variantKey = variantId.replace(/\D/g, '') || String(product.id);
    var sectionId = 'bundle-kits-' + variantKey;
    var formId = 'bundle-kit-form-' + variantKey;
    var quantityId = 'Quantity-' + sectionId;
    var minQty = parsePositiveInteger(product.min_qty, 1);
    var stepQty = parsePositiveInteger(product.step_qty, 1);
    var maxQty = parseOptionalInteger(product.max_qty);
    var maxAttr = maxQty !== null ? ' data-max="' + maxQty + '" max="' + maxQty + '"' : '';
    var disabled = product.button_disabled || product.button_rule_soldout;
    var disabledAttr = disabled ? ' disabled="disabled" aria-disabled="true"' : '';
    var rawLabel = product.button_label || 'Add to Cart';
    if (/^view(\s+product)?$/i.test(rawLabel)) {
      rawLabel = 'Add to Cart';
    }
    var label = escapeHtml(rawLabel);

    return '' +
      '<div class="bundle-kit-card__purchase">' +
        '<product-form class="product-form bundle-kit-card__product-form" data-hide-errors="false" data-section-id="' + sectionId + '">' +
          '<div class="product-form__error-message-wrapper bundle-kit-card__error" role="alert" hidden><span class="product-form__error-message"></span></div>' +
          '<form method="post" action="' + escapeHtml(storefrontRoot() + 'cart/add') + '" id="' + formId + '" class="form bundle-kit-card__form" novalidate="novalidate" data-type="add-to-cart-form">' +
            '<input type="hidden" name="id" value="' + escapeHtml(variantId) + '">' +
            '<quantity-input class="qtyField quantity bundle-kit-card__qty" data-section="' + sectionId + '">' +
              '<button type="button" class="quantity__button qtyBtn minus" name="minus" aria-label="Decrease quantity for ' + escapedTitle + '"><i class="at at-minus-r" aria-hidden="true"></i></button>' +
              '<input class="quantity__input pr_input qty" type="number" name="quantity" id="' + quantityId + '" aria-label="Quantity for ' + escapedTitle + '" data-cart-quantity="0" data-min="' + minQty + '" min="' + minQty + '"' + maxAttr + ' step="' + stepQty + '" value="' + minQty + '">' +
              '<button type="button" class="quantity__button qtyBtn plus" name="plus" aria-label="Increase quantity for ' + escapedTitle + '"><i class="at at-plus-r" aria-hidden="true"></i></button>' +
            '</quantity-input>' +
            '<button type="submit" name="add" class="btn pr_btn product-form__submit bundle-kit-card__submit"' + disabledAttr + ' data-obsolete-soldout="' + product.button_obsolete + '" data-stock-availability="' + escapeHtml(product.button_stock_status) + '" data-inv="' + escapeHtml(product.button_inventory) + '" data-victron-warehouse="' + product.button_victron + '">' +
              '<span class="txt">' + label + '</span>' +
              '<div class="btn_spinner hidden"><i class="at at-circle-notch-r at-spin"></i></div>' +
            '</button>' +
          '</form>' +
        '</product-form>' +
      '</div>';
  }

  function prefetch(trigger, options) {
    if (!trigger) return Promise.resolve();
    if (trigger.__bundleKitsPrefetchPromise) return trigger.__bundleKitsPrefetchPromise;
    if (trigger.__bundleKitsPrefetched) return Promise.resolve();

    var items = normalizeBundleItems(trigger);
    if (!items.length) return Promise.resolve();

    trigger.__bundleKitsPrefetchPromise = resolveProductsForTrigger(trigger, items, options)
      .then(function () {
        var latestItems = normalizeBundleItems(trigger);
        var targetItems = latestItems.length ? latestItems : items;
        var productsReady = bundleProductsAreReady(targetItems);

        if (productsReady) {
          trigger.__bundleKitsPrefetched = true;
        }
      })
      .catch(function () {
        trigger.__bundleKitsPrefetched = false;
      })
      .finally(function () {
        trigger.__bundleKitsPrefetchPromise = null;
      });

    return trigger.__bundleKitsPrefetchPromise;
  }

  function scheduleIntentIdle(callback, timeout) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(callback, { timeout: timeout || 1600 });
    } else {
      window.setTimeout(callback, 0);
    }
  }

  function scheduleIntentPrefetchQueue() {
    if (intentPrefetchQueueScheduled || intentPrefetchRunning || !intentPrefetchQueue.length) return;
    intentPrefetchQueueScheduled = true;
    scheduleIntentIdle(function () {
      intentPrefetchQueueScheduled = false;
      drainIntentPrefetchQueue();
    }, 1200);
  }

  function drainIntentPrefetchQueue() {
    if (intentPrefetchRunning) return;

    var trigger = null;
    while (intentPrefetchQueue.length && !trigger) {
      var candidate = intentPrefetchQueue.shift();
      candidate.__bundleKitsIntentQueued = false;
      if (document.documentElement.contains(candidate) && !candidate.__bundleKitsPrefetched) {
        trigger = candidate;
      }
    }

    if (!trigger) return;

    intentPrefetchRunning = true;
    prefetch(trigger, { priority: 'low' })
      .finally(function () {
        intentPrefetchRunning = false;
        scheduleIntentPrefetchQueue();
      });
  }

  function enqueueIntentPrefetch(trigger) {
    if (!trigger || trigger.__bundleKitsPrefetched || trigger.__bundleKitsPrefetchPromise || trigger.__bundleKitsIntentQueued) return;
    if (!normalizeBundleItems(trigger).length) return;

    trigger.__bundleKitsIntentQueued = true;
    intentPrefetchQueue.push(trigger);
    scheduleIntentPrefetchQueue();
  }

  function isTriggerNearViewport(trigger) {
    if (!trigger || typeof trigger.getBoundingClientRect !== 'function') return false;
    var rect = trigger.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    return rect.bottom >= -800 && rect.top <= viewportHeight + 800;
  }

  function queueNearViewportTriggers() {
    intentViewportScanScheduled = false;
    Array.prototype.forEach.call(document.querySelectorAll(triggerSelector), function (trigger) {
      if (isTriggerNearViewport(trigger)) enqueueIntentPrefetch(trigger);
    });
  }

  function scheduleNearViewportScan() {
    if (intentViewportScanScheduled) return;
    intentViewportScanScheduled = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(queueNearViewportTriggers);
    } else {
      window.setTimeout(queueNearViewportTriggers, 16);
    }
  }

  function observeIntentTriggers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var triggers = Array.prototype.slice.call(scope.querySelectorAll(triggerSelector));
    if (scope.matches && scope.matches(triggerSelector)) {
      triggers.unshift(scope);
    }

    triggers.forEach(function (trigger) {
      if (trigger.__bundleKitsIntentObserved) return;
      trigger.__bundleKitsIntentObserved = true;
      if (intentPrefetchObserver) {
        intentPrefetchObserver.observe(trigger);
      } else if (isTriggerNearViewport(trigger)) {
        enqueueIntentPrefetch(trigger);
      }
    });
  }

  function startIntentPrefetch() {
    if (intentPrefetchStarted) return;
    intentPrefetchStarted = true;

    if (window.IntersectionObserver) {
      intentPrefetchObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          intentPrefetchObserver.unobserve(entry.target);
          enqueueIntentPrefetch(entry.target);
        });
      }, { rootMargin: '800px 0px', threshold: 0 });
    } else {
      window.addEventListener('scroll', scheduleNearViewportScan, { passive: true });
      window.addEventListener('resize', scheduleNearViewportScan, { passive: true });
    }

    observeIntentTriggers(document);

    if (window.MutationObserver && document.body) {
      intentMutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node && node.nodeType === 1) observeIntentTriggers(node);
          });
        });
      });
      intentMutationObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  var intentEventNames = ['pointerdown', 'wheel', 'touchstart', 'keydown'];

  function disarmIntentPrefetch() {
    intentEventNames.forEach(function (eventName) {
      document.removeEventListener(eventName, onFirstUserIntent, true);
    });
  }

  function onFirstUserIntent(event) {
    if (event && event.isTrusted === false) return;
    disarmIntentPrefetch();
    window.setTimeout(function () {
      scheduleIntentIdle(startIntentPrefetch, 1600);
    }, 1000);
  }

  function armIntentPrefetch() {
    intentEventNames.forEach(function (eventName) {
      document.addEventListener(eventName, onFirstUserIntent, {
        capture: true,
        passive: eventName !== 'keydown'
      });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openModal(trigger);
  }, true);

  document.addEventListener('click', function (event) {
    var quickView = event.target && event.target.closest ? event.target.closest('.bundle-kit-card__quick-view') : null;
    if (quickView) suspendModalForQuickView();
  }, true);

  document.addEventListener('quick-view:closed', restoreModalAfterQuickView);
  document.addEventListener('quick-view:error', restoreModalAfterQuickView);

  document.addEventListener('mouseover', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
    if (!trigger) return;
    if (event.relatedTarget && trigger.contains(event.relatedTarget)) return;
    if (hoverTimers) {
      var timer = setTimeout(function () { prefetch(trigger); }, 140);
      hoverTimers.set(trigger, timer);
    } else {
      prefetch(trigger);
    }
  });

  document.addEventListener('mouseout', function (event) {
    if (!hoverTimers) return;
    var trigger = event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
    if (!trigger) return;
    if (event.relatedTarget && trigger.contains(event.relatedTarget)) return;
    var timer = hoverTimers.get(trigger);
    if (timer) clearTimeout(timer);
  });

  document.addEventListener('focusin', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
    if (trigger) prefetch(trigger);
  });

  document.addEventListener('touchstart', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
    if (trigger) prefetch(trigger);
  }, { passive: true });

  if (document.readyState === 'complete') {
    armIntentPrefetch();
  } else {
    window.addEventListener('load', armIntentPrefetch, { once: true });
  }

})();

// Pause autoplay while sliders are well outside the viewport.
document.addEventListener('DOMContentLoaded', function() {
    if (!window.IntersectionObserver) return;

    var sliderObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var instance = entry.target.themeSwiper;
            if (!instance || !instance.autoplay) return;
            if (entry.isIntersecting && instance.params.autoplay && instance.params.autoplay.enabled) instance.autoplay.start();
            else if (!entry.isIntersecting) instance.autoplay.stop();
        });
    }, { rootMargin: '250px 0px' });

    function observeSliders(scope) {
        var root = scope || document;
        var sliders = root.querySelectorAll ? root.querySelectorAll('[data-theme-swiper]:not([data-theme-swiper-observed])') : [];
        sliders.forEach(function(slider) {
            sliderObserver.observe(slider);
            slider.setAttribute('data-theme-swiper-observed', 'true');
        });
    }

    observeSliders(document);
    document.addEventListener('shopify:section:load', function(event){ observeSliders(event.target); });
    document.addEventListener('theme:swiper:init', function(event){ observeSliders(event.target.parentElement || document); });
});
